webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_TABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_TABLE_DATAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_TABLE_PAGINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_TABLE_PAGINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_TABLE_QUERIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_INVOICE_HELPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_INVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_ALL_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_ALL_ADMINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_ALL_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_PERMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_PERMISSION_HELPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_ALL_CARRIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_ALL_CARRIERS_ZH_COD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_CROSS_CHECKS_HELPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_COMPARE_HELPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_COMPARE_FEE_HELPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_RECEIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_USER; });
/* unused harmony export SHIPMENT_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_SHIPMENT_HELPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_SHIPMENT_STATUS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_SHIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NEW_SHIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_ALL_AFFILIATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_AFFILIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_BANKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_ALL_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ALL_DISTRICT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_DISTRICT_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_DISTRICT_FROM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_LOADED_DISTRICT_BY_CITY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ALL_WARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_WARD_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_WARD_FROM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_LOADED_WARD_BY_DISTRICT_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_LOADED_WARD_BY_DISTRICT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_WARD; });

var SET_TABLE_DATA = 'SET_TABLE_DATA';
var SET_TABLE_DATAS = 'SET_TABLE_DATAS';
var SET_TABLE_PAGINATION = 'SET_TABLE_PAGINATION';
var SET_TABLE_PAGINATIONS = 'SET_TABLE_PAGINATIONS';
var SET_TABLE_QUERIES = 'SET_TABLE_QUERIES';

var GET_INVOICE_HELPERS = 'GET_INVOICE_HELPERS';
var SET_INVOICE = 'SET_INVOICE';

var GET_ALL_ROLES = 'GET_ALL_ROLES';
var GET_ROLE = 'GET_ROLE';

var GET_ALL_ADMINS = 'GET_ALL_ADMINS';

var GET_ALL_PERMISSIONS = 'GET_ALL_PERMISSIONS';
var SET_PERMISSION = 'SET_PERMISSION';
var SET_PERMISSION_HELPERS = 'SET_PERMISSION_HELPERS';

var GET_ALL_CARRIERS = 'GET_ALL_CARRIERS';
var GET_ALL_CARRIERS_ZH_COD = 'GET_ALL_CARRIERS_ZH_COD';

var GET_CROSS_CHECKS_HELPERS = 'GET_CROSS_CHECKS_HELPERS';
var GET_COMPARE_HELPERS = 'GET_COMPARE_HELPERS';
var GET_COMPARE_FEE_HELPERS = 'GET_COMPARE_FEE_HELPERS';

var SET_RECEIPT = 'SET_RECEIPT';

var GET_ACCOUNT = 'GET_ACCOUNT';

var GET_USER = 'GET_USER';

var SHIPMENT_FAIL = 'SHIPMENT_FAIL';
var GET_SHIPMENT_HELPERS = 'GET_SHIPMENT_HELPERS';
var GET_SHIPMENT_STATUS_FILTERS = 'GET_SHIPMENT_STATUS_FILTERS';
var SET_SHIPMENT = 'SET_SHIPMENT';
var NEW_SHIPMENT = 'NEW_SHIPMENT';

var GET_ALL_AFFILIATES = 'GET_ALL_AFFILIATES';
var GET_AFFILIATE = 'GET_AFFILIATE';

var SET_BANKS = 'SET_BANKS';

var GET_ALL_CITY = 'GET_ALL_CITY';

var GET_ALL_DISTRICT = 'GET_ALL_DISTRICT';
var GET_DISTRICT_TO = 'GET_DISTRICT_TO';
var GET_DISTRICT_FROM = 'GET_DISTRICT_FROM';
var SET_LOADED_DISTRICT_BY_CITY_CODE = 'SET_LOADED_DISTRICT_BY_CITY_CODE';

var GET_ALL_WARD = 'GET_ALL_WARD';
var GET_WARD_TO = 'GET_WARD_TO';
var GET_WARD_FROM = 'GET_WARD_FROM';
var SET_LOADED_WARD_BY_DISTRICT_CODE = 'SET_LOADED_WARD_BY_DISTRICT_CODE';
var SET_LOADED_WARD_BY_DISTRICT_ID = 'SET_LOADED_WARD_BY_DISTRICT_ID';
var GET_WARD = 'GET_DISTRICT';

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_routes__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_routes__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_invoice_routes__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_receipt_routes__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_user_routes__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_role_routes__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_permission_routes__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_compare_routes__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_saler_routes__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_permissiondenied_routes__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_affiliate_routes__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_salerConfig_routes__ = __webpack_require__(412);



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["concat"])(__WEBPACK_IMPORTED_MODULE_4__components_account_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_dashboard_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_invoice_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_user_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__components_role_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_receipt_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__components_permission_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__components_compare_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13_components_permissiondenied_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__components_saler_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_components_affiliate_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15_components_salerConfig_routes__["a" /* default */])
}));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store__ = __webpack_require__(42);


var requireAuth = function requireAuth(to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_0_local_storage___default.a.get('authen');
  if (!token) {
    __WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].commit('setLogout');
    next({
      path: '/login'
    });
  } else {
    next();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  requireAuth: requireAuth
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateUrl */
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNumber;
/* unused harmony export removeComma */
/* unused harmony export removeDot */
/* unused harmony export removeString */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeAccents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function generateUrl(url, key, params) {
  if (url.indexOf('?') > -1) {
    url = url + '&' + key + '=' + params;
  } else {
    url = url + '?' + key + '=' + params;
  }
  return url;
}

function formatNumber(number, places, thousand, decimal) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  thousand = thousand || ',';
  decimal = decimal || '.';
  var negative = number < 0 ? '-' : '';
  var i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '';
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
}

function removeComma(number) {
  return number.replace(/,/g, '');
}

function removeDot(number) {
  return number.replace(/./g, '');
}

function removeString(str) {
  return str.replace(/\D/g, '');
}

function formatDate(value) {
  var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format(formatStr);
  }
  return '';
}

function removeAccents(str) {
  var AccentsMap = ['aàảãáạăằẳẵắặâầẩẫấậ', 'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ', 'dđ', 'DĐ', 'eèẻẽéẹêềểễếệ', 'EÈẺẼÉẸÊỀỂỄẾỆ', 'iìỉĩíị', 'IÌỈĨÍỊ', 'oòỏõóọôồổỗốộơờởỡớợ', 'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ', 'uùủũúụưừửữứự', 'UÙỦŨÚỤƯỪỬỮỨỰ', 'yỳỷỹýỵ', 'YỲỶỸÝỴ'];
  for (var i = 0; i < AccentsMap.length; i++) {
    var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
    var char = AccentsMap[i][0];
    str = str.replace(re, char);
  }
  return str;
}

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAllInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getTotalDebt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getTotalDebtByFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return createInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return deleteInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return confirmInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return confirmAllInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return paymentInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hardPaymentInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return returnInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return exportExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resendEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return exportAllInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return paymentAllInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return makePaymentExtra; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportCodListing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return exportFeeListing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exportCompareFeeListing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllInvoice = function getAllInvoice(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/invoices', {
    params: params
  });
};

var getInvoice = function getInvoice(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/invoices/' + id, {
    params: params
  });
};

var getTotalDebt = function getTotalDebt(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/invoices/total-debt', {
    params: params
  });
};

var getTotalDebtByFilter = function getTotalDebtByFilter(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/invoices/total-debt-filters', {
    params: params
  });
};

var createInvoice = function createInvoice(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/invoices', data);
};

var editInvoice = function editInvoice(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/invoices/' + id, data);
};

var deleteInvoice = function deleteInvoice(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/invoices/' + id);
};

var getHelpers = function getHelpers() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/helpers/invoices');
};

var confirmInvoice = function confirmInvoice(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('invoices/' + id + '/confirm');
};

var confirmAllInvoice = function confirmAllInvoice(ids) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('invoices/confirm_all', ids);
};

var paymentInvoice = function paymentInvoice(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('invoices/' + id + '/payment');
};

var hardPaymentInvoice = function hardPaymentInvoice(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('invoices/' + id + '/hard-payment');
};

var returnInvoice = function returnInvoice(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('invoices/' + id + '/return', data);
};

var exportExcel = function exportExcel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('invoices/export-excel', {
    params: params
  });
};

var resendEmail = function resendEmail(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('invoices/' + id + '/resend-email');
};

var exportAllInvoice = function exportAllInvoice(ids) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('invoices/export_all', ids);
};

var paymentAllInvoice = function paymentAllInvoice(ids) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('invoices/payment_all', ids);
};

var makePaymentExtra = function makePaymentExtra(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('invoices/' + id + '/payment-extra', data);
};

var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __webpack_require__.i({"NODE_ENV":"production","API_URI":"https://api.1express.vn/api/v1","API_BASE_URI":"https://api.1express.vn","CLIENT_ID":1,"PUSHER_KEY":"0486f414b049a9f15b5a","PUSHER_CLUSTER":"MT1","GOOGLE_APP_KEY":"AIzaSyCuRr7HS4n-48-WsIa1s-x0pqQhXrrK4cM","CLIENT_SECRET":"D4SF4QcLzPmIj2ruq40In094Jc8bKcJXLq58xrF3"}).EXPORT_LISTING_ZH_URL,
  timeout: 1000 * 60 * 2,
  headers: {
    'Authorization': 'Bearer ' + __webpack_require__.i({"NODE_ENV":"production","API_URI":"https://api.1express.vn/api/v1","API_BASE_URI":"https://api.1express.vn","CLIENT_ID":1,"PUSHER_KEY":"0486f414b049a9f15b5a","PUSHER_CLUSTER":"MT1","GOOGLE_APP_KEY":"AIzaSyCuRr7HS4n-48-WsIa1s-x0pqQhXrrK4cM","CLIENT_SECRET":"D4SF4QcLzPmIj2ruq40In094Jc8bKcJXLq58xrF3"}).EXPORT_LISTING_ZH_KEY
  }
});

var exportCodListing = function exportCodListing(params) {
  return axiosInstance.get('/shipments/export-cod-listing', {
    params: params,
    responseType: 'blob'
  });
};

var exportFeeListing = function exportFeeListing(params) {
  return axiosInstance.get('/shipments/export-fee-listing', {
    params: params,
    responseType: 'blob'
  });
};

var exportCompareFeeListing = function exportCompareFeeListing(params) {
  return axiosInstance.get('/shipments/export-compare-fee-listing', {
    params: params,
    responseType: 'blob'
  });
};

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getCompareHeppers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCompareFeeHeppers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return createCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ApplyCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UpdateCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DeleteCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeErrorShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resyncingCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return verifyCrossCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateFeeByCarrier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateCrossCheckFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateCrossCheckFee1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateCompareFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteCompareFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return exportExcelFee; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getCompareHeppers = function getCompareHeppers() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('helpers/compares');
};

var getCompareFeeHeppers = function getCompareFeeHeppers() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('helpers/compare-fees');
};

var getCrossCheck = function getCrossCheck(id, params) {
  var remoteUrl = 'cross-checks/' + id + '?include=finance';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var createCrossCheck = function createCrossCheck(data) {
  var remoteUrl = 'cross-checks';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(remoteUrl, data);
};

var updateCompare = function updateCompare(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('compares/' + id, data);
};

var ApplyCrossCheck = function ApplyCrossCheck(id) {
  var remoteUrl = 'cross-checks/' + id + '/confirm';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(remoteUrl);
};

var UpdateCrossCheck = function UpdateCrossCheck(id, data) {
  var remoteUrl = 'cross-checks/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(remoteUrl, data);
};

var DeleteCrossCheck = function DeleteCrossCheck(id) {
  var remoteUrl = 'cross-checks/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(remoteUrl);
};

var exportExcel = function exportExcel(params) {
  var remoteUrl = 'compares/export-excel';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var deleteCompare = function deleteCompare(id) {
  var remoteUrl = 'compares/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(remoteUrl);
};

var updateCrossCheck = function updateCrossCheck(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/update/' + id, data);
};

var removeErrorShipment = function removeErrorShipment(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/remove-error-shipment', data);
};

var resyncingCode = function resyncingCode(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/resync', data);
};

var updateWeight = function updateWeight(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/update-weight', data);
};

var verifyCrossCheck = function verifyCrossCheck(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/verify', data);
};

var updateFeeByCarrier = function updateFeeByCarrier(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/update-fee-by-carrier', null, { params: params });
};

var updateCrossCheckFee = function updateCrossCheckFee(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/compare-fee', data);
};

var updateCrossCheckFee1 = function updateCrossCheckFee1(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('cross-checks/' + id + '/compare-fee-1', data);
};

var updateCompareFee = function updateCompareFee(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('compare-fees/' + id, data);
};

var deleteCompareFee = function deleteCompareFee(id) {
  var remoteUrl = 'compare-fees/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(remoteUrl);
};

var exportExcelFee = function exportExcelFee(params) {
  var remoteUrl = 'compare-fees/export-excel';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAllReceipt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmReceipt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllReceipt = function getAllReceipt(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/receipts', { params: params });
};

var getReceipt = function getReceipt(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/receipts/' + id, { params: params });
};

var createReceipt = function createReceipt(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/receipts', data);
};

var editReceipt = function editReceipt(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/receipts/' + id, data);
};

var deleteReceipt = function deleteReceipt(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/receipts/' + id);
};

var confirmReceipt = function confirmReceipt(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('receipts/' + id + '/confirm');
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shipmentStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shipmentStatusesBg; });
var shipmentStatuses = {
  900: 'text-grey',
  901: 'text-brown',
  902: 'text-yellow',
  903: 'text-yellow',
  904: 'text-blue',
  905: 'text-green',
  906: 'text-red',
  907: 'text-orange',
  908: 'text-purple',
  909: 'text-teal',
  910: 'text-teal',
  911: 'text-green',
  912: 'text-olive',
  913: 'text-green',
  914: 'text-red',
  1000: 'text-black',
  915: 'text-orange',
  917: 'text-red',
  '-1': 'text-blue'
};

var shipmentStatusesBg = {
  900: '#A0A0A0',
  901: '#a5673f',
  902: '#FFD700',
  903: '#FFD700',
  904: '#0E6EB8',
  905: '#32CD32',
  906: '#db2828',
  907: '#FE9A76',
  908: '#B413EC',
  909: '#008080',
  910: '#008080',
  911: '#32CD32',
  912: '#b5cc18',
  913: '#32CD32',
  914: '#db2828',
  1000: '#000000',
  915: '#FE9A76',
  916: '#32CD32',
  917: '#db2828'
};

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_libs_ls__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_gsTable_store__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_account_store__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_invoice_store__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_receipt_store__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_user_store__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_role_store__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_admin_store__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_permission_store__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_compare_store__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_carrier_store__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shipment_store__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_affiliate_store__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_bank_store__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_city_store__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_district_store__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_ward_store__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_router__ = __webpack_require__(19);
























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  strict: debug,
  state: {
    loading: false,
    logged: false,
    loadingInstance: undefined,
    debugQuery: []
  },
  actions: {
    showNotify: function showNotify(_ref, message) {
      var commit = _ref.commit;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Notification"])({
        title: message.title,
        message: message.body,
        type: message.type ? message.type : 'success'
      });
    },
    logged: function logged(_ref2, token) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_4_src_libs_ls__["a" /* default */].set('authen', token);
      commit('setLogged');
    },
    logout: function logout(_ref3) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_4_src_libs_ls__["a" /* default */].remove('authen');
      commit('setLogout');
    },
    toggleLoadding: function toggleLoadding(_ref4) {
      var commit = _ref4.commit;
      var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      commit('loading', loading);
    },
    checkLogged: function checkLogged(_ref5) {
      var commit = _ref5.commit;

      if (__WEBPACK_IMPORTED_MODULE_4_src_libs_ls__["a" /* default */].get('authen')) {
        commit('setLogged');
      } else {
        __WEBPACK_IMPORTED_MODULE_21_src_router__["a" /* default */].push('/login');
      }
    }
  },
  mutations: {
    loading: function loading(state, _loading) {
      state.loading = _loading;
    },
    setLogged: function setLogged(state) {
      state.logged = true;
    },
    setLogout: function setLogout(state) {
      state.logged = false;
    },
    SET_DEBUG: function SET_DEBUG(state, queries) {
      state.debugQuery.push(queries);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    isLogged: function isLogged(state) {
      return state.logged;
    },
    debugQuery: function debugQuery(state) {
      return state.debugQuery;
    }
  },
  modules: {
    gsTable: __WEBPACK_IMPORTED_MODULE_5_components_app_gsTable_store__["a" /* default */],
    account: __WEBPACK_IMPORTED_MODULE_6_components_account_store__["a" /* default */],
    invoice: __WEBPACK_IMPORTED_MODULE_7_components_invoice_store__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_9_components_user_store__["a" /* default */],
    role: __WEBPACK_IMPORTED_MODULE_10_components_role_store__["a" /* default */],
    admin: __WEBPACK_IMPORTED_MODULE_11_components_admin_store__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_12_components_permission_store__["a" /* default */],
    compare: __WEBPACK_IMPORTED_MODULE_13_components_compare_store__["a" /* default */],
    carrier: __WEBPACK_IMPORTED_MODULE_14_components_carrier_store__["a" /* default */],
    receipt: __WEBPACK_IMPORTED_MODULE_8_components_receipt_store__["a" /* default */],
    shipment: __WEBPACK_IMPORTED_MODULE_15_components_shipment_store__["a" /* default */],
    affiliate: __WEBPACK_IMPORTED_MODULE_16_components_affiliate_store__["a" /* default */],
    bank: __WEBPACK_IMPORTED_MODULE_17_components_bank_store__["a" /* default */],
    city: __WEBPACK_IMPORTED_MODULE_18_components_city_store__["a" /* default */],
    district: __WEBPACK_IMPORTED_MODULE_19_components_district_store__["a" /* default */],
    ward: __WEBPACK_IMPORTED_MODULE_20_components_ward_store__["a" /* default */]
  },
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()()] : []
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPersonlInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateStatusOnline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var login = function login(info) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login', info);
};

var changePassword = function changePassword(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('account/change-password', data);
};

var getPersonlInformation = function getPersonlInformation() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('account');
};

var updateStatusOnline = function updateStatusOnline(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('account/update-status-online', data);
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAllRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteRole; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllRoles = function getAllRoles(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/roles', { params: params });
};

var getRole = function getRole(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/roles/' + id, { params: params });
};

var createRole = function createRole(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/roles', data);
};

var editRole = function editRole(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/roles/' + id, data);
};

var deleteRole = function deleteRole(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/roles/' + id);
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getUser = function getUser(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/clients/' + id, { params: params });
};

var createUser = function createUser(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/clients', data);
};

var editUser = function editUser(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/clients/' + id, data);
};

var deleteUser = function deleteUser(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/clients/' + id);
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CROSS_CHECK_TYPE; });
var CROSS_CHECK_TYPE = {
  COD: 1,
  FEE: 2,
  COMPARE_FEE: 3,
  FEE1: 4
};

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var getAllClient = function getAllClient(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('clients', {
    params: params
  });
};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAllPermissions; });
/* unused harmony export getPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPermission; });
/* unused harmony export editPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAllPermissionHelpers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllPermissions = function getAllPermissions(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/permissions/by-role', { params: params });
};

var getPermission = function getPermission(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/permissions/' + id, { params: params });
};

var createPermission = function createPermission(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/permissions', data);
};

var editPermission = function editPermission(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/permissions/' + id, data);
};

var deletePermission = function deletePermission(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/permissions/' + id);
};

var getAllPermissionHelpers = function getAllPermissionHelpers() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/helpers/permissions');
};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return compareStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return compareStatusesBg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listtingComparesStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listtingComparesStatusBg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return listtingComparesError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return listtingComparesErrorBg; });
var compareStatuses = {
  0: 'text-red',
  1: 'text-orange',
  2: 'text-green'
};

var compareStatusesBg = {
  0: '#db2828',
  1: '#FE9A76',
  2: '#32CD32'
};

var listtingComparesStatus = {
  0: 'text-grey',
  1: 'text-orange',
  2: 'text-blue',
  3: 'text-purple',
  4: 'text-green'
};

var listtingComparesStatusBg = {
  0: '#A0A0A0',
  1: '#FE9A76',
  2: '#0E6EB8',
  3: '#B413EC',
  4: '#32CD32'
};

var listtingComparesError = {
  1: 'text-red',
  2: 'text-red',
  3: 'text-red',
  4: 'text-red',
  5: 'text-red',
  6: 'text-red',
  7: 'text-red'
};

var listtingComparesErrorBg = {
  1: '#db2828',
  2: '#db2828',
  3: '#db2828',
  4: '#db2828',
  5: '#db2828',
  6: '#db2828',
  7: '#db2828'
};

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["number"] = number;
/* harmony export (immutable) */ __webpack_exports__["vnd"] = vnd;
/* harmony export (immutable) */ __webpack_exports__["gam"] = gam;
/* harmony export (immutable) */ __webpack_exports__["cm"] = cm;
/* harmony export (immutable) */ __webpack_exports__["percent"] = percent;
/* harmony export (immutable) */ __webpack_exports__["svnd"] = svnd;
function number(number, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal;
  return formatNumber(number, decimal);
}

function vnd(money, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal;
  return formatNumber(money, decimal) + ' đ';
}

function gam(gam, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal;
  return formatNumber(gam, decimal) + ' g';
}

function cm(cm, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal;
  return formatNumber(cm, decimal) + ' cm';
}

function percent(percent, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal;
  return formatNumber(percent, decimal) + ' %';
}

function svnd(money, decimal) {
  decimal = typeof decimal === 'undefined' ? 2 : decimal;
  return nFormatter(money, decimal);
}

function nFormatter(num, digits) {
  var si = [{ value: 1, symbol: '' }, { value: 1E3, symbol: 'k' }];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return formatNumber((num / si[i].value).toFixed(digits).replace(rx, '$1'), digits) + si[i].symbol;
}

function formatNumber(number, places, thousand, decimal) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  thousand = thousand || ',';
  decimal = decimal || '.';
  var negative = number < 0 ? '-' : '';
  var i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '';
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
}

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllAdmins; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllAdmins = function getAllAdmins(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/clients', { params: params });
};

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllAffiliates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAffiliate; });
/* unused harmony export createAffiliate */
/* unused harmony export editAffiliate */
/* unused harmony export deleteAffiliate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmRequestPayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllAffiliates = function getAllAffiliates(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/affiliates', { params: params });
};

var getAffiliate = function getAffiliate(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/affiliates/' + id, { params: params });
};

var createAffiliate = function createAffiliate(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/affiliates', data);
};

var editAffiliate = function editAffiliate(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/affiliates/' + id, data);
};

var deleteAffiliate = function deleteAffiliate(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/affiliates/' + id);
};

var confirmRequestPayment = function confirmRequestPayment(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/request-payments/' + id + '/payment');
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCrossChecksHeppers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getShipmentHeppers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getCrossChecksHeppers = function getCrossChecksHeppers(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('helpers/cross-checks');
};

var getShipmentHeppers = function getShipmentHeppers(params) {
  var remoteUrl = '/helpers/shipments';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFromUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var getFromUrl = function getFromUrl(url, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
    params: params
  });
};

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSysConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfigBySaler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeSysConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeConfigBySaler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetSalerConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getSysConfig = function getSysConfig() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('settings/saller');
};

var getConfigBySaler = function getConfigBySaler(salerId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('settings/saller/by-saler/' + salerId);
};

var changeSysConfig = function changeSysConfig(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('settings/saller', data);
};

var changeConfigBySaler = function changeConfigBySaler(salerId, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('settings/saller/by-saler/' + salerId, data);
};

var resetSalerConfig = function resetSalerConfig(salerId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('settings/saller/reset-config/' + salerId);
};

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllShipment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var getAllShipment = function getAllShipment(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('shipments', {
    params: params
  });
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAllShipment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return exportExcel; });
/* unused harmony export getFeeList */
/* unused harmony export getCoinFeeList */
/* unused harmony export addShipment */
/* unused harmony export deleteShipment */
/* unused harmony export updatePriceShipment */
/* unused harmony export editShipment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilter; });
/* unused harmony export sendCarrier */
/* unused harmony export login */
/* unused harmony export updateStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hardUpdateShipment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllShipment = function getAllShipment(params) {
  var remoteUrl = 'shipments';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var getShipment = function getShipment(id, params) {
  var remoteUrl = 'shipments/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var exportExcel = function exportExcel(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('shipments/export-excel', { params: params });
};

var getFeeList = function getFeeList(shipment) {
  var remoteUrl = 'fees-list';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(remoteUrl, shipment);
};

var getCoinFeeList = function getCoinFeeList(shipment) {
  var remoteUrl = 'fees-list-by-carrier';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(remoteUrl, shipment);
};

var addShipment = function addShipment(shipment) {
  var remoteUrl = 'shipments';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(remoteUrl, shipment);
};

var deleteShipment = function deleteShipment(id) {
  var remoteUrl = 'shipments/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(remoteUrl);
};

var updatePriceShipment = function updatePriceShipment(id, shipment) {
  var remoteUrl = 'shipments/' + id + '/update-price';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(remoteUrl, shipment).then(function (response) {
    return response.json();
  }, function (errors) {
    return errors.json();
  });
};

var editShipment = function editShipment(id, shipment, params) {
  var remoteUrl = 'shipments/' + id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(remoteUrl, shipment, { params: params });
};

var getFilter = function getFilter(params) {
  var remoteUrl = 'shipments/get-filter-info';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var sendCarrier = function sendCarrier(id, params) {
  var remoteUrl = 'shipments/' + id + '/send-carrier';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var login = function login() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'post',
    url: '/login',
    params: {
      username: 'nguyentranhoan13@gmail.com',
      password: '111111'
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    }
  });
};

var updateStatus = function updateStatus(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('shipments/' + id + '/update-status', data);
};

var hardUpdateShipment = function hardUpdateShipment(id, shipment, params) {
  var remoteUrl = 'shipments/' + id + '/hard-update';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(remoteUrl, shipment, { params: params });
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_api_client__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_shipment__ = __webpack_require__(106);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      submitting: false,
      localInvoice: {
        id: 0,
        kind: '0',
        client_id: 0,
        shipments: [],
        total_amount: 0,
        debt: 0,
        description: ''
      },
      suggettionReceiver: {},
      fetchReceiver: false,
      listReceiver: [],
      suggettionShipment: {},
      fetchShipment: false,
      listShipment: [],
      shipmentAdded: [],
      rules: {
        kind: [{ required: true, message: 'Vui lòng chọn loại phiếu', trigger: 'change' }],
        client_id: [{ required: true, message: 'Vui lòng chọn người nhận', trigger: 'change' }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('invoice', ['invoiceHelpers'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('invoice', ['getInvoiceHelpers']), {
    selectReceiver: function selectReceiver(q) {
      var _this = this;

      if (q) {
        this.fetchReceiver = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_client__["a" /* getAllClient */])({ limit: 10, q: q }).then(function (response) {
          if (response.code === 200) {
            _this.listReceiver = response.data;
            _this.fetchReceiver = false;
          }
        });
      }
    },
    selectSuggettionReceiver: function selectSuggettionReceiver() {
      this.localInvoice.client_id = this.suggettionReceiver.id;
      this.listReceiver = [];
    },
    selectShipment: function selectShipment(q) {
      var _this2 = this;

      if (q) {
        this.fetchShipment = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_api_shipment__["a" /* getAllShipment */])({ limit: 10, q: q, include: 'receiver,picker', client_id: this.localInvoice.client_id }).then(function (response) {
          if (response.code === 200) {
            _this2.listShipment = response.data;
            _this2.fetchShipment = false;
          }
        });
      }
    },
    selectSuggettionShipment: function selectSuggettionShipment() {
      if (this.localInvoice.shipments.indexOf(this.suggettionShipment.id) < 0) {
        this.localInvoice.shipments.push(this.suggettionShipment.id);
        this.shipmentAdded.push(this.suggettionShipment);
      }
      this.listShipment = [];
    },
    removeShipment: function removeShipment(shipment) {
      var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(this.shipmentAdded, shipment);
      var sindex = this.localInvoice.shipments.indexOf(shipment.id);
      this.shipmentAdded.splice(index, 1);
      this.localInvoice.shipments.splice(sindex, 1);
    },
    removeZero: function removeZero(key) {
      if (parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.localInvoice, key)) === 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.localInvoice, key, '');
      }
    },
    addZero: function addZero(key) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.localInvoice, key) === '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.localInvoice, key, 0);
      }
    },
    newInvoice: function newInvoice() {
      this.localInvoice = {
        id: 0,
        kind: '0',
        client_id: 0,
        shipments: [],
        total_amount: 0,
        debt: 0,
        description: ''
      };
    }
  }),
  mounted: function mounted() {
    this.newInvoice();
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.invoiceHelpers).length) {
      this.getInvoiceHelpers();
    }
  },

  watch: {
    localInvoice: {
      handler: function handler(value) {
        if (this.watching) {
          this.changedData = true;
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_shipment__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_client__ = __webpack_require__(62);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      submitting: false,
      localReceipt: {
        id: 0,
        shipments: [],
        total_amount: 0,
        description: '',
        client_id: 0
      },
      suggettionReceiver: {},
      fetchReceiver: false,
      listReceiver: [],
      suggettionShipment: {},
      fetchShipment: false,
      listShipment: [],
      shipmentAdded: [],
      rules: {}
    };
  },

  methods: {
    selectReceiver: function selectReceiver(q) {
      var _this = this;

      if (q) {
        this.fetchReceiver = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_client__["a" /* getAllClient */])({ limit: 10, q: q }).then(function (response) {
          if (response.code === 200) {
            _this.listReceiver = response.data;
            _this.fetchReceiver = false;
          }
        });
      }
    },
    selectSuggettionReceiver: function selectSuggettionReceiver() {
      this.localReceipt.client_id = this.suggettionReceiver.id;
      this.listReceiver = [];
    },
    selectShipment: function selectShipment(q) {
      var _this2 = this;

      if (q) {
        this.fetchShipment = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_shipment__["a" /* getAllShipment */])({ limit: 10, q: q, include: 'receiver,picker' }).then(function (response) {
          if (response.code === 200) {
            _this2.listShipment = response.data;
            _this2.fetchShipment = false;
          }
        });
      }
    },
    selectSuggettionShipment: function selectSuggettionShipment() {
      if (this.localReceipt.shipments.indexOf(this.suggettionShipment.id) < 0) {
        this.localReceipt.shipments.push(this.suggettionShipment.id);
        this.shipmentAdded.push(this.suggettionShipment);
      }
      this.listShipment = [];
    },
    removeShipment: function removeShipment(shipment) {
      var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["findIndex"])(this.shipmentAdded, shipment);
      var sindex = this.localReceipt.shipments.indexOf(shipment.id);
      this.shipmentAdded.splice(index, 1);
      this.localReceipt.shipments.splice(sindex, 1);
    },
    removeZero: function removeZero(key) {
      if (parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.localReceipt, key)) === 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.localReceipt, key, '');
      }
    },
    addZero: function addZero(key) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.localReceipt, key) === '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.localReceipt, key, 0);
      }
    },
    newReceipt: function newReceipt() {
      this.localReceipt = {
        id: 0,
        shipments: [],
        total_amount: 0,
        description: '',
        client_id: 0
      };
    }
  },
  mounted: function mounted() {
    this.newReceipt();
  },

  watch: {
    localReceipt: {
      handler: function handler(value) {
        if (this.watching) {
          this.changedData = true;
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_admins__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      submitting: false,
      localRole: {
        name: '',
        display_name: '',
        description: '',
        users: [],
        permissions: []
      },
      suggettionAdmin: {},
      fetchAdmin: false,
      listAdmins: [],
      selectedAdmins: [],
      rules: {
        name: [{ required: true, message: 'Bạn chưa nhập tên role', trigger: 'change' }, { max: 255, message: 'Tên role phải nhỏ hơn 255 ký tự', trigger: 'change' }]
      },
      listPermissions: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('permission', ['permissions'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('permission', ['getAllPermissions']), {
    selectPermission: function selectPermission(e, permission) {
      if (e.target.checked) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"])(this.listPermissions, { id: permission.id }) < 0) {
          this.listPermissions.push({ id: permission.id, name: permission.name });
        }
      } else {
        this.listPermissions.splice(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"])(this.listPermissions, { id: permission.id }), 1);
      }
    },
    checkIsExist: function checkIsExist(permission) {
      var check = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"])(this.listPermissions, { id: permission.id });
      if (check < 0) {
        return false;
      }
      return true;
    },
    selectAdmin: function selectAdmin(q) {
      var _this = this;

      if (q) {
        this.fetchAdmin = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_admins__["a" /* getAllAdmins */])({ limit: 10, q: q }).then(function (response) {
          if (response.code === 200) {
            _this.listAdmins = response.data;
            _this.fetchAdmin = false;
          }
        });
      }
    },
    selectSuggettionAdmin: function selectSuggettionAdmin() {
      if (this.localRole.users.indexOf(this.suggettionAdmin.id) === -1) {
        this.localRole.users.push(this.suggettionAdmin.id);
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"])(this.selectedAdmins, { id: this.suggettionAdmin.id }) === -1) {
        this.selectedAdmins.push(this.suggettionAdmin);
      }
      this.listAdmins = [];
    },
    removeAdmin: function removeAdmin(admin) {
      this.selectedAdmins.splice(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"])(this.selectedAdmins, admin), 1);
      this.localRole.users.splice(this.localRole.users.indexOf(admin.id), 1);
    },
    newRole: function newRole() {
      this.localRole = {
        name: '',
        display_name: '',
        description: '',
        users: [],
        permissions: []
      };
    }
  }),
  mounted: function mounted() {
    this.newRole();
    if (!this.permissions.length) {
      this.getAllPermissions({ limit: -1 });
    }
    this.listPermissions = [];
  },

  watch: {
    localRole: {
      handler: function handler(value) {
        if (this.watching) {
          this.changedData = true;
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    var comfirmPass = function comfirmPass(rule, value, callback) {
      if (value !== _this.localUser.password) {
        callback(new Error('Nhập lại mật khẩu không đúng'));
      } else {
        callback();
      }
    };
    return {
      submitting: false,
      localUser: {
        shop_name: '',
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        shop_name: [{ required: true, message: 'Bạn chưa nhập tên user', trigger: 'change' }, { min: 5, max: 255, message: 'Tên user phải trong khoảng 5 đến 255 ký tự', trigger: 'change' }],
        name: [{ required: true, message: 'Bạn chưa nhập tên user', trigger: 'change' }, { min: 2, max: 255, message: 'Tên user phải trong khoảng 2 đến 255 ký tự', trigger: 'change' }],
        phone: [{ required: true, message: 'Bạn chưa nhập số điện thoại', trigger: 'change' }, { min: 9, max: 12, message: 'Số điện thoại phải trong khoảng 9 đến 12 ký tự', trigger: 'change' }],
        email: [{ required: true, message: 'Bạn chưa nhập email', trigger: 'change' }, { type: 'email', message: 'Email không đúng định dạng', trigger: 'change' }],
        password: [{
          required: true,
          message: 'Mật khẩu không được để trống',
          trigger: 'change'
        }, {
          min: 6,
          max: 32,
          message: 'Mật khẩu phải trong khoảng 6 đến 32 ký tự',
          trigger: 'change'
        }],
        password_confirmation: [{
          required: true,
          message: 'Nhập lại mật khẩu không được để trống',
          trigger: 'change'
        }, {
          validator: comfirmPass,
          trigger: 'change'
        }]
      }
    };
  },

  methods: {
    newUser: function newUser() {
      this.localUser = {
        shop_name: '',
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      };
    }
  },
  mounted: function mounted() {
    this.newUser();
  },

  watch: {
    localUser: {
      handler: function handler(value) {
        if (this.watching) {
          this.changedData = true;
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_store__ = __webpack_require__(42);







__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "https://api.1express.vn/api/v1";
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Accept'] = 'application/json';

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  var token = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('authen', {});
  if (!config.headers.Authorization && token) {
    config.headers.Authorization = 'Bearer ' + token.access_token;
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  if (response.data.queries) {
    __WEBPACK_IMPORTED_MODULE_4_src_store__["a" /* default */].commit('SET_DEBUG', response.data.queries);
  }
  return response.data;
}, function (error) {
  var token = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('authen', {});
  var response = error.response;
  if (response.status === 400 || response.status === 401) {
    if (!(response.config.method === 'post' && response.config.url === response.config.baseURL + '/login')) {
      if (token) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('authen');
      }
      __WEBPACK_IMPORTED_MODULE_4_src_store__["a" /* default */].commit('setLogout');
      __WEBPACK_IMPORTED_MODULE_3_src_router__["a" /* default */].push('/login');
    }
  }
  if (response.status === 403) {
    __WEBPACK_IMPORTED_MODULE_3_src_router__["a" /* default */].push({ name: 'permission-denied' });
  }

  return error.response.data;
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_local_storage__);




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('gsTable', ['dataTables', 'dataPaginations'])),
  methods: {
    reloadGsTable: function reloadGsTable(name) {
      if (typeof this.$refs[name] !== 'undefined') {
        this.$refs[name].$emit('reload-table');
      }
    },
    reloadGsTableAfterRedirect: function reloadGsTableAfterRedirect(route, tableName) {
      route.query = route.query ? route.query : {};
      route.query['reload-gs-table'] = tableName;
      this.$router.push(route);
    },
    listenReloadGsTable: function listenReloadGsTable() {
      var _this = this;

      if (this.$route.query['reload-gs-table']) {
        this.$nextTick(function () {
          _this.reloadGsTable(_this.$route.query['reload-gs-table']);
          var query = {};
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(_this.$route.query, function (value, key) {
            if (key !== 'reload-gs-table') {
              query[key] = value;
            }
          });
          _this.$router.push({ name: _this.$route.name, query: query });
        });
      }
    },
    getSorted: function getSorted(name) {
      if (__WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('sorteds') && __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('sorteds')[name]) {
        return __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('sorteds')[name];
      }
      return {};
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loaddingHelper", function() { return loaddingHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(42);


var loaddingHelper = {
  data: function data() {
    return {
      changedData: false,
      watching: false
    };
  },

  methods: {
    toggleLoadding: function toggleLoadding() {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('toggleLoadding', loading);
    },
    clickToCopy: function clickToCopy() {
      var _this = this;

      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click-copy';

      this.$nextTick(function () {
        document.addEventListener('click', function (e) {
          if (e.target.classList.contains(selector)) {
            e.preventDefault();
            var context = e.target.textContent.trim();

            if (/^[\d{1,3}\\,?\\.?]{1,}\sđ/.test(context)) {
              context = context.replace(/\D/gi, '');
            }
            _this.$copyText(context).then(function (event) {
              e.target.classList.add('click-copied');
              setTimeout(function () {
                e.target.classList.remove('click-copied');
              }, 3000);
            });
          }
        });
      });
    }
  },
  metaInfo: {
    title: 'M.M.S - Hệ thống quản trị dành cho quản lý',
    titleTemplate: '%s | goship.io'
  },
  watch: {
    changedData: function changedData(value) {
      if (value) {
        window.onbeforeunload = function (e) {
          return false;
        };
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this2 = this;

    if (this.changedData) {
      this.$confirm('Dữ liệu bạn đã nhập chưa được lưu. Bạn chắc chắn muốn thoát trang?', 'Cảnh báo', {
        confirmButtonText: 'Thoát',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        next();
      }).catch(function () {
        _this2.watching = true;
      });
    } else {
      next();
    }
  }
};

/***/ }),
/* 282 */,
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  "data-v-bd26cd6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-3e8bda89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllBank; });
/* unused harmony export getBank */
/* unused harmony export newBank */
/* unused harmony export editBank */
/* unused harmony export deleteBank */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllBank = function getAllBank(params) {
  var remoteUrl = 'banks';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var getBank = function getBank(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('banks/' + id, { params: params });
};

var newBank = function newBank(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('banks', data);
};

var editBank = function editBank(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('banks/' + id, data);
};

var deleteBank = function deleteBank(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('banks/' + id);
};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllCarriers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllCarrierZhCod; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllCarriers = function getAllCarriers(params) {
  var remoteUrl = 'carriers';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

var getAllCarrierZhCod = function getAllCarrierZhCod(params) {
  var remoteUrl = 'carriers-allow-export-zh-cod';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllCity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllCity = function getAllCity(params) {
  var remoteUrl = 'cities';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getByStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getByTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getByCarrier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getByCarrierPie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getClientByDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTop10User; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProportion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProportionPie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTotalCod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProfit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTotalShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTotalSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAllUserHasShipments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTop10DistrictTopShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getTop10DistrictTopUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getMatrixShipmentByCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getInterprovinceShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getAllShipmentFromCity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getByStatus = function getByStatus(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('dashboard/shipments/statuses', { params: params });
};

var getByTime = function getByTime(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('dashboard/shipments/statuses/by-time', { params: params });
};

var getByCarrier = function getByCarrier(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/shipments/carriers', { params: params });
};

var getByCarrierPie = function getByCarrierPie(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/shipments/carriers-pie', { params: params });
};

var getClientByDay = function getClientByDay(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('dashboard/clients', { params: params });
};

var getTop10User = function getTop10User(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/top-10-user', { params: params });
};

var getProportion = function getProportion(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/proportion', { params: params });
};

var getProportionPie = function getProportionPie(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/proportion/pie', { params: params });
};

var getTotalCod = function getTotalCod(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/total-cod-amount', { params: params });
};

var getProfit = function getProfit(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/total-profit', { params: params });
};

var getTotalShop = function getTotalShop(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/total-shop', { params: params });
};

var getTotalSource = function getTotalSource(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/total-source', { params: params });
};

var getAllUserHasShipments = function getAllUserHasShipments(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/all-user-has-shipments', { params: params });
};

var getTop10DistrictTopShipment = function getTop10DistrictTopShipment(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/top-10-district-shipment', { params: params });
};

var getTop10DistrictTopUser = function getTop10DistrictTopUser(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/top-10-district-user', { params: params });
};

var getMatrixShipmentByCity = function getMatrixShipmentByCity(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/matrix-shipment-by-city', { params: params });
};

var getInterprovinceShipment = function getInterprovinceShipment(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/interprovince-shipment', { params: params });
};

var getAllShipmentFromCity = function getAllShipmentFromCity(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('statistics/all-shipment-from-city', { params: params });
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllDistrict; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllDistrict = function getAllDistrict(params) {
  var remoteUrl = 'districts';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(remoteUrl, { params: params });
};

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllWard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWard; });
/* unused harmony export getWardKind */
/* unused harmony export addWard */
/* unused harmony export editWard */
/* unused harmony export deleteWard */
/* unused harmony export restoreWard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var getAllWard = function getAllWard(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('wards', { params: params });
};

var getWard = function getWard(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('wards/' + id, { params: params });
};

var getWardKind = function getWardKind(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('helpers/wards', { params: params });
};

var addWard = function addWard(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('wards', data);
};

var editWard = function editWard(id, data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('wards/' + id, data);
};

var deleteWard = function deleteWard(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('wards/' + id);
};

var restoreWard = function restoreWard(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('wards/' + id + '/restore', {});
};

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Login__);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__Login___default.a
}]);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_accounts__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getPersonlInformation = function getPersonlInformation(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_accounts__["d" /* getPersonlInformation */]().then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["H" /* GET_ACCOUNT */], response.data);
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, { root: true });
      dispatch('toggleLoadding', false, { root: true });
    } else {
      dispatch('toggleLoadding', false, { root: true });
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getPersonlInformation: getPersonlInformation
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  accountInfo: function accountInfo(state) {
    return state.accountInfo;
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(342);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["H" /* GET_ACCOUNT */], function (state, accountInfo) {
  state.accountInfo = accountInfo;
}));

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  login: {},
  accountInfo: {}
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_admins__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getAllAdmins = function getAllAdmins(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_admins__["a" /* getAllAdmins */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["B" /* GET_ALL_ADMINS */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["B" /* GET_ALL_ADMINS */], []);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllAdmins: getAllAdmins
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  administrators: function administrators(state) {
    return state.administrators;
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(347);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["B" /* GET_ALL_ADMINS */], function (state, administrators) {
  state.administrators = administrators;
}));

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  administrators: []
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Affiliate__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Affiliate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Affiliate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestPayment__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestPayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RequestPayment__);





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/affiliates',
  name: 'affiliate',
  component: __WEBPACK_IMPORTED_MODULE_1__Affiliate___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/request-payments/:id',
  name: 'request-payments',
  component: __WEBPACK_IMPORTED_MODULE_2__RequestPayment___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_affiliates__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var getAllAffiliates = function getAllAffiliates(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_affiliates__["b" /* getAllAffiliates */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["m" /* GET_ALL_AFFILIATES */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["m" /* GET_ALL_AFFILIATES */], []);
    }
  });
};

var getAffiliate = function getAffiliate(_ref2, configs) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_affiliates__["c" /* getAffiliate */](configs.id, configs.params).then(function (response) {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["n" /* GET_AFFILIATE */], response.data);
        break;
      case 404:
        dispatch('toggleLoadding', false, { root: true });
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Affiliate không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
        __WEBPACK_IMPORTED_MODULE_1_src_router__["a" /* default */].push({ name: 'affiliate' });
        break;
      default:
        dispatch('toggleLoadding', false, { root: true });
    }
  });
};

var setAffiliate = function setAffiliate(_ref3, affiliate) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["n" /* GET_AFFILIATE */], affiliate);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllAffiliates: getAllAffiliates,
  getAffiliate: getAffiliate,
  setAffiliate: setAffiliate
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  affiliates: function affiliates(state) {
    return state.affiliates;
  },
  affiliate: function affiliate(state) {
    return state.affiliate;
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(353);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_ALL_AFFILIATES$G;



/* harmony default export */ __webpack_exports__["a"] = (_GET_ALL_AFFILIATES$G = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_AFFILIATES$G, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["m" /* GET_ALL_AFFILIATES */], function (state, affiliates) {
  state.affiliates = affiliates;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_AFFILIATES$G, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["n" /* GET_AFFILIATE */], function (state, affiliate) {
  state.affiliate = affiliate;
}), _GET_ALL_AFFILIATES$G);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  affiliates: [],
  affiliate: {}
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api__ = __webpack_require__(104);


/* harmony default export */ __webpack_exports__["a"] = ({
  fetchTableData: function fetchTableData(_ref, configs) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    dispatch('toggleLoadding', true, { root: true });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api__["a" /* getFromUrl */])(configs.url, configs.params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["I" /* SET_TABLE_DATA */], response.data);
        commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["J" /* SET_TABLE_DATAS */], { table_name: configs.table_name, data: response.data });
        if (typeof response.meta !== 'undefined' && typeof response.meta.pagination !== 'undefined') {
          commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["L" /* SET_TABLE_PAGINATIONS */], { table_name: configs.table_name, data: response.meta.pagination });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["I" /* SET_TABLE_DATA */], []);
        commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["J" /* SET_TABLE_DATAS */], { table_name: configs.table_name, data: [] });
      }
    }).catch(function (err) {
      dispatch('toggleLoadding', false, { root: true });
      dispatch('showNotify', {
        title: 'Kết nối lỗi',
        body: err.message || 'Kết nối lỗi vui lòng thử lại',
        type: 'danger'
      }, { root: true });
    });
  },
  setTableData: function setTableData(_ref2, name) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["I" /* SET_TABLE_DATA */], state.dataTables[name]);
  },
  setPaginator: function setPaginator(_ref3, configs) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["K" /* SET_TABLE_PAGINATION */], configs);
  },
  setTableQuery: function setTableQuery(_ref4, configs) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0_src_store_mutation_types__["M" /* SET_TABLE_QUERIES */], configs);
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  dataTables: function dataTables(state) {
    return state.dataTables;
  },
  dataTable: function dataTable(state) {
    return state.dataTable;
  },
  dataPaginations: function dataPaginations(state) {
    return state.dataPaginations;
  },
  tableQueries: function tableQueries(state) {
    return state.tableQueries;
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(358);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _SET_TABLE_DATA$SET_T;


/* harmony default export */ __webpack_exports__["a"] = (_SET_TABLE_DATA$SET_T = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TABLE_DATA$SET_T, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["I" /* SET_TABLE_DATA */], function (state, data) {
  state.dataTable = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TABLE_DATA$SET_T, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["J" /* SET_TABLE_DATAS */], function (state, data) {
  state.dataTables[data.table_name] = data.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TABLE_DATA$SET_T, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["K" /* SET_TABLE_PAGINATION */], function (state, data) {
  state.dataPaginations[data.table_name][data.key] = data.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TABLE_DATA$SET_T, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["L" /* SET_TABLE_PAGINATIONS */], function (state, data) {
  state.dataPaginations[data.table_name] = data.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TABLE_DATA$SET_T, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["M" /* SET_TABLE_QUERIES */], function (state, data) {
  state.tableQueries[data.table_name] = data.value;
}), _SET_TABLE_DATA$SET_T);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  dataTable: [],
  dataTables: {},
  dataPaginations: {},
  tableQueries: {}
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_bank__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getAllBanks = function getAllBanks(_ref, params) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_bank__["a" /* getAllBank */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["l" /* SET_BANKS */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["l" /* SET_BANKS */], []);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllBanks: getAllBanks
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  banks: function banks(state) {
    return state.banks;
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(363);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["l" /* SET_BANKS */], function (state, data) {
  state.banks = data;
}));

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  banks: []
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_carriers__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getAllCarriers = function getAllCarriers(_ref, params) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_carriers__["a" /* getAllCarriers */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["t" /* GET_ALL_CARRIERS */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["t" /* GET_ALL_CARRIERS */], []);
    }
  });
};

var getAllCarrierZhCod = function getAllCarrierZhCod(_ref2, params) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_carriers__["b" /* getAllCarrierZhCod */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["u" /* GET_ALL_CARRIERS_ZH_COD */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["u" /* GET_ALL_CARRIERS_ZH_COD */], []);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCarriers: getAllCarriers,
  getAllCarrierZhCod: getAllCarrierZhCod
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carriers: function carriers(state) {
    return state.carriers;
  },
  carrierZhs: function carrierZhs(state) {
    return state.carrierZhs;
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(368);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_ALL_CARRIERS$GET;



/* harmony default export */ __webpack_exports__["a"] = (_GET_ALL_CARRIERS$GET = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_CARRIERS$GET, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["t" /* GET_ALL_CARRIERS */], function (state, carriers) {
  state.carriers = carriers;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_CARRIERS$GET, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["u" /* GET_ALL_CARRIERS_ZH_COD */], function (state, carrierZhs) {
  state.carrierZhs = carrierZhs;
}), _GET_ALL_CARRIERS$GET);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carriers: [],
  carrierZhs: []
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_city__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getAllCity = function getAllCity(_ref, params) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_city__["a" /* getAllCity */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["k" /* GET_ALL_CITY */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["k" /* GET_ALL_CITY */], []);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCity: getAllCity
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cities: function cities(state) {
    return state.cities;
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(373);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["k" /* GET_ALL_CITY */], function (state, cities) {
  state.cities = cities;
}));

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cities: [],
  city: {}
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Compare__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListtingCompare__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListtingCompare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ListtingCompare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListtingAllCompare__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListtingAllCompare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ListtingAllCompare__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/cross-checks',
  name: 'cross-check',
  component: __WEBPACK_IMPORTED_MODULE_1__Compare___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/cross-checks/listting/:id',
  name: 'listting-compare',
  component: __WEBPACK_IMPORTED_MODULE_2__ListtingCompare___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/compares',
  name: 'compare',
  component: __WEBPACK_IMPORTED_MODULE_3__ListtingAllCompare___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_compares__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var getCrossChecksHeppers = function getCrossChecksHeppers(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_helpers__["b" /* getCrossChecksHeppers */]().then(function (response) {
    if (response) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["v" /* GET_CROSS_CHECKS_HELPERS */], response);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["v" /* GET_CROSS_CHECKS_HELPERS */], []);
    }
  });
};
var getCompareHeppers = function getCompareHeppers(_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_1_src_api_compares__["t" /* getCompareHeppers */]().then(function (response) {
    if (response) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["w" /* GET_COMPARE_HELPERS */], response);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["w" /* GET_COMPARE_HELPERS */], []);
    }
  });
};
var getCompareFeeHeppers = function getCompareFeeHeppers(_ref3) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_1_src_api_compares__["u" /* getCompareFeeHeppers */]().then(function (response) {
    if (response) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["x" /* GET_COMPARE_FEE_HELPERS */], response);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["x" /* GET_COMPARE_FEE_HELPERS */], []);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getCrossChecksHeppers: getCrossChecksHeppers,
  getCompareHeppers: getCompareHeppers,
  getCompareFeeHeppers: getCompareFeeHeppers
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  crossChecksHelpers: function crossChecksHelpers(state) {
    return state.crossChecksHelpers;
  },
  compareHelpers: function compareHelpers(state) {
    return state.compareHelpers;
  },
  compareFeeHelpers: function compareFeeHelpers(state) {
    return state.compareFeeHelpers;
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(379);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_CROSS_CHECKS_HEL;



/* harmony default export */ __webpack_exports__["a"] = (_GET_CROSS_CHECKS_HEL = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_CROSS_CHECKS_HEL, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["v" /* GET_CROSS_CHECKS_HELPERS */], function (state, crossChecksHelpers) {
  state.crossChecksHelpers = crossChecksHelpers;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_CROSS_CHECKS_HEL, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["w" /* GET_COMPARE_HELPERS */], function (state, compareHelpers) {
  state.compareHelpers = compareHelpers;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_CROSS_CHECKS_HEL, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["x" /* GET_COMPARE_FEE_HELPERS */], function (state, compareFeeHelpers) {
  state.compareFeeHelpers = compareFeeHelpers;
}), _GET_CROSS_CHECKS_HEL);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  crossChecksHelpers: {},
  compareHelpers: {},
  compareFeeHelpers: {}
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard__);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'dashboard',
  component: __WEBPACK_IMPORTED_MODULE_1__Dashboard___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/dashboard',
  name: 'dashboard',
  component: __WEBPACK_IMPORTED_MODULE_1__Dashboard___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_district__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getAllDistrict = function getAllDistrict(_ref, params) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      state = _ref.state;

  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["g" /* GET_ALL_DISTRICT */], state.districtsByCityCode[params.city_code]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_district__["a" /* getAllDistrict */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["g" /* GET_ALL_DISTRICT */], response.data);
        if (params.city_code) {
          commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["j" /* SET_LOADED_DISTRICT_BY_CITY_CODE */], { city_code: params.city_code, districts: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["g" /* GET_ALL_DISTRICT */], []);
      }
    });
  }
};

var getAllDistrictTo = function getAllDistrictTo(_ref2, params) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      state = _ref2.state;

  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["h" /* GET_DISTRICT_TO */], state.districtsByCityCode[params.city_code]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_district__["a" /* getAllDistrict */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["h" /* GET_DISTRICT_TO */], response.data);
        if (params.city_code) {
          commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["j" /* SET_LOADED_DISTRICT_BY_CITY_CODE */], { city_code: params.city_code, districts: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["h" /* GET_DISTRICT_TO */], []);
      }
    });
  }
};

var getAllDistrictFrom = function getAllDistrictFrom(_ref3, params) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch,
      state = _ref3.state;

  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["i" /* GET_DISTRICT_FROM */], state.districtsByCityCode[params.city_code]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_district__["a" /* getAllDistrict */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["i" /* GET_DISTRICT_FROM */], response.data);
        if (params.city_code) {
          commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["j" /* SET_LOADED_DISTRICT_BY_CITY_CODE */], { city_code: params.city_code, districts: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["i" /* GET_DISTRICT_FROM */], []);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllDistrict: getAllDistrict,
  getAllDistrictTo: getAllDistrictTo,
  getAllDistrictFrom: getAllDistrictFrom
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  districts: function districts(state) {
    return state.districts;
  },
  districtTo: function districtTo(state) {
    return state.districtTo;
  },
  districtFrom: function districtFrom(state) {
    return state.districtFrom;
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(385);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_ALL_DISTRICT$GET;


/* harmony default export */ __webpack_exports__["a"] = (_GET_ALL_DISTRICT$GET = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_DISTRICT$GET, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["g" /* GET_ALL_DISTRICT */], function (state, districts) {
  state.districts = districts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_DISTRICT$GET, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["h" /* GET_DISTRICT_TO */], function (state, districts) {
  state.districtTo = districts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_DISTRICT$GET, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["i" /* GET_DISTRICT_FROM */], function (state, districts) {
  state.districtFrom = districts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_DISTRICT$GET, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["j" /* SET_LOADED_DISTRICT_BY_CITY_CODE */], function (state, params) {
  state.districtsByCityCode[params.city_code] = params.districts;
}), _GET_ALL_DISTRICT$GET);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  districts: [],
  districtTo: [],
  districtFrom: [],
  district: {},
  districtsByCityCode: {}
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Invoice__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewInvoice__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditInvoice__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailInvoice__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DetailInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvoiceReport__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvoiceReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InvoiceReport__);







/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/invoices',
  name: 'invoice',
  component: __WEBPACK_IMPORTED_MODULE_1__Invoice___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/invoices/create',
  name: 'create-invoice',
  component: __WEBPACK_IMPORTED_MODULE_2__NewInvoice___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/invoices/report',
  name: 'invoice-report',
  component: __WEBPACK_IMPORTED_MODULE_5__InvoiceReport___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/invoices/:id/edit',
  name: 'edit-invoice',
  component: __WEBPACK_IMPORTED_MODULE_3__EditInvoice___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/invoices/:id',
  name: 'detail-invoice',
  component: __WEBPACK_IMPORTED_MODULE_4__DetailInvoice___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_invoice__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var getInvoiceHelpers = function getInvoiceHelpers(_ref) {
  var commit = _ref.commit;

  __WEBPACK_IMPORTED_MODULE_0_src_api_invoice__["u" /* getHelpers */]().then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["F" /* GET_INVOICE_HELPERS */], response);
  });
};

var setInvoice = function setInvoice(_ref2, invoice) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["G" /* SET_INVOICE */], invoice);
};

var getInvoiceDetail = function getInvoiceDetail(_ref3, configs) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  dispatch("toggleLoadding", true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_invoice__["l" /* getInvoice */](configs.id, configs.params).then(function (response) {
    if (response.code === 200) {
      dispatch("toggleLoadding", false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["G" /* SET_INVOICE */], response.data);
      if (configs.success != null) {
        configs.success(response.data);
      }
    } else if (response.code === 404) {
      dispatch("toggleLoadding", false, { root: true });
      dispatch("showNotify", {
        title: "Không tìm thấy tài nguyên",
        body: "Phiếu chi không tồn tại trên hệ thống",
        type: "warning"
      }, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_src_router__["a" /* default */].push({ name: "invoice" });
    } else {}
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getInvoiceHelpers: getInvoiceHelpers,
  setInvoice: setInvoice,
  getInvoiceDetail: getInvoiceDetail
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  invoices: function invoices(state) {
    return state.invoices;
  },
  invoice: function invoice(state) {
    return state.invoice;
  },
  invoiceHelpers: function invoiceHelpers(state) {
    return state.invoiceHelpers;
  },
  getTotalFee: function getTotalFee(state) {
    return state.invoice.shipments.data.reduce(function (pv, cv) {
      return pv + cv.total_fee;
    }, 0);
  },
  getTotalCOD: function getTotalCOD(state) {
    return state.invoice.shipments.data.reduce(function (pv, cv) {
      return pv + cv.amount_for_cross;
    }, 0);
  },
  getTotalFeeDifference: function getTotalFeeDifference(state) {
    return state.invoice.shipments.data.reduce(function (pv, cv) {
      return pv + (cv.compare_fee.data.total_fee - cv.compare_fee.data.last_total_fee);
    }, 0);
  },
  getArearAmount: function getArearAmount(state) {
    var arearAmount = state.invoice.money_return;
    var isDebt = state.invoice.returneds.data.length > 0 || state.invoice.returns.data.length > 0;
    return isDebt ? arearAmount * -1 : arearAmount;
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(391);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_INVOICE_HELPERS$;



/* harmony default export */ __webpack_exports__["a"] = (_GET_INVOICE_HELPERS$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_INVOICE_HELPERS$, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["F" /* GET_INVOICE_HELPERS */], function (state, helper) {
  state.invoiceHelpers = helper;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_INVOICE_HELPERS$, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["G" /* SET_INVOICE */], function (state, invoice) {
  state.invoice = invoice;
}), _GET_INVOICE_HELPERS$);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  invoices: [],
  invoice: {},
  invoiceHelpers: {}
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Permission__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Permission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Permission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewPermission__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewPermission__);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/permissions',
  name: 'permission',
  component: __WEBPACK_IMPORTED_MODULE_1__Permission___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/permissions/new',
  name: 'create-permission',
  component: __WEBPACK_IMPORTED_MODULE_2__NewPermission___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_permissions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



var getAllPermissions = function getAllPermissions(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_permissions__["c" /* getAllPermissions */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["y" /* GET_ALL_PERMISSIONS */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["y" /* GET_ALL_PERMISSIONS */], []);
    }
  });
};

var setPermission = function setPermission(_ref2, permission) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["z" /* SET_PERMISSION */], permission);
};

var getAllPermissionsHelpers = function getAllPermissionsHelpers(_ref3) {
  var commit = _ref3.commit;

  __WEBPACK_IMPORTED_MODULE_0_src_api_permissions__["d" /* getAllPermissionHelpers */]().then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["A" /* SET_PERMISSION_HELPERS */], response);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllPermissions: getAllPermissions,
  setPermission: setPermission,
  getAllPermissionsHelpers: getAllPermissionsHelpers
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  permissions: function permissions(state) {
    return state.permissions;
  },
  permission: function permission(state) {
    return state.permission;
  },
  permissionHelpers: function permissionHelpers(state) {
    return state.permissionHelpers;
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(397);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_ALL_PERMISSIONS$;



/* harmony default export */ __webpack_exports__["a"] = (_GET_ALL_PERMISSIONS$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_PERMISSIONS$, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["y" /* GET_ALL_PERMISSIONS */], function (state, permissions) {
  state.permissions = permissions;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_PERMISSIONS$, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["z" /* SET_PERMISSION */], function (state, permission) {
  state.permission = permission;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_PERMISSIONS$, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["A" /* SET_PERMISSION_HELPERS */], function (state, helpers) {
  state.permissionHelpers = helpers;
}), _GET_ALL_PERMISSIONS$);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  permissions: [],
  permission: {},
  permissionHelpers: {}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PermissionDenied__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PermissionDenied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PermissionDenied__);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/permission-denied',
  name: 'permission-denied',
  component: __WEBPACK_IMPORTED_MODULE_0__PermissionDenied___default.a
}]);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Receipt__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Receipt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewReceipt__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewReceipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewReceipt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditReceipt__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditReceipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditReceipt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailReceipt__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailReceipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DetailReceipt__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/receipt',
  name: 'receipt',
  component: __WEBPACK_IMPORTED_MODULE_1__Receipt___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/receipt/new',
  name: 'create-receipt',
  component: __WEBPACK_IMPORTED_MODULE_2__NewReceipt___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/receipt/:id/edit',
  name: 'edit-receipt',
  component: __WEBPACK_IMPORTED_MODULE_3__EditReceipt___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/receipt/:id',
  name: 'detail-receipt',
  component: __WEBPACK_IMPORTED_MODULE_4__DetailReceipt___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_receipt__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var setReceipt = function setReceipt(_ref, receipt) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["s" /* SET_RECEIPT */], receipt);
};

var getReceiptDetail = function getReceiptDetail(_ref2, configs) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_receipt__["c" /* getReceipt */](configs.id, configs.params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["s" /* SET_RECEIPT */], response.data);
    } else if (response.code === 404) {
      dispatch('toggleLoadding', false, { root: true });
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        body: 'Phiếu thu không tồn tại trên hệ thống',
        type: 'warning'
      }, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_src_router__["a" /* default */].push({ name: 'receipt' });
    } else {}
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setReceipt: setReceipt,
  getReceiptDetail: getReceiptDetail
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  receipts: function receipts(state) {
    return state.receipts;
  },
  receipt: function receipt(state) {
    return state.receipt;
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(404);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["s" /* SET_RECEIPT */], function (state, receipt) {
  state.receipt = receipt;
}));

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  receipts: [],
  receipt: {}
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Role__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Role___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Role__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewRole__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewRole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewRole__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditRole__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditRole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditRole__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/roles',
  name: 'role',
  component: __WEBPACK_IMPORTED_MODULE_1__Role___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/roles/create',
  name: 'new-role',
  component: __WEBPACK_IMPORTED_MODULE_2__NewRole___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/roles/edit/:id',
  name: 'edit-role',
  component: __WEBPACK_IMPORTED_MODULE_3__EditRole___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_roles__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var getAllRoles = function getAllRoles(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_roles__["e" /* getAllRoles */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["C" /* GET_ALL_ROLES */], response.data);
    } else {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["C" /* GET_ALL_ROLES */], []);
    }
  });
};

var getRole = function getRole(_ref2, configs) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_roles__["b" /* getRole */](configs.id, configs.params).then(function (response) {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["D" /* GET_ROLE */], response.data);
        break;
      case 404:
        dispatch('toggleLoadding', false, { root: true });
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Role không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
        __WEBPACK_IMPORTED_MODULE_1_src_router__["a" /* default */].push({ name: 'role' });
        break;
      default:
        dispatch('toggleLoadding', false, { root: true });
    }
  });
};

var setRole = function setRole(_ref3, role) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["D" /* GET_ROLE */], role);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllRoles: getAllRoles,
  getRole: getRole,
  setRole: setRole
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  roles: function roles(state) {
    return state.roles;
  },
  role: function role(state) {
    return state.role;
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(410);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_ALL_ROLES$GET_RO;



/* harmony default export */ __webpack_exports__["a"] = (_GET_ALL_ROLES$GET_RO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_ROLES$GET_RO, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["C" /* GET_ALL_ROLES */], function (state, roles) {
  state.roles = roles;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_ROLES$GET_RO, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["D" /* GET_ROLE */], function (state, role) {
  state.role = role;
}), _GET_ALL_ROLES$GET_RO);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  roles: [],
  role: {}
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Saler__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Saler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Saler__);




/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/salers',
  name: 'saler',
  component: __WEBPACK_IMPORTED_MODULE_1__Saler___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SalerConfig__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SalerConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SalerConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalerConfigByUser__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalerConfigByUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SalerConfigByUser__);





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/settings/saller',
  name: 'saller-config',
  component: __WEBPACK_IMPORTED_MODULE_1__SalerConfig___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/settings/saller-by-saler/:id',
  name: 'saller-config-by-saler',
  component: __WEBPACK_IMPORTED_MODULE_2__SalerConfigByUser___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_shipments__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__ = __webpack_require__(3);





var getShipmentHelpers = function getShipmentHelpers(_ref, params) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_helpers__["a" /* getShipmentHeppers */](params).then(function (response) {
    dispatch('toggleLoadding', false, { root: true });
    response.statuses.push({ status: -1, status_txt: 'Tất cả' });
    commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["o" /* GET_SHIPMENT_HELPERS */], response);
  });
};
var getFilter = function getFilter(_ref2, params) {
  var commit = _ref2.commit;

  params = typeof params === 'undefined' ? {} : params;
  __WEBPACK_IMPORTED_MODULE_1_src_api_shipments__["c" /* getFilter */](params).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["p" /* GET_SHIPMENT_STATUS_FILTERS */], response.data);
  }).catch(function (errors) {
    return errors;
  });
};
var setShipment = function setShipment(_ref3, shipment) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["q" /* SET_SHIPMENT */], shipment);
};
var getShipmentDetail = function getShipmentDetail(_ref4, configs) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_1_src_api_shipments__["b" /* getShipment */](configs.id, configs.params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["q" /* SET_SHIPMENT */], response.data);
    } else if (response.code === 404) {
      dispatch('toggleLoadding', false, { root: true });
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        body: 'Vận đơn không tồn tại trên hệ thống',
        type: 'warning'
      }, { root: true });
      __WEBPACK_IMPORTED_MODULE_2_src_router__["a" /* default */].push({ name: 'shipment' });
    } else {}
  });
};

var getShipmentDetailComplaint = function getShipmentDetailComplaint(_ref5, configs) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_1_src_api_shipments__["b" /* getShipment */](configs.id, configs.params).then(function (response) {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["q" /* SET_SHIPMENT */], response.data);
    } else if (response.code === 404) {
      dispatch('toggleLoadding', false, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["q" /* SET_SHIPMENT */], { status: 1000, status_txt: 'Đơn đã hủy' });
    } else {}
  });
};

var exportExcel = function exportExcel(_ref6, params) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_1_src_api_shipments__["d" /* exportExcel */](params).then(function (response) {
    if (response.code === 200) {
      dispatch('showNotify', {
        title: 'Thành công',
        body: 'Xuất excel thành công'
      }, { root: true });
      window.location.href = response.full;
      dispatch('toggleLoadding', false, { root: true });
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, { root: true });
      dispatch('toggleLoadding', false, { root: true });
      __WEBPACK_IMPORTED_MODULE_2_src_router__["a" /* default */].push({ name: 'client' });
    } else {
      dispatch('toggleLoadding', false, { root: true });
    }
  });
};

var setNewShipment = function setNewShipment(_ref7) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3_src_store_mutation_types__["r" /* NEW_SHIPMENT */]);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getShipmentHelpers: getShipmentHelpers,
  getFilter: getFilter,
  setShipment: setShipment,
  getShipmentDetail: getShipmentDetail,
  setNewShipment: setNewShipment,
  exportExcel: exportExcel,
  getShipmentDetailComplaint: getShipmentDetailComplaint
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  shipmentHelpers: function shipmentHelpers(state) {
    return state.shipmentHelpers;
  },
  shipmentStatusFilters: function shipmentStatusFilters(state) {
    return state.shipmentStatusFilters;
  },
  shipment: function shipment(state) {
    return state.shipment;
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(417);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_SHIPMENT_HELPERS;


/* harmony default export */ __webpack_exports__["a"] = (_GET_SHIPMENT_HELPERS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_SHIPMENT_HELPERS, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["o" /* GET_SHIPMENT_HELPERS */], function (state, shipmentHelpers) {
  state.shipmentHelpers = shipmentHelpers;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_SHIPMENT_HELPERS, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["p" /* GET_SHIPMENT_STATUS_FILTERS */], function (state, shipmentStatusFilters) {
  state.shipmentStatusFilters = shipmentStatusFilters;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_SHIPMENT_HELPERS, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["q" /* SET_SHIPMENT */], function (state, shipment) {
  state.shipment = shipment;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_SHIPMENT_HELPERS, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["r" /* NEW_SHIPMENT */], function (state) {
  state.shipment = {
    id: 0,
    address_from: {
      city_code: '',
      district_code: ''
    },
    address_to: {
      city_code: '',
      district_code: ''
    },
    picker: {},
    receiver: {},
    parcel: {
      quantity: 1,
      cod_amount: 0,
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      amount: 0
    },
    metadata: '',
    return_type: 0,
    payer: 0
  };
}), _GET_SHIPMENT_HELPERS);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  shipmentHelpers: {},
  shipmentStatusFilters: [],
  shipment: {
    id: 0,
    address_from: {
      data: {
        city_code: '',
        district_code: '',
        city: {},
        district: {}
      }
    },
    address_to: {
      data: {
        city_code: '',
        district_code: '',
        city: {},
        district: {}
      }
    },
    picker: {
      data: {}
    },
    receiver: {
      data: {}
    },
    parcel: {
      data: {
        quantity: 1,
        cod_amount: 0,
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        amount: 0
      }
    },
    metadata: ''
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_router_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__User__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewUser__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditUser__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditUser__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/users',
  name: 'user',
  component: __WEBPACK_IMPORTED_MODULE_1__User___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/users/create',
  name: 'new-user',
  component: __WEBPACK_IMPORTED_MODULE_2__NewUser___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}, {
  path: '/users/edit/:id',
  name: 'edit-user',
  component: __WEBPACK_IMPORTED_MODULE_3__EditUser___default.a,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_0_src_router_auth__["a" /* default */].requireAuth
}]);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_users__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var getUser = function getUser(_ref, configs) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_users__["b" /* getUser */](configs.id, configs.params).then(function (response) {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["E" /* GET_USER */], response.data);
        break;
      case 404:
        dispatch('toggleLoadding', false, { root: true });
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'User không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
        __WEBPACK_IMPORTED_MODULE_1_src_router__["a" /* default */].push({ name: 'user' });
        break;
      default:
        dispatch('toggleLoadding', false, { root: true });
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: getUser
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  user: function user(state) {
    return state.user;
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(423);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["E" /* GET_USER */], function (state, user) {
  state.user = user;
}));

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  user: {}
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_ward__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__ = __webpack_require__(3);




var getAllWard = function getAllWard(_ref, params) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      state = _ref.state;

  if (params.district_code && state.wardsByDistrictCode[params.district_code] && state.wardsByDistrictCode[params.district_code].length) {
    commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["a" /* GET_ALL_WARD */], state.wardsByDistrictCode[params.district_code]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_ward__["a" /* getAllWard */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["a" /* GET_ALL_WARD */], response.data);
        if (params.district_code) {
          commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["d" /* SET_LOADED_WARD_BY_DISTRICT_CODE */], { district_code: params.district_code, wards: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["a" /* GET_ALL_WARD */], []);
      }
    });
  }
};

var getAllWardTo = function getAllWardTo(_ref2, params) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      state = _ref2.state;

  if (params.district_code && state.wardsByDistrictCode[params.district_code] && state.wardsByDistrictCode[params.district_code].length) {
    commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["b" /* GET_WARD_TO */], state.wardsByDistrictCode[params.district_code]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_ward__["a" /* getAllWard */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["b" /* GET_WARD_TO */], response.data);
        if (params.district_code) {
          commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["d" /* SET_LOADED_WARD_BY_DISTRICT_CODE */], { district_code: params.district_code, wards: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["b" /* GET_WARD_TO */], []);
      }
    });
  }
};

var getAllWardFrom = function getAllWardFrom(_ref3, params) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch,
      state = _ref3.state;

  if (params.district_code && state.wardsByDistrictCode[params.district_code] && state.wardsByDistrictCode[params.district_code].length) {
    commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["c" /* GET_WARD_FROM */], state.wardsByDistrictCode[params.district_code]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_ward__["a" /* getAllWard */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["c" /* GET_WARD_FROM */], response.data);
        if (params.district_code) {
          commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["d" /* SET_LOADED_WARD_BY_DISTRICT_CODE */], { district_code: params.district_code, wards: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["c" /* GET_WARD_FROM */], []);
      }
    });
  }
};

var getWardByDistrictId = function getWardByDistrictId(_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch,
      state = _ref4.state;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (params.district_id && state.wardsByDistrictId[params.district_id] && state.wardsByDistrictId[params.district_id].length) {
    commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["a" /* GET_ALL_WARD */], state.wardsByDistrictId[params.district_id]);
  } else {
    dispatch('toggleLoadding', true, { root: true });
    __WEBPACK_IMPORTED_MODULE_0_src_api_ward__["a" /* getAllWard */](params).then(function (response) {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["a" /* GET_ALL_WARD */], response.data);
        if (params.district_id) {
          commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["e" /* SET_LOADED_WARD_BY_DISTRICT_ID */], { district_id: params.district_id, wards: response.data });
        }
      } else {
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["a" /* GET_ALL_WARD */], []);
      }
    });
  }
};

var getWard = function getWard(_ref5, configs) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  dispatch('toggleLoadding', true, { root: true });
  __WEBPACK_IMPORTED_MODULE_0_src_api_ward__["b" /* getWard */](configs.id, configs.params).then(function (response) {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["f" /* GET_WARD */], response.data);
        break;
      case 404:
        dispatch('toggleLoadding', false, { root: true });
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Quận huyện không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
        __WEBPACK_IMPORTED_MODULE_1_src_router__["a" /* default */].push({ name: 'ward' });
        break;
      default:
        dispatch('toggleLoadding', false, { root: true });
    }
  });
};

var setWard = function setWard(_ref6, ward) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2_src_store_mutation_types__["f" /* GET_WARD */], ward);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllWard: getAllWard,
  getAllWardTo: getAllWardTo,
  getAllWardFrom: getAllWardFrom,
  getWardByDistrictId: getWardByDistrictId,
  getWard: getWard,
  setWard: setWard
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  wards: function wards(state) {
    return state.wards;
  },
  wardTo: function wardTo(state) {
    return state.wardTo;
  },
  wardFrom: function wardFrom(state) {
    return state.wardFrom;
  },
  ward: function ward(state) {
    return state.ward;
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(428);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__ = __webpack_require__(3);


var _GET_ALL_WARD$GET_WAR;


/* harmony default export */ __webpack_exports__["a"] = (_GET_ALL_WARD$GET_WAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_WARD$GET_WAR, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["a" /* GET_ALL_WARD */], function (state, wards) {
  state.wards = wards;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_WARD$GET_WAR, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["b" /* GET_WARD_TO */], function (state, wards) {
  state.wardTo = wards;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_WARD$GET_WAR, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["c" /* GET_WARD_FROM */], function (state, wards) {
  state.wardFrom = wards;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_WARD$GET_WAR, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["d" /* SET_LOADED_WARD_BY_DISTRICT_CODE */], function (state, params) {
  state.wardsByDistrictCode[params.city_code] = params.wards;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_WARD$GET_WAR, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["e" /* SET_LOADED_WARD_BY_DISTRICT_ID */], function (state, params) {
  state.wardsByDistrictId[params.city_id] = params.wards;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_GET_ALL_WARD$GET_WAR, __WEBPACK_IMPORTED_MODULE_1_src_store_mutation_types__["f" /* GET_WARD */], function (state, ward) {
  state.ward = ward;
}), _GET_ALL_WARD$GET_WAR);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  wards: [],
  wardTo: [],
  wardFrom: [],
  ward: {},
  wardsByDistrictCode: {},
  wardsByDistrictId: {}
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_local_storage__);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(key) {
    var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var val = __WEBPACK_IMPORTED_MODULE_0_local_storage___default()(key) || defaultVal;
    return val;
  },
  set: function set(key, val) {
    return __WEBPACK_IMPORTED_MODULE_0_local_storage___default()(key, val);
  },
  remove: function remove(key) {
    return __WEBPACK_IMPORTED_MODULE_0_local_storage___default.a.remove(key);
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_vi__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_vi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_vi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_display_css__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_display_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_display_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_semantic_ui_button_button_min_css__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_semantic_ui_button_button_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_semantic_ui_button_button_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_semantic_ui_label_label_min_css__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_semantic_ui_label_label_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_semantic_ui_label_label_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_app_gsTable_GsTable__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_app_gsTable_GsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_src_components_app_gsTable_GsTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_app_gsTable_mixins__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_app_GsHeader__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_app_GsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_src_components_app_GsHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_clipboard2__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_api_config__ = __webpack_require__(279);























__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_vi___default.a });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_clipboard2___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('gs-table', __WEBPACK_IMPORTED_MODULE_14_src_components_app_gsTable_GsTable___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_15_src_components_app_gsTable_mixins__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('gs-header', __WEBPACK_IMPORTED_MODULE_16_src_components_app_GsHeader___default.a);

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_8__filters__[key]);
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__mixins__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_9__mixins__[key]);
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carrierShortName; });
var carrierShortName = ['vtp', 'vnp', 'ghn', 'ghtk', 'njv', 'hbb', 'kerry', 'spl', 'ahm'];

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_app_GsMenu__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_app_GsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_app_GsMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    GsMenu: __WEBPACK_IMPORTED_MODULE_1_components_app_GsMenu___default.a
  },
  data: function data() {
    return {
      dialogDebug: false,
      dialogDebugQuery: false,
      dialogData: [],
      devTool: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['isLogged', 'loading', 'debugQuery'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['checkLogged']), {
    showDebugDialog: function showDebugDialog(statement) {
      this.dialogData = statement.stt_exp;
      this.dialogDebugQuery = true;
    }
  }),
  mounted: function mounted() {
    this.checkLogged();
    if (false) {
      this.devTool = true;
    }
  },

  watch: {
    debugQuery: {
      handler: function handler(value) {
        if (value.length) {
          this.devTool = true;
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_accounts__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    login: function login(state) {
      return state.account.login;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isLogged'])),
  data: function data() {
    return {
      rules: {
        username: [{
          required: true,
          message: 'Email không được để trống',
          trigger: 'blur'
        }, {
          type: 'email',
          message: 'Email không hợp lệ',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: 'Mật khẩu không được để trống',
          trigger: 'blur'
        }, {
          min: 6,
          message: 'Mật khẩu cần ít nhất 6 ký tự',
          trigger: 'blur'
        }]
      },
      submitting: false
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_accounts__["c" /* login */])(_this.login).then(function (response) {
            if (response.code === 200) {
              _this.$store.dispatch('showNotify', {
                title: 'Đăng nhập thành công',
                body: 'Đăng nhập thành công'
              });
              _this.$store.dispatch('logged', response);
              _this.$router.push({ path: '/' });
              _this.submitting = false;
            }
            if (response.code === 422) {
              var er = response.data.errors;
              var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(er);
              _this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              });
              _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.isLogged) {
      this.$router.push({ path: '/' });
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Affiliate',

  data: function data() {
    return {
      affiliateTable: 'affiliates',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('affiliate', ['affiliate'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('affiliate', ['getAffiliate']), {
    removeFilter: function removeFilter() {
      this.reloadGsTable(this.affiliateTable);
      this.filters = {
        sort: 'created_at:-1'
      };
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.affiliateTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.affiliateTable);
      }
    }, 300),
    detailRole: function detailRole(affiliate) {
      this.$router.push({ name: 'request-payments', params: { id: affiliate.id }, query: { name: affiliate.name } });
    }
  }),
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.affiliateTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.affiliateTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.affiliateTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')['affiliates']) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_affiliates__ = __webpack_require__(102);





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'RequestPayment',

  data: function data() {
    return {
      requestPaymentTable: 'request-payments',
      filters: {
        sort: 'created_at:-1',
        include: 'client'
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      clientName: ''
    };
  },

  methods: {
    removeFilter: function removeFilter() {
      this.reloadGsTable(this.requestPaymentTable);
      this.filters = {
        sort: 'created_at:-1'
      };
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.requestPaymentTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.requestPaymentTable);
      }
    }, 300),
    confirmPayment: function confirmPayment(payment) {
      var _this = this;

      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xE1c nh\u1EADn y\xEAu c\u1EA7u thanh to\xE1n n\xE0y?', 'Xác nhận yêu cầu thanh toán', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        if (payment.id) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_affiliates__["a" /* confirmRequestPayment */])(payment.id).then(function (response) {
            if (response.code === 200) {
              _this.$message({
                type: 'success',
                message: 'Xác nhận yêu cầu thanh toán thành công'
              });
              _this.reloadGsTable(_this.requestPaymentTable);
            } else {
              _this.$message({
                type: 'danger',
                message: 'Xác nhận yêu cầu thanh toán thất bại'
              });
            }
          });
        }
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.filters.client_id = this.$route.params.id;
    this.clientName = this.$route.query.name;
    if (__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters')[this.requestPaymentTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters')[this.requestPaymentTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.requestPaymentTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters')['affiliates']) {
        __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'GsHeader',
  props: {
    title: {
      type: String,
      default: null
    },
    breadcrumbs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_accounts__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'GsMenu',

  data: function data() {
    var _this = this;

    var comfirmPass = function comfirmPass(rule, value, callback) {
      if (value !== _this.account.password) {
        callback(new Error('Nhập lại mật khẩu không đúng'));
      } else {
        callback();
      }
    };
    return {
      active: '',
      changePasswordModal: false,
      account: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        old_password: [{
          required: true,
          message: 'Mật khẩu hiện tại không được để trống',
          trigger: 'change'
        }, {
          min: 6,
          max: 32,
          message: 'Mật khẩu hiện tại phải trong khoảng 6 đến 32 ký tự',
          trigger: 'change'
        }],
        password: [{
          required: true,
          message: 'Mật khẩu mới không được để trống',
          trigger: 'change'
        }, {
          min: 6,
          max: 32,
          message: 'Mật khẩu mới phải trong khoảng 6 đến 32 ký tự',
          trigger: 'change'
        }],
        password_confirmation: [{
          required: true,
          message: 'Nhập lại mật khẩu không được để trống',
          trigger: 'change'
        }, {
          validator: comfirmPass,
          trigger: 'change'
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('account', ['accountInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('account', ['getPersonlInformation']), {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this2 = this;

      this.$refs.changePasswordForm.validate(function (valid) {
        if (valid) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_accounts__["a" /* changePassword */])(_this2.account).then(function (response) {
            if (response.code === 200) {
              _this2.$store.dispatch('showNotify', {
                title: 'Đổi mật khẩu thành công',
                body: 'Đổi mật khẩu thành công'
              });
              _this2.$store.dispatch('logout');
              _this2.$router.push({ path: '/login' });
            }
            if (response.code === 422) {
              var er = response.data.errors;
              var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(er);
              _this2.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              });
              _this2.submitting = false;
            }
          });
        } else {
          _this2.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this2.submitting = false;
          return false;
        }
      });
    },
    logOut: function logOut() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
      window.location.reload();
    },
    changePassword: function changePassword() {
      this.changePasswordModal = true;
    }
  }),
  mounted: function mounted() {
    if (this.$router.currentRoute.name !== 'dashboard') {
      this.active = this.$router.currentRoute.fullPath.split('/')[1];
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.accountInfo).length) {
      this.getPersonlInformation();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.name === 'dashboard') {
        this.active = '';
      } else {
        this.active = to.fullPath.split('/')[1];
      }
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_local_storage__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gs-table',
  props: {
    tableName: {
      type: String,
      default: 'anonymous'
    },
    dataSource: {
      type: String,
      default: null
    },
    dataParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dataSorted: {
      type: Object,
      default: function _default() {
        return {
          created_at: -1
        };
      }
    },
    dataSorts: {
      type: Array,
      default: function _default() {
        return [{ key: 'created_at', name: 'Ngày tạo' }];
      }
    },
    searchText: {
      type: String,
      default: 'Tìm kiếm'
    },
    cacheData: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      q: null,
      sortStatus: '',
      lastParams: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('gsTable', ['dataTable', 'dataTables', 'dataPaginations', 'tableQueries'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('gsTable', ['fetchTableData', 'setTableData', 'setPaginator', 'setTableQuery']), {
    fetchData: function fetchData() {
      this.sort();
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query)) {
        this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$route.query, this.dataParams, { q: this.q, sort: this.dataParams.sort, limit: this.dataParams.limit }) });
      }

      this.dataParams.limit = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query) && this.$route.query.limit !== '' ? this.$route.query.limit : 25;
      this.dataParams.q = this.tableQueries[this.tableName] ? this.tableQueries[this.tableName] : !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query) && this.$route.query.q !== '' ? this.$route.query.q : null;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.dataParams) !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.lastParams)) {
        this.dataParams.page = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query) ? Number(this.$route.query.page) : 1;
        if (typeof this.dataPaginations[this.tableName] !== 'undefined') {
          if (this.dataParams.page === this.lastParams.page) {
            this.dataParams.page = 1;
          }
          this.setPaginator({ table_name: this.tableName, key: 'current_page', value: this.dataParams.page });
        }
      } else if (typeof this.dataPaginations[this.tableName] !== 'undefined') {
        this.dataParams.page = this.dataPaginations[this.tableName].current_page;
      }

      this.fetchTableData({
        url: this.dataSource,
        params: this.dataParams,
        table_name: this.tableName
      });

      this.lastParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["clone"])(this.dataParams);
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["debounce"])(function () {
      if (this.q !== this.tableQueries[this.tableName]) {
        this.setTableQuery({ table_name: this.tableName, value: this.q });
        this.fetchData();
      }
    }, 500),
    sort: function sort() {
      var sort = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(this.dataSorted, function (value, key) {
        if (value) {
          sort += key + ':' + value + ',';
        }
      });
      if (sort.slice(0, sort.length - 1)) {
        this.dataParams.sort = sort.slice(0, sort.length - 1);
      }
      var lsSorteds = __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('sorteds', {});
      if (!lsSorteds) {
        lsSorteds = {};
      }
      lsSorteds[this.tableName] = this.dataSorted;
      __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.set('sorteds', lsSorteds);
    },
    removeFilter: function removeFilter() {
      this.setTableQuery({ table_name: this.tableName, value: null });
      this.q = null;
      this.$emit('remove-filter');
    },
    pageChange: function pageChange(page) {
      this.setPaginator({ table_name: this.tableName, key: 'current_page', value: page });
      if (this.dataParams.page !== page) {
        this.dataParams.page = page;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query)) {
          this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$route.query, this.dataParams) });
        }
        this.fetchData();
      }
    },
    handleSizeChange: function handleSizeChange(value) {
      this.setPaginator({ table_name: this.tableName, key: 'per_page', value: value });
      this.dataParams.limit = value;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query)) {
        this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$route.query, this.dataParams) });
      }
      this.fetchData();
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.q = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query) ? this.$route.query.q : null;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query)) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.$route.query.sort)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(this.dataSorts, function (val) {
          _this.dataSorted[val.key] = '';
        });
      } else {
        var pairs = this.$route.query.sort.split(',');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(pairs, function (val) {
          var _val$split = val.split(':'),
              _val$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_val$split, 2),
              key = _val$split2[0],
              valueStr = _val$split2[1];

          var trimmedKey = key.trim();
          _this.dataSorted[trimmedKey] = Number(valueStr);
        });
      }
    }
    if (this.cacheData) {
      if (typeof this.dataTables[this.tableName] === 'undefined') {
        this.fetchData();
      } else {
        this.setTableData(this.tableName);
        this.q = this.tableQueries[this.tableName] ? this.tableQueries[this.tableName] : null;
      }
    } else {
      this.fetchData();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$on('reload-table', function (reset) {
      if (typeof _this2.dataPaginations[_this2.tableName] !== 'undefined' && reset) {
        _this2.setPaginator({ table_name: _this2.tableName, key: 'current_page', value: 1 });
      }
      if (typeof _this2.dataTables[_this2.tableName] !== 'undefined') {
        _this2.fetchData();
      }
    });
  },

  watch: {
    dataSorted: {
      handler: function handler(value) {
        var _this3 = this;

        var sortTxt = '';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(this.dataSorted, function (value, key) {
          if (value) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(_this3.dataSorts, { key: key }) > -1) {
              sortTxt += _this3.dataSorts[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(_this3.dataSorts, { key: key })]['name'] + (': ' + (value === 1 ? 'tăng' : 'giảm') + ', ');
            } else {
              sortTxt += key + ': ' + (value === 1 ? 'tăng' : 'giảm') + ', ';
            }
          }
        });
        this.sortStatus = sortTxt.slice(0, sortTxt.length - 2);
      },
      deep: true
    },
    selectedRows: function selectedRows(val) {
      console.log(val);
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_client__ = __webpack_require__(62);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectClient',
  props: ['value', 'placeholder'],
  data: function data() {
    return {
      clients: [],
      loading: false
    };
  },

  methods: {
    remoteMethod: function remoteMethod(query) {
      var _this = this;

      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_api_client__["a" /* getAllClient */])({ q: query }).then(function (response) {
        _this.loading = false;
        _this.clients = response.data;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.value) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_api_client__["a" /* getAllClient */])({ id: this.value }).then(function (response) {
        _this2.loading = false;
        _this2.clients = response.data;
      });
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_api_compares__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_helpers__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_stubs_compares__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_api_invoice__ = __webpack_require__(27);
















var CROSS_CHECK_TYPES = {
  COD: {
    kind: 1,
    exportFunction: __WEBPACK_IMPORTED_MODULE_12_src_api_invoice__["a" /* exportCodListing */],
    fileNamePrefix: 'COD'
  },
  FEE_COMPARE: {
    kind: 2,
    exportFunction: __WEBPACK_IMPORTED_MODULE_12_src_api_invoice__["b" /* exportCompareFeeListing */],
    fileNamePrefix: 'Phí Lần 2'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Compare',
  data: function data() {
    return {
      crossCheckTable: 'crossChecks',
      updateCrossCheck: false,
      filters: {
        status: -1,
        carrier_id: '',
        include: '',
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        kind: ''
      },
      sorted: {
        created_at: -1,
        started_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }, { key: 'started_at', name: 'Ngày đối soát' }],
      filterDateRange: '',
      compareStatuses: __WEBPACK_IMPORTED_MODULE_10_src_stubs_compares__["e" /* compareStatuses */],
      compareStatusesBg: __WEBPACK_IMPORTED_MODULE_10_src_stubs_compares__["f" /* compareStatusesBg */],
      createModal: false,
      currentCompare: {},
      isOpenDialogCompare: false,
      kindCrossCheck: 1,
      monthRangeVal: '',
      note: '',
      noteEdit: '',
      isOpenDialogEditNote: false
    };
  },

  watch: {
    '$route.query': {
      handler: function handler(newQuery) {
        var _this = this;

        this.filters = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.filters, newQuery);
        if (this.filters.start_date && this.filters.end_date) {
          this.filterDateRange = [this.filters.start_date, this.filters.end_date];
        }
        ['status'].forEach(function (key) {
          if (_this.filters[key]) {
            _this.filters[key] = Number(_this.filters[key]);
          }
        });
      },

      deep: true,
      immediate: true }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('compare', ['crossChecksHelpers'])),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('compare', ['getCrossChecksHeppers']), {
    removeFilter: function removeFilter() {
      if (!this.checkDefaultFilter({
        status: -1,
        carrier_id: '',
        include: 'carrier',
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        kind: ''
      })) {
        this.reloadGsTable(this.crossCheckTable);
      }
      this.filterDateRange = '';
      this.filters = {
        status: -1,
        carrier_id: '',
        include: 'carrier',
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        kind: ''
      };
    },
    checkDefaultFilter: function checkDefaultFilter(filters) {
      var _this2 = this;

      var diff = false;
      var lkeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["keys"])(filters);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["forEach"])(lkeys, function (key) {
        if (filters[key] !== _this2.filters[key]) {
          _this2.diff = true;
        }
      });
      return diff;
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.crossCheckTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.crossCheckTable);
      }
      this.$router.push({ query: this.filters });
    }, 300),
    updateFilters: function updateFilters(data) {
      var startDate = data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_src_helpers__["a" /* formatDate */])(data[0]) : null;
      var endDate = data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_src_helpers__["a" /* formatDate */])(data[1]) : null;

      this.filters.start_date = startDate;
      this.filters.end_date = endDate;
      this.filter();
    },
    importNewCompare: function importNewCompare() {
      var _this3 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_api_compares__["r" /* createCrossCheck */])({ kind: this.kindCrossCheck, note: this.note, month: this.kindCrossCheck === 1 ? undefined : this.monthRangeVal }).then(function (response) {
        switch (response.code) {
          case 200:
            _this3.$message({
              type: 'success',
              message: 'Thêm đối soát thành công'
            });
            _this3.reloadGsTable(_this3.crossCheckTable);
            _this3.toggleLoadding(false);
            _this3.isOpenDialogCompare = false;
            break;
          case 422:
            var er = response.data.errors;
            var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(er)[0]]);
            _this3.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: message,
              type: 'warning'
            });
            _this3.toggleLoadding(false);
            _this3.isOpenDialogCompare = false;
            break;
          default:
            _this3.$message({
              type: 'error',
              message: 'Thêm đối soát thất bại vui lòng kiểm tra lại thông tin'
            });
            _this3.toggleLoadding(false);
            _this3.isOpenDialogCompare = false;
        }
      });
    },
    validateBeforeSubmitCrossCheck: function validateBeforeSubmitCrossCheck() {
      var _this4 = this;

      this.$refs.createCrossCheckForm.validate(function (valid) {
        if (valid) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_api_compares__["r" /* createCrossCheck */])(_this4.localCrossCheck).then(function (response) {
            switch (response.code) {
              case 200:
                _this4.$message({
                  type: 'success',
                  message: 'Thêm đối soát thành công'
                });
                _this4.shieldModal = false;
                _this4.reloadGsTable(_this4.crossCheckTable);
                _this4.toggleLoadding(false);
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this4.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this4.toggleLoadding(false);
                break;
              default:
                _this4.$message({
                  type: 'error',
                  message: 'Thêm đối soát thất bại vui lòng kiểm tra lại thông tin'
                });
                _this4.toggleLoadding(false);
            }
          });
        }
      });
    },
    removeCompare: function removeCompare(compare) {
      var _this5 = this;

      this.currentCompare = compare;
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a phi\xEAn \u0111\u1ED1i xo\xE1t ' + this.currentCompare.id, 'Xóa phiên đối xoát', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this5.delCompare();
      }).catch(function () {});
    },
    confirmApplyCompare: function confirmApplyCompare(compare) {
      var _this6 = this;

      this.currentCompare = compare;
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xE1c nh\u1EADn phi\xEAn \u0111\u1ED1i xo\xE1t ' + this.currentCompare.id, 'Xác nhận đối xoát', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this6.applyCompare();
      }).catch(function () {});
    },
    delCompare: function delCompare() {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_api_compares__["e" /* DeleteCrossCheck */])(this.currentCompare.id).then(function (response) {
        if (response.code === 200) {
          _this7.$message({
            type: 'success',
            message: 'Hủy đối soát thành công.'
          });
          _this7.reloadGsTable(_this7.crossCheckTable);
        } else {
          _this7.$message({
            type: 'error',
            message: 'Hủy đối soát thất bại'
          });
        }
      });
    },
    applyCompare: function applyCompare() {
      var _this8 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_api_compares__["d" /* ApplyCrossCheck */])(this.currentCompare.id).then(function (response) {
        if (response.code === 200) {
          _this8.toggleLoadding(false);
          _this8.$message({
            type: 'success',
            message: 'Xác nhận đối soát thành công.'
          });
          _this8.reloadGsTable(_this8.crossCheckTable);
        } else {
          _this8.toggleLoadding(false);
          _this8.$store.dispatch('showNotify', {
            title: 'Xác nhận đối soát',
            body: response.data.message ? response.data.message : 'Xác nhận đối soát thất bại!',
            type: 'warning'
          });
        }
      });
    },
    kindStatus: function kindStatus(kind) {
      switch (kind) {
        case 1:
          return 'success';
        case 2:
          return 'danger';
        default:
          return 'info';
      }
    },
    exportExcelComapre: function exportExcelComapre(crossCheck) {
      var _this9 = this;

      var type = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(CROSS_CHECK_TYPES).find(function (t) {
        return t.kind === crossCheck.kind;
      });
      if (!type) {
        return;
      }
      var handleExport = function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var response, title;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  _this9.submitting = true;
                  _context.next = 4;
                  return type.exportFunction({ crossCheckId: crossCheck.real_id });

                case 4:
                  response = _context.sent;
                  _context.t0 = response.status;
                  _context.next = _context.t0 === 200 ? 8 : _context.t0 === 400 ? 10 : 12;
                  break;

                case 8:
                  _this9.saveBlobToFile(response.data, crossCheck.created_at, type.fileNamePrefix);
                  return _context.abrupt('break', 13);

                case 10:
                  _this9.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error'
                  });
                  return _context.abrupt('break', 13);

                case 12:
                  _this9.$store.dispatch('showNotify', {
                    title: response.data.message || 'Có lỗi xảy ra',
                    type: 'error'
                  });

                case 13:
                  _context.next = 19;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t1 = _context['catch'](0);
                  title = _context.t1.message.includes('status code 400') ? 'Vui lòng thử lại sau ít phút' : _context.t1.message;

                  _this9.$store.dispatch('showNotify', {
                    title: title,
                    type: 'error'
                  });

                case 19:
                  _context.prev = 19;

                  _this9.submitting = false;
                  return _context.finish(19);

                case 22:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this9, [[0, 15, 19, 22]]);
        }));

        return function handleExport() {
          return _ref.apply(this, arguments);
        };
      }();

      handleExport();
    },
    saveBlobToFile: function saveBlobToFile(blob, date, shortName) {
      var url = URL.createObjectURL(blob);

      var link = document.createElement('a');
      link.href = url;
      link.download = 'B\u1EA3ng k\xEA ' + shortName + ' ' + date;
      link.click();

      URL.revokeObjectURL(url);
    },
    editNoteCompare: function editNoteCompare(compare) {
      this.currentCompare = compare;
      this.isOpenDialogEditNote = true;
      this.noteEdit = this.currentCompare.note;
    },
    handlerEditNote: function handlerEditNote() {
      var _this10 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_api_compares__["s" /* UpdateCrossCheck */])(this.currentCompare.id, { note: this.noteEdit }).then(function (response) {
        if (response.code === 200) {
          _this10.$message({
            type: 'success',
            message: 'Cập nhật ghi chú thành công.'
          });
          _this10.reloadGsTable(_this10.crossCheckTable);
          _this10.toggleLoadding(false);
          _this10.isOpenDialogEditNote = false;
        } else {
          _this10.toggleLoadding(false);
          _this10.$message({
            type: 'error',
            message: 'Cập nhật ghi chú thất bại'
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.clickToCopy();
    this.monthRangeVal = __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY-MM');
    if (__WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('filters')[this.crossCheckTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('filters')[this.crossCheckTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.crossChecksHelpers).length) {
      this.getCrossChecksHeppers();
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.crossCheckTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.get('filters')['crossChecks']) {
        __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_7_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_xlsx__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_api_compares__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_constants__ = __webpack_require__(46);














var fileColumnField = [{
  value: 'none',
  text: 'Không chọn'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DialogAddShipmentToCompare',
  data: function data() {
    return {
      dialog: false,
      file: {},
      fileColumnField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["cloneDeep"])(fileColumnField),
      systemColumnField: [{ text: 'Mã HVC/Goship', system: 'ma_don', file: '', maps: ['ma_hvc', 'ma_don_hang', 'ma_e1'] }, { text: 'Cân nặng', system: 'can_nang', file: '', maps: ['can_nang', 'khoi_luong', 'can', 'can_tp', 'tp'] }, { text: 'Tiền COD', system: 'cod', file: '', maps: ['cod', 'tien_thu_ho', 'tien_cod', 'cod_thanh_toan', 'thu_ho', 'cuoc_cod'] }, { text: 'Phí vận chuyển', system: 'phi', file: '', maps: ['phi', 'phi_giao_hang', 'tong_phi_dich_vu', 'cuoc_chinh'] }],
      formatCorrect: false,
      submitting: false,
      dataExcelJson: [],
      carrier: ''
    };
  },


  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('carrier', ['carriers']), {
    filteredFileColumnField: function filteredFileColumnField() {
      return this.type === __WEBPACK_IMPORTED_MODULE_11_src_constants__["a" /* CROSS_CHECK_TYPE */].COD ? this.systemColumnField : this.systemColumnField.filter(function (item) {
        return item.system !== 'can_nang' && item.system !== 'cod';
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('carrier', ['getAllCarriers']), {
    checkFileFormat: function checkFileFormat(fileName) {
      var exten = fileName.substring(fileName.length - 3, fileName.length);
      if (exten === 'csv' || exten === 'xls' || exten === 'lsx') {
        return true;
      } else {
        return false;
      }
    },
    loadExcel: function loadExcel(e) {
      var _this = this;

      this.toggleLoadding(true);
      var fileUpload = e.target.files[0];
      if (fileUpload && this.checkFileFormat(fileUpload.name)) {
        this.formatCorrect = true;
        this.file = fileUpload;
        var reader = new FileReader(fileUpload);
        reader.onload = function (e) {
          var binary = '';
          var bytes = new Uint8Array(e.target.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var wb = __WEBPACK_IMPORTED_MODULE_8_xlsx___default.a.read(binary, { type: 'binary' });
          var ws = wb.Sheets[wb.SheetNames[0]];

          _this.fileColumnField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["cloneDeep"])(fileColumnField);
          if (!ws || !ws['!ref']) return;
          var ref = __WEBPACK_IMPORTED_MODULE_8_xlsx___default.a.utils.decode_range(ws['!ref']);
          for (var C = ref.s.c; C <= ref.e.c; ++C) {
            var cell = ws[__WEBPACK_IMPORTED_MODULE_8_xlsx___default.a.utils.encode_cell({ r: ref.s.r, c: C })];
            if (cell && cell.t === 's') {
              if (cell.v) {
                var originCell = cell.v;
                cell.v = cell.v.trim().replace(/\s/g, '_').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd');
                _this.fileColumnField.push({
                  value: cell.v,
                  text: originCell.trim()
                });
              }
              if (cell.w) {
                cell.w = cell.w.trim().replace(/\s/g, '_').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd');
              }
            }
          }

          _this.dataExcelJson = __WEBPACK_IMPORTED_MODULE_8_xlsx___default.a.utils.sheet_to_json(ws, { defval: '' });

          if (_this.dataExcelJson.length) {
            _this.dataExcelJson = _this.dataExcelJson.map(function (row) {
              var processedRow = {};
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(row)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _step$value = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
                      key = _step$value[0],
                      value = _step$value[1];

                  processedRow[key] = typeof value === 'number' && Math.abs(value - Math.round(value)) < 1e-8 ? Math.round(value) : value;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return processedRow;
            });

            _this.filteredFileColumnField.map(function (obj) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["forEach"])(_this.fileColumnField, function (item) {
                var index = obj.maps.indexOf(item.value);
                if (index > -1) {
                  obj.file = item.value;
                  return false;
                }
              });

              return obj;
            });
          }
          _this.toggleLoadding(false);
        };
        reader.readAsArrayBuffer(fileUpload);
      } else {
        this.formatCorrect = false;
        this.toggleLoadding(false);
      }
    },
    getFormData: function getFormData() {
      var mapper = {};
      this.filteredFileColumnField.forEach(function (obj) {
        mapper[obj.system] = obj.file;
      });
      if ('ma_don' in mapper) {
        this.dataExcelJson.map(function (item) {
          item[mapper['ma_don']] = item[mapper['ma_don']].replace(/^'/, '') + '';
        });
      }
      return {
        data: this.dataExcelJson,
        mapper: mapper
      };
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, dataChunk, requests, responses, count, maxConcurrent, request, firstResponse, er, message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.submitting = true;
                formData = _this2.getFormData();
                dataChunk = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["chunk"])(formData.data, 500);
                requests = [];

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["forEach"])(dataChunk, function (data) {
                  switch (_this2.type) {
                    case __WEBPACK_IMPORTED_MODULE_11_src_constants__["a" /* CROSS_CHECK_TYPE */].COD:
                      requests.push(function () {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_src_api_compares__["o" /* updateCrossCheck */])(_this2.$route.params.id, {
                          carrier: _this2.carrier,
                          data: data,
                          mapper: formData.mapper
                        });
                      });
                      break;
                    case __WEBPACK_IMPORTED_MODULE_11_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE:
                      requests.push(function () {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_src_api_compares__["p" /* updateCrossCheckFee */])(_this2.$route.params.id, {
                          carrier: _this2.carrier,
                          data: data,
                          mapper: formData.mapper
                        });
                      });
                      break;
                    case __WEBPACK_IMPORTED_MODULE_11_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE1:
                      requests.push(function () {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_src_api_compares__["q" /* updateCrossCheckFee1 */])(_this2.$route.params.id, {
                          carrier: _this2.carrier,
                          data: data,
                          mapper: formData.mapper
                        });
                      });
                      break;

                  }
                });

                responses = [];
                count = 0;
                maxConcurrent = 5;
                _context.prev = 8;

              case 9:
                if (false) {
                  _context.next = 17;
                  break;
                }

                if (!(requests.length === 0 && count === 0)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('break', 17);

              case 12:
                if (count < maxConcurrent && requests.length > 0) {
                  request = requests.shift();

                  count++;
                  request().then(function (response) {
                    responses.push(response);
                  }).catch(function (error) {
                    console.error("Lỗi khi thực hiện request:", error);
                  }).finally(function () {
                    count--;
                  });
                }

                _context.next = 15;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, 50);
                });

              case 15:
                _context.next = 9;
                break;

              case 17:
                if (!(responses.length > 0)) {
                  _context.next = 33;
                  break;
                }

                firstResponse = responses[0];
                _context.t0 = firstResponse.code;
                _context.next = _context.t0 === 200 ? 22 : _context.t0 === 422 ? 28 : 32;
                break;

              case 22:
                _this2.resetData();
                formData = null;
                _this2.$emit("success");
                _this2.dialog = false;
                _this2.$message({
                  type: "success",
                  message: "Upload bảng kê thành công! Quá trình hoàn tất sẽ được thông báo trên Telegram."
                });
                return _context.abrupt('break', 33);

              case 28:
                er = firstResponse.data;
                message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["head"])(er);

                _this2.$store.dispatch("showNotify", {
                  title: "Vui lòng kiểm tra thông tin cần nhập",
                  body: message,
                  type: "warning"
                });
                return _context.abrupt('break', 33);

              case 32:
                _this2.$message({
                  type: "error",
                  message: "Thêm đối soát thất bại, vui lòng kiểm tra lại thông tin."
                });

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context['catch'](8);

                _this2.$message({
                  type: "error",
                  message: "Đã xảy ra lỗi trong quá trình xử lý."
                });

              case 38:
                _context.prev = 38;

                _this2.submitting = false;
                return _context.finish(38);

              case 41:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[8, 35, 38, 41]]);
      }))();
    },
    resetData: function resetData() {
      this.resetFileInput();
      this.dataExcelJson = [];
      this.fileColumnField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["cloneDeep"])(fileColumnField);
      this.file = {};
      this.carrier = '';
      this.formatCorrect = false;
    },
    retryRequest: function retryRequest(request) {
      var _this3 = this;

      var maxRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var retries, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                retries = 0;

              case 1:
                if (!(retries < maxRetries)) {
                  _context2.next = 16;
                  break;
                }

                _context2.prev = 2;
                _context2.next = 5;
                return request();

              case 5:
                response = _context2.sent;

                if (!(response.code === 200)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', response);

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](2);

                console.error('L\u1ED7i khi th\u1EF1c hi\u1EC7n request (l\u1EA7n th\u1EED ' + (retries + 1) + '):', _context2.t0);

              case 13:
                retries++;
                _context2.next = 1;
                break;

              case 16:
                throw new Error('Request th\u1EA5t b\u1EA1i sau ' + maxRetries + ' l\u1EA7n th\u1EED.');

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 10]]);
      }))();
    },
    resetFileInput: function resetFileInput() {
      var input = this.$refs.fileInput;
      input.value = null;
    }
  }),

  mounted: function mounted() {
    this.dialog = this.value;
    this.getAllCarriers();
  },


  watch: {
    value: function value(_value) {
      this.dialog = _value;
    },
    dialog: function dialog() {
      this.$emit('input', this.dialog);
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_compares__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_stubs_compares__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_stubs_shipments__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_helpers__ = __webpack_require__(25);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListtingAllCompare',
  data: function data() {
    return {
      compareTable: 'compares',
      filters: {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,cross_check,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1,
        start_date: '',
        end_date: ''
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      listtingComparesStatus: __WEBPACK_IMPORTED_MODULE_6_src_stubs_compares__["a" /* listtingComparesStatus */],
      listtingComparesStatusBg: __WEBPACK_IMPORTED_MODULE_6_src_stubs_compares__["b" /* listtingComparesStatusBg */],
      listtingComparesError: __WEBPACK_IMPORTED_MODULE_6_src_stubs_compares__["c" /* listtingComparesError */],
      listtingComparesErrorBg: __WEBPACK_IMPORTED_MODULE_6_src_stubs_compares__["d" /* listtingComparesErrorBg */],
      shipmentStatuses: __WEBPACK_IMPORTED_MODULE_7_src_stubs_shipments__["a" /* shipmentStatuses */],
      filterDateRange: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('compare', ['compareHelpers'])),
  watch: {
    '$route.query': {
      handler: function handler(newQuery) {
        var _this = this;

        this.filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.filters, newQuery);
        if (this.filters.start_date && this.filters.end_date) {
          this.filterDateRange = [this.filters.start_date, this.filters.end_date];
        }
        ['error_id', 'status'].forEach(function (key) {
          if (_this.filters[key]) {
            _this.filters[key] = Number(_this.filters[key]);
          }
        });
      },

      deep: true,
      immediate: true }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('compare', ['getCompareHeppers']), {
    removeFilter: function removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,cross_check,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1,
        start_date: '',
        end_date: ''
      })) {
        this.reloadGsTable(this.compareTable);
      }
      this.filterDateRange = '';
      this.filters = {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,cross_check,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1,
        start_date: '',
        end_date: ''
      };
    },
    checkDefaultFilter: function checkDefaultFilter(filters) {
      var _this2 = this;

      var diff = false;
      var lkeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(filters);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"])(lkeys, function (key) {
        if (filters[key] !== _this2.filters[key]) {
          _this2.diff = true;
        }
      });
      return diff;
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.compareTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.compareTable);
      }
      this.$router.push({ query: this.filters });
    }, 300),
    updateFilters: function updateFilters(data) {
      var startDate = data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data[0]) : null;
      var endDate = data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data[1]) : null;

      this.filters.start_date = startDate;
      this.filters.end_date = endDate;
      this.filter();
    },
    exportExcel: function exportExcel() {
      var _this3 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_api_compares__["a" /* exportExcel */])(this.filters).then(function (response) {
        _this3.toggleLoadding(false);
        window.location.href = response.full;
      });
    }
  }),
  mounted: function mounted() {
    this.clickToCopy();
    if (__WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters')[this.compareTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters')[this.compareTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.compareHelpers).length) {
      this.getCompareHeppers();
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.compareTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters')['compares']) {
        __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_compares__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_stubs_compares__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_stubs_shipments__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DialogAddShipmentToCompare_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DialogAddShipmentToCompare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DialogAddShipmentToCompare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UpgradeShipment__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UpgradeShipment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__UpgradeShipment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_xlsx__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_constants__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filters__ = __webpack_require__(92);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListtingCompare',
  data: function data() {
    return {
      submitting: false,
      listtingCompareTable: 'listtingCompares',
      typeofCompare: null,
      filters: {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      listtingComparesStatus: __WEBPACK_IMPORTED_MODULE_8_src_stubs_compares__["a" /* listtingComparesStatus */],
      listtingComparesStatusBg: __WEBPACK_IMPORTED_MODULE_8_src_stubs_compares__["b" /* listtingComparesStatusBg */],
      listtingComparesError: __WEBPACK_IMPORTED_MODULE_8_src_stubs_compares__["c" /* listtingComparesError */],
      listtingComparesErrorBg: __WEBPACK_IMPORTED_MODULE_8_src_stubs_compares__["d" /* listtingComparesErrorBg */],
      shipmentStatuses: __WEBPACK_IMPORTED_MODULE_9_src_stubs_shipments__["a" /* shipmentStatuses */],
      editModal: false,
      currentListtingCompare: {},
      canEdit: false,
      applyPopup: false,
      removePopup: false,
      addShipmentModal: false,
      uploadUrl: "https://api.1express.vn/api/v1" + '/cross-checks/update/' + this.$route.params.id,
      uploadHeader: {
        Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('authen').access_token
      },
      crossChecks: {},
      applyCompareSubmitting: false,
      removeErrorShipmentPopup: false,
      removeErrorShipmentSubmitting: false,
      editShipmentModal: false,
      localShipment: {},
      CROSS_CHECK_TYPE: __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('compare', ['compareHelpers', 'compareFeeHelpers', 'crossChecksHelpers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('account', ['accountInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('gsTable', ['dataTables']), {
    financeReport: function financeReport() {
      return this.crossChecks.finance ? this.crossChecks.finance.data.map(function ($row) {
        return {
          carrier: $row['short_name'].toUpperCase(),
          cod: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__filters__["vnd"])($row['carrier_cod']),
          fee: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__filters__["vnd"])($row['carrier_fee']),
          total_pay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__filters__["vnd"])($row['carrier_cod'] - $row['carrier_fee'])
        };
      }) : [];
    },
    isCheckUpgrade: function isCheckUpgrade() {
      return this.crossChecksHelpers && this.accountInfo ? this.crossChecksHelpers.allow_edit_shipments.includes(this.accountInfo.email) : false;
    },
    getCrossCheckKind: function getCrossCheckKind() {
      var _this = this;

      return function (type) {
        return _this.crossChecks.kind === type;
      };
    },
    crossCheckConfig: function crossCheckConfig() {
      var _this2 = this,
          _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].COD, {
        errorSource: function errorSource() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.compareHelpers).length ? _this2.compareHelpers.errors[_this2.filters.error_id] : '';
        },
        include: 'client,carrier,parcel,shipment.invoice'
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE, {
        errorSource: function errorSource() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.compareFeeHelpers).length ? _this2.compareFeeHelpers.errors[_this2.filters.error_id] : '';
        },
        include: 'client,carrier,parcel,shipment.invoice_fee'
      }), _ref;
    }
  }),
  components: {
    DialogAddShipmentToCompare: __WEBPACK_IMPORTED_MODULE_10__DialogAddShipmentToCompare_vue___default.a,
    UpgradeShipment: __WEBPACK_IMPORTED_MODULE_11__UpgradeShipment___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('compare', ['getCompareHeppers', 'getCompareFeeHeppers', 'getCrossChecksHeppers']), {
    removeFilter: function removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1
      })) {
        this.reloadGsTable(this.listtingCompareTable);
      }
      this.filters = {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1
      };
      this.setFiltersInclude();
    },
    checkDefaultFilter: function checkDefaultFilter(filters) {
      var _this3 = this;

      var diff = false;
      var lkeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["keys"])(filters);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["forEach"])(lkeys, function (key) {
        if (filters[key] !== _this3.filters[key]) {
          _this3.diff = true;
        }
      });
      return diff;
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.listtingCompareTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.listtingCompareTable);
      }
    }, 300),
    editListtingCompare: function editListtingCompare(compare) {
      this.currentListtingCompare = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, compare);
      this.editModal = true;
    },
    validateBeforeSubmitEditCompare: function validateBeforeSubmitEditCompare() {
      var _this4 = this;

      this.submitting = true;
      this.toggleLoadding(true);
      if (this.currentListtingCompare.cross_check) {
        this.currentListtingCompare.cross_check_id = this.currentListtingCompare.cross_check.data.id;
      }
      if (this.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["b" /* updateCompareFee */])(this.currentListtingCompare.id, this.currentListtingCompare).then(function (response) {
          switch (response.code) {
            case 200:
              _this4.$message({
                type: 'success',
                message: 'Sửa đối soát thành công'
              });
              _this4.editModal = false;
              _this4.reloadDataListCompare();
              _this4.toggleLoadding(false);
              _this4.submitting = false;
              break;
            case 422:
              var er = response.data.errors;
              var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(er)[0]]);
              _this4.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              });
              _this4.toggleLoadding(false);
              _this4.submitting = false;
              break;
            default:
              _this4.$message({
                message: 'Sửa đối soát thất bại, vui lòng kiểm tra lại thông tin.',
                type: 'error'
              });
              _this4.toggleLoadding(false);
              _this4.submitting = false;
          }
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["c" /* updateCompare */])(this.currentListtingCompare.id, this.currentListtingCompare).then(function (response) {
          switch (response.code) {
            case 200:
              _this4.$message({
                type: 'success',
                message: 'Sửa đối soát thành công'
              });
              _this4.editModal = false;
              _this4.reloadDataListCompare();
              _this4.toggleLoadding(false);
              _this4.submitting = false;
              break;
            case 422:
              var er = response.data.errors;
              var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(er)[0]]);
              _this4.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              });
              _this4.toggleLoadding(false);
              _this4.submitting = false;
              break;
            default:
              _this4.$message({
                message: 'Sửa đối soát thất bại, vui lòng kiểm tra lại thông tin.',
                type: 'error'
              });
              _this4.toggleLoadding(false);
              _this4.submitting = false;
          }
        });
      }
    },
    applyCompare: function applyCompare() {
      var _this5 = this;

      this.applyCompareSubmitting = true;
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["d" /* ApplyCrossCheck */])(this.$route.params.id).then(function (response) {
        _this5.applyCompareSubmitting = false;
        if (response.code === 200) {
          _this5.$message({
            type: 'success',
            message: 'Xác nhận đối soát thành công!'
          });
          _this5.reloadGsTableAfterRedirect({ name: 'cross-check' }, 'crossChecks');
          _this5.toggleLoadding(false);
        } else {
          _this5.toggleLoadding(false);
          _this5.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Xác nhận đối soát thất bại!'
          });
        }
      });
    },
    removeCompare: function removeCompare() {
      var _this6 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["e" /* DeleteCrossCheck */])(this.$route.params.id).then(function (response) {
        _this6.$message({
          type: 'success',
          message: 'Hủy đối soát thành công!'
        });
        _this6.reloadGsTableAfterRedirect({ name: 'cross-check' }, 'crossChecks');
        _this6.toggleLoadding(false);
      });
    },
    exportExcel: function exportExcel() {
      var _this7 = this;

      this.toggleLoadding(true);
      var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.cross_check_id = this.$route.params.id;
      if (this.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].COD) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["a" /* exportExcel */])(filters).then(function (response) {
          _this7.toggleLoadding(false);
          if (response.code == 200) {
            window.location.href = response.full;
          }
        }).catch(function () {
          _this7.toggleLoadding(false);
          _this7.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi xuất file, vui lòng thử lại sau hoặc liên hệ quản trị viên!'
          });
        });
      } else if (this.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["f" /* exportExcelFee */])(filters).then(function (response) {
          _this7.toggleLoadding(false);
          if (response.code == 200) {
            window.location.href = response.full;
          }
        }).catch(function () {
          _this7.toggleLoadding(false);
          _this7.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi xuất file, vui lòng thử lại sau hoặc liên hệ quản trị viên!'
          });
        });
      }
    },
    handleUpload: function handleUpload(response, file) {
      if (response.code === 200) {
        this.$message({
          type: 'success',
          message: 'Thêm vận đơn vào đối soát thành công!'
        });
        this.reloadDataListCompare();
        this.getCrossCheck({});
      } else {
        this.$message({
          message: 'Thêm đối soát thất bại, vui lòng kiểm tra lại thông tin.',
          type: 'error'
        });
        this.toggleLoadding(false);
      }
    },
    beforeUpload: function beforeUpload(file) {
      this.toggleLoadding(true);
    },
    deleteListtingCompare: function deleteListtingCompare(compare) {
      var _this8 = this;

      this.$confirm('Bạn chắc chắn muốn xóa đơn khỏi đối soát', 'Xóa đơn đối soát', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Thoát',
        type: 'info'
      }).then(function () {
        _this8.toggleLoadding(true);
        if (_this8.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].COD) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["g" /* deleteCompare */])(compare.id).then(function (response) {
            if (response.code === 200) {
              _this8.reloadDataListCompare();
              _this8.toggleLoadding(false);
            } else {
              _this8.toggleLoadding(false);
              _this8.$message({
                message: 'Xóa đơn đối soát thất bại',
                type: 'error'
              });
            }
          });
        } else if (_this8.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["h" /* deleteCompareFee */])(compare.id).then(function (response) {
            if (response.code === 200) {
              _this8.reloadDataListCompare();
              _this8.toggleLoadding(false);
            } else {
              _this8.toggleLoadding(false);
              _this8.$message({
                message: 'Xóa đơn đối soát thất bại',
                type: 'error'
              });
            }
          });
        }
      }).catch(function () {});
    },
    reloadDataListCompare: function reloadDataListCompare() {
      this.reloadGsTable(this.listtingCompareTable);
      this.getCrossCheck({ include: 'finance' });
    },
    removeAllErrorShipment: function removeAllErrorShipment() {
      var _this9 = this;

      this.removeErrorShipmentSubmitting = true;
      this.removeErrorShipmentPopup = false;
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["i" /* removeErrorShipment */])(this.$route.params.id, { 'error_id': this.filters.error_id }).then(function (response) {
        _this9.removeErrorShipmentSubmitting = false;
        if (response.code === 200) {
          _this9.$message({
            type: 'success',
            message: 'Xoá tất cả ' + _this9.getErrorText() + ' thành công!'
          });
          _this9.reloadDataListCompare();
          _this9.toggleLoadding(false);
        } else {
          _this9.toggleLoadding(false);
          _this9.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Xoá tất cả ' + _this9.getErrorText() + ' thất bại!'
          });
        }
      });
    },
    resyncCode: function resyncCode() {
      var _this10 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["j" /* resyncingCode */])(this.$route.params.id, { 'error_id': this.filters.error_id }).then(function (response) {
        if (response.status === 'success') {
          _this10.toggleLoadding(false);
          _this10.$message({
            type: 'success',
            message: 'Đồng bộ code thành công!'
          });
          _this10.reloadDataListCompare();
        } else {
          _this10.toggleLoadding(false);
          _this10.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Đồng bộ code thất bại!'
          });
        }
      }).catch(function (err) {
        _this10.toggleLoadding(false);
        _this10.$message({
          type: 'error',
          message: err.message || 'Kết nối lỗi vui lòng thử lại!'
        });
      });
    },
    updateWeight: function updateWeight() {
      var _this11 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["k" /* updateWeight */])(this.$route.params.id, { 'error_id': this.filters.error_id }).then(function (response) {
        if (response.status === 'success') {
          _this11.toggleLoadding(false);
          _this11.$message({
            type: 'success',
            message: 'Đồng bộ cân thành công!'
          });
          _this11.reloadDataListCompare();
        } else {
          _this11.toggleLoadding(false);
          _this11.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Đồng bộ cân thất bại!'
          });
        }
      }).catch(function (err) {
        _this11.toggleLoadding(false);
        _this11.$message({
          type: 'error',
          message: err.message || 'Kết nối lỗi vui lòng thử lại!'
        });
      });
    },
    updateFeeCarrier: function updateFeeCarrier() {
      var _this12 = this;

      this.$confirm('Bạn chắc chắn muốn cập nhật theo phí hãng', 'Cập nhật theo phí hãng', {
        confirmButtonText: 'Xuất & cập nhật phí',
        cancelButtonText: 'Thoát',
        type: 'info'
      }).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_api__["a" /* getFromUrl */])('' + _this12.typeofCompare + _this12.$route.params.id, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this12.filters, { limit: -1 })).then(function (response) {
          if (response.code === 200 && response.data.length > 0) {
            _this12.exportToExcel(response.data);
            _this12.toggleLoadding(true);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["l" /* updateFeeByCarrier */])(_this12.$route.params.id, { 'error_id': _this12.filters.error_id }).then(function (response) {
              if (response.status === 'success') {
                _this12.toggleLoadding(false);
                _this12.$message({
                  type: 'success',
                  message: 'Cập nhật theo phí hãng thành công!'
                });
                _this12.reloadDataListCompare();
              } else {
                _this12.toggleLoadding(false);
                _this12.$message({
                  type: 'error',
                  message: response.data.message ? response.data.message : 'Cập nhật theo phí hãng thất bại!'
                });
              }
            });
          } else {
            _this12.$message({
              type: 'error',
              message: 'Không có dữ liệu'
            });
          }
        });
      }).catch(function () {});
    },
    isOverweight: function isOverweight(scope) {
      return parseInt(scope.row.parcel.data.weight) > parseInt(scope.row.parcel.data.real_weight) ? scope.row.parcel.data.weight : scope.row.parcel.data.real_weight;
    },
    verifyCrossCheck: function verifyCrossCheck() {
      var _this13 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["m" /* verifyCrossCheck */])(this.$route.params.id, { limit: 1000 }).then(function (response) {
        if (response.status === 'success') {
          if (response.data.count_update && response.data.count_update > 0) {
            _this13.verifyCrossCheck();
          } else {
            _this13.toggleLoadding(false);
            _this13.crossChecks = response.data;
            _this13.reloadDataListCompare();
            _this13.$message({
              type: 'success',
              message: 'Duyệt đối soát xong, có ' + _this13.crossChecks.num_compare_error + ' đơn lỗi trong phiên đối soát này, vui lòng kiểm tra.'
            });
          }
        } else {
          _this13.toggleLoadding(false);
          _this13.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Duyệt đối soát thất bại!'
          });
        }
      });
    },
    countErrorCompare: function countErrorCompare(errorId) {
      var errorType = this.crossChecks.error_list ? this.crossChecks.error_list.filter(function (err) {
        return err.error == errorId;
      }) : [];
      return errorType[0] ? errorType[0].count : 0;
    },
    closeModalShipment: function closeModalShipment() {
      this.localShipment = {};
    },
    editShipmentSuccess: function editShipmentSuccess() {
      this.editShipmentModal = false;
      this.reloadDataListCompare();
    },
    showEditShipment: function showEditShipment(shipment) {
      this.localShipment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, shipment.data);
      this.editShipmentModal = true;
    },
    exportToExcel: function exportToExcel(data) {
      var _this14 = this;

      var formattedData = data.map(function (item) {
        if (_this14.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].COD) {
          return {
            'Mã vận đơn': item.shipment && item.shipment.data.id ? item.shipment.data.id : '',
            'Mã HVC': item.code,
            'Tổng phí đối soát': item.total_fee,
            'Tổng phí vận đơn': item.shipment && item.shipment.data.total_fee ? item.shipment.data.total_fee : 0,
            'Ngày tạo': item.shipment.data.created_at,
            'Ngày giao': item.shipment.data.delivery_at,
            'Ngày chuyển hoàn': item.shipment.data.returned_at
          };
        } else if (_this14.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE) {
          var result = item.shipment.data.status_txt;
          if (item.shipment.data.is_return) {
            result += ' (Chuyển hoàn)';
          }
          if (item.shipment.data.is_part_delivery) {
            result += ' (Giao một phần)';
          }
          if (item.shipment.data.is_lost) {
            result += ' (Thất lạc)';
          }
          return {
            'Mã HVC': item.code,
            'Tổng phí đối soát lần 1': item.last_total_fee,
            'Tổng phí đối soát': item.total_fee,
            'Chênh lệch': _this14.differenceFee(item.last_total_fee, item.total_fee),
            'Tổng phí vận đơn': item.shipment && item.shipment.data.total_fee ? item.shipment.data.total_fee : 0,
            'Trạng thái đơn ': result,
            'Ngày tạo': item.shipment.data.created_at,
            'Ngày giao': item.shipment.data.delivery_at,
            'Ngày chuyển hoàn': item.shipment.data.returned_at
          };
        } else if (_this14.crossChecks.kind === __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE1) {
          return {
            'Mã vận đơn': item.shipment && item.shipment.data.id ? item.shipment.data.id : '',
            'Mã HVC': item.code,
            'Tổng phí đối soát': item.total_fee,
            'Tổng phí vận đơn': item.shipment && item.shipment.data.total_fee ? item.shipment.data.total_fee : 0,
            'Ngày tạo': item.shipment.data.created_at,
            'Ngày giao': item.shipment.data.delivery_at,
            'Ngày chuyển hoàn': item.shipment.data.returned_at
          };
        }
      });

      this.formattedDataExcel(formattedData, this.convertString(this.getErrorText()));
    },
    getCrossCheck: function getCrossCheck(params) {
      var _this15 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_compares__["n" /* getCrossCheck */])(this.$route.params.id, params).then(function (response) {
        if (response.code === 200) {
          _this15.canEdit = !response.data.status;
          _this15.crossChecks = response.data;
          switch (_this15.crossChecks.kind) {
            case __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].COD:
              _this15.typeofCompare = 'compares/';
              _this15.filters.include = 'client,carrier,parcel,shipment.invoice';
              break;
            case __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE:
              _this15.typeofCompare = 'compare-fees/';
              _this15.filters.include = 'client,carrier,parcel,shipment.invoice_fee';
              break;
            case __WEBPACK_IMPORTED_MODULE_14_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE1:
              _this15.typeofCompare = 'compares/';
              _this15.filters.include = 'client,carrier,parcel,shipment.invoice';
              break;
          }
        }
      });
    },
    exportExcelCompare: function exportExcelCompare() {
      var _this16 = this;

      this.$confirm('Bạn chắc chắn muốn xuất danh sách chưa đối soát lần 1', 'Xuất danh sách đối soát lần 1', {
        confirmButtonText: 'Xuất danh sách',
        cancelButtonText: 'Thoát',
        type: 'info'
      }).then(function () {
        _this16.toggleLoadding(true);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_api__["a" /* getFromUrl */])('' + _this16.typeofCompare + _this16.$route.params.id, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this16.filters, { limit: -1 })).then(function (response) {
          if (response.code === 200 && response.data.length > 0) {
            _this16.exportToExcel(response.data);
            _this16.toggleLoadding(false);
          } else {
            _this16.toggleLoadding(false);
            _this16.$message({
              type: 'error',
              message: 'Không có dữ liệu'
            });
          }
        });
      }).catch(function () {});
    },
    formattedDataExcel: function formattedDataExcel(formattedData, name) {
      var ws = __WEBPACK_IMPORTED_MODULE_12_xlsx__["utils"].json_to_sheet(formattedData);

      var wb = __WEBPACK_IMPORTED_MODULE_12_xlsx__["utils"].book_new();
      __WEBPACK_IMPORTED_MODULE_12_xlsx__["utils"].book_append_sheet(wb, ws, 'Danh sách');

      var excelBuffer = __WEBPACK_IMPORTED_MODULE_12_xlsx__["write"](wb, { bookType: 'xlsx', type: 'array' });
      var dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

      var url = URL.createObjectURL(dataBlob);
      var a = document.createElement('a');
      a.href = url;
      a.download = '' + name + this.$route.params.id + '.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    },
    getErrorText: function getErrorText() {
      var config = this.crossCheckConfig[this.crossChecks.kind];
      return config ? config.errorSource() : '';
    },
    setFiltersInclude: function setFiltersInclude() {
      var config = this.crossCheckConfig[this.crossChecks.kind];
      if (config) this.filters.include = config.include;
    },
    convertString: function convertString(str) {
      return 'danh_sach_' + str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/\s+/g, "_") + '_';
    },
    differenceFee: function differenceFee(last_total_fee, total_fee) {
      return total_fee - last_total_fee;
    }
  }),
  mounted: function mounted() {
    var _this17 = this;

    this.clickToCopy();
    if (__WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('filters')[this.listtingCompareTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('filters')[this.listtingCompareTable];
      setTimeout(function () {
        _this17.filters.error_id = -1;
        __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.compareHelpers).length) {
      this.getCompareHeppers();
    }
    if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.compareFeeHelpers).length) {
      this.getCompareFeeHeppers();
    }
    if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.crossChecksHelpers).length) {
      this.getCrossChecksHeppers();
    }
    this.getCrossCheck({});
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.listtingCompareTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.get('filters')['listtingCompares']) {
        __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_6_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_shipments__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpgradeShipment',
  props: {
    shipmentId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var validatorParcelWeight = function validatorParcelWeight(rule, value, callback) {
      if (value === '') {
        callback(new Error('Cân nặng không thể để trống'));
      }if (value < 50) {
        callback(new Error('Cân nặng không nhỏ hơn 50g'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        'receiver.name': [{ required: true, message: 'Tên người nhận không thể để trống', trigger: 'change' }, { min: 2, max: 255, message: 'Tên người nhận phải chứa từ 2 đến 255 ký tự', trigger: 'change' }],
        'receiver.phone': [{ required: true, message: 'Điện thoại người nhận không thể để trống', trigger: 'change' }, { min: 8, max: 12, message: 'Điện thoại người nhận phải chứa từ 8 đến 12 ký tự', trigger: 'change' }],
        'address_from.city_code': [{ required: true, message: 'Tỉnh thành đi không thể để trống', trigger: 'change' }],
        'address_from.district_code': [{ required: true, message: 'Quận huyện đi không thể để trống', trigger: 'change' }],
        'address_from.ward_id': [{ required: true, message: 'Phường xã đi không thể để trống', trigger: 'change' }],
        'address_from.street': [{ required: true, message: 'Địa chỉ đi không thể để trống', trigger: 'change' }, { min: 2, max: 255, message: 'Địa chỉ đi phải chứa từ 2 đến 255 ký tự', trigger: 'change' }],
        'picker.name': [{ required: true, message: 'Tên người gửi không thể để trống', trigger: 'change' }, { min: 2, max: 255, message: 'Tên người gửi phải chứa từ 2 đến 255 ký tự', trigger: 'change' }],
        'picker.phone': [{ required: true, message: 'Điện thoại người gửi không thể để trống', trigger: 'change' }, { min: 8, max: 12, message: 'Điện thoại người gửi phải chứa từ 8 đến 12 ký tự', trigger: 'change' }],
        'address_to.city_code': [{ required: true, message: 'Tỉnh thành đến không thể để trống', trigger: 'change' }],
        'address_to.district_code': [{ required: true, message: 'Quận huyện đến không thể để trống', trigger: 'change' }],
        'address_to.street': [{ required: true, message: 'Địa chỉ đến không thể để trống', trigger: 'change' }, { min: 5, max: 255, message: 'Địa chỉ đến phải chứa từ 5 đến 255 ký tự', trigger: 'change' }],
        'parcel.weight': [{ validator: validatorParcelWeight, trigger: 'change' }],
        'parcel.name': [{ required: true, message: 'Tên gói hàng không được để trống', trigger: 'change' }],
        'note_update': [{ required: true, message: 'Ghi chú cập nhật không được để trống', trigger: 'change' }]
      },
      submitting: false,
      localShipment: {},
      isCoin: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('shipment', ['getShipmentHelpers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('city', ['getAllCity']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('district', ['getAllDistrictTo', 'getAllDistrictFrom']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ward', ['getAllWardFrom', 'getAllWardTo']), {
    validatorBeforeSubmit: function validatorBeforeSubmit(autoSend) {
      var _this = this;

      if (autoSend === 1) {
        this.localShipment.auto_send = 1;
      } else {
        this.localShipment.auto_send = 0;
      }
      this.$refs['create-shipment-form'].validate(function (valid) {
        if (valid) {
          _this.submitShipment();
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    submitShipment: function submitShipment() {
      var _this2 = this;

      var print = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.toggleLoadding(true);
      this.changedData = false;
      this.watching = false;
      this.submitting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_shipments__["a" /* hardUpdateShipment */])(this.localShipment.id, this.localShipment).then(function (response) {
        _this2.toggleLoadding(false);
        _this2.submitting = false;
        switch (response.code) {
          case 200:
            _this2.$store.dispatch('showNotify', {
              title: 'Sửa thành công!',
              body: 'Cập nhật thông tin vận đơn thành công!',
              type: 'success'
            });
            _this2.$emit('edit-shipment-success');
            break;
          case 422:
            var er = response.data.errors;
            var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);

            _this2.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: message,
              type: 'warning'
            });
            break;
          case 402:
            _this2.$store.dispatch('showNotify', {
              title: 'Sửa thành công!',
              body: response.message,
              type: 'warning'
            });
            _this2.$emit('edit-shipment-success');
            break;
          default:
            _this2.$store.dispatch('showNotify', {
              title: 'Sửa thất bại!',
              body: 'Cập nhật thông tin vận đơn thất bại vui lòng kiểm tra lại thông tin',
              type: 'danger'
            });
        }
      });
    },
    setNewShipment: function setNewShipment() {
      this.localShipment = {
        id: 0,
        address_from: {
          city_code: '',
          district_code: '',
          ward_id: '',
          street: ''
        },
        address_to: {
          city_code: '',
          district_code: '',
          ward_id: '',
          street: ''
        },
        picker: {
          name: '',
          phone: ''
        },
        receiver: {
          name: '',
          phone: ''
        },
        parcel: {
          quantity: 1,
          cod_amount: 0,
          length: 0,
          width: 0,
          height: 0,
          weight: 0,
          amount: 0,
          name: ''
        },
        metadata: '',
        return_type: 0,
        payer: 0,
        price_table_id: '',
        total_amount_carrier: 0,
        total_amount_shop: 0,
        total_fee: 0,
        promo_code: '',
        discount: 0,
        note_update: '',
        over_weight_fee: 0,
        re_delivery_fee: 0,
        update_info_fee: 0,
        is_return: 0,
        part_delivery: 0,
        is_lost: 0,
        is_error: 0,
        update_to_carrier: 0
      };
    },
    removeZero: function removeZero(key) {
      if (parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.localShipment, key)) === 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.localShipment, key, '');
      }
    },
    addZero: function addZero(key) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.localShipment, key) === '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.localShipment, key, 0);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('shipment', ['shipmentHelpers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('city', ['cities']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('district', ['districtTo', 'districtFrom']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('ward', ['wardFrom', 'wardTo'])),
  mounted: function mounted() {
    var _this3 = this;

    this.setNewShipment();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_shipments__["b" /* getShipment */])(this.shipmentId, { include: 'address_from,address_to,picker,receiver,carrier,service,parcel,price_table,promotion' }).then(function (response) {
      if (response.code === 200) {
        _this3.localShipment.address_from = response.data.address_from.data;
        _this3.localShipment.address_from.ward_id = response.data.address_from.data.ward_id.toString();
        _this3.localShipment.address_to = response.data.address_to.data;
        _this3.localShipment.address_to.ward_id = response.data.address_to.data.ward_id.toString();
        _this3.localShipment.parcel = response.data.parcel.data;
        _this3.localShipment.parcel.name = response.data.parcel.data.name ? response.data.parcel.data.name : 'gói hàng';
        _this3.localShipment.picker = response.data.picker.data;
        _this3.localShipment.receiver = response.data.receiver.data;
        _this3.localShipment.return_type = response.data.return_type;
        _this3.localShipment.payer = response.data.payer;
        _this3.localShipment.client_id = response.data.client_id;
        _this3.localShipment.price_table_id = response.data.price_table_id;
        _this3.localShipment.promo_code = response.data.promotion.data.code ? response.data.promotion.data.code : '';
        _this3.localShipment.metadata = response.data.metadata;
        _this3.localShipment.note_update = response.data.note_update;
        _this3.localShipment.over_weight_fee = response.data.overweight_fee;
        _this3.localShipment.re_delivery_fee = response.data.re_delivery_fee;
        _this3.localShipment.update_info_fee = response.data.update_info_fee;
        _this3.localShipment.is_return = response.data.is_return;
        _this3.localShipment.part_delivery = response.data.is_part_delivery;
        _this3.localShipment.is_lost = response.data.is_lost;
        _this3.localShipment.is_error = response.data.is_error;
        _this3.localShipment.id = response.data.id;
        _this3.localShipment.update_to_carrier = response.data.can_update_cod_to_carrier;
        _this3.showUpdateToCarrier = response.data.can_update_cod_to_carrier;
        _this3.getAllDistrictTo({ city_code: _this3.localShipment.address_to.city_code, limit: -1, sort: 'name:1' });
        _this3.getAllWardTo({ district_code: _this3.localShipment.address_to.district_code, limit: -1, sort: 'name:1' });
        _this3.getAllDistrictFrom({ city_code: _this3.localShipment.address_from.city_code, limit: -1, sort: 'name:1' });
        _this3.getAllWardFrom({ district_code: _this3.localShipment.address_from.district_code, limit: -1, sort: 'name:1' });
        setTimeout(function () {
          _this3.watching = true;
        }, 200);
      } else {
        _this3.$router.push({ name: 'shipment' });
        _this3.$store.dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Vận đơn không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
      }
    });

    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' });
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.shipmentHelpers).length) {
      this.getShipmentHelpers();
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_stubs_shipments__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_stubs_carrier__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_helpers__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      carrierShortName: __WEBPACK_IMPORTED_MODULE_6_src_stubs_carrier__["a" /* carrierShortName */],
      shipmentStatuses: __WEBPACK_IMPORTED_MODULE_5_src_stubs_shipments__["a" /* shipmentStatuses */],
      filterDateRange: '',
      filters: {
        start_date: __WEBPACK_IMPORTED_MODULE_10_moment___default()().date(1).format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('YYYY-MM-DD'),
        status: -1,
        carrier_id: '',
        sale_id: '',
        vip: ''
      },
      topUserAllShipment: [],
      topUserReturnShipment: [],
      allUserHasShipment: [],
      view: 'day',
      detailShopModal: false,
      detailShipmentShop: {},
      currentShop: {},
      allUserHasShipmentModal: false,
      topDistrictTopShipment: [],
      topDistrictTopUser: [],
      matrixShipmentByCity: [],
      interprovinceShipment: [],
      allShipmentFromCity: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('carrier', ['carriers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('shipment', ['shipmentHelpers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('admin', ['administrators'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('carrier', ['getAllCarriers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('shipment', ['getShipmentHelpers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('admin', ['getAllAdmins']), {
    updateFilters: function updateFilters(data) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data[0]) === this.filters.start_date && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data[1]) === this.filters.end_date) {
        return false;
      }
      this.filters.start_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data[0]);
      this.filters.end_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data[1]);
      this.filter();
    },
    filter: function filter() {
      this.drawStatisticClientByDay();
      this.drawTop10UserWithAllShipment();
      this.drawTop10UserWithReturnShipment();
      this.drawProportion();
      this.drawProportionPie();
      this.drawStatisticCodAmount();
      this.drawProfit();
      this.drawByCarierPie();

      this.drawTotalShop();
      this.drawTotalSource();
      this.drawTop10DistrictTopShipment();
      this.drawTop10DistrictTopUser();
      this.drawMatrixShipmentByCity();
      this.drawInterprovinceShipment();
      this.drawAllShipmentFromCity();
    },
    changeView: function changeView() {
      this.drawStatisticClientByDay();
      this.drawStatisticCodAmount();
      this.drawProfit();
      this.drawProportion();
      this.drawMatrixShipmentByCity();
      this.drawInterprovinceShipment();
      this.drawAllShipmentFromCity();
    },
    formatDate: function formatDate(data) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(data, format);
    },
    drawStatisticStatus: function drawStatisticStatus() {
      var _this = this;

      this.toggleLoadding(true);
      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["a" /* getByStatus */])(filters).then(function (response) {
        _this.toggleLoadding(false);
        var title = 'Số lượng vận đơn theo trạng thái';
        if (_this.filters.start_date && _this.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (response.code === 200) {
          var colors = [];
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["forEach"])(response.data.statuses, function (value, key) {
            if (value === -1) {
              colors.push('#0E6EB8');
            } else {
              colors.push(__WEBPACK_IMPORTED_MODULE_5_src_stubs_shipments__["b" /* shipmentStatusesBg */][value]);
            }
          });
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-status',
              type: 'column'
            },
            title: {
              text: 'Số lượng vận đơn theo trạng thái'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: 'Số vận đơn (vận đơn)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f} vận đơn</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              },
              series: {
                colorByPoint: true,
                colors: colors
              }
            },
            series: [{
              showInLegend: false,
              name: 'Vận đơn',
              data: response.data.series.data
            }]
          });
          window.chart = chart;
        } else {
          document.getElementById('statistic-status').innerHTML = '';
        }
      });
    },
    drawStatisticByTime: function drawStatisticByTime() {
      var _this2 = this;

      this.toggleLoadding(true);
      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["b" /* getByTime */])(filters).then(function (response) {
        _this2.toggleLoadding(false);
        var title = 'Số lượng vận đơn theo thời gian';
        if (_this2.filters.start_date && _this2.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this2.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this2.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (response.code === 200) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-status-by-day',
              type: 'line'
            },
            title: {
              text: 'Số lượng vận đơn theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: 'Số vận đơn (vận đơn)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f} vận đơn</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              },
              series: {
                colorByPoint: true,
                colors: _this2.filters.status === -1 ? ['#0E6EB8'] : [__WEBPACK_IMPORTED_MODULE_5_src_stubs_shipments__["b" /* shipmentStatusesBg */][_this2.filters.status]],
                lineColor: _this2.filters.status === -1 ? '#0E6EB8' : __WEBPACK_IMPORTED_MODULE_5_src_stubs_shipments__["b" /* shipmentStatusesBg */][_this2.filters.status]
              }
            },
            series: [{
              showInLegend: false,
              name: 'Vận đơn',
              data: response.data.series.data
            }]
          });
          window.chart = chart;
        } else {
          document.getElementById('statistic-status-by-day').innerHTML = '';
        }
      });
    },
    drawStatisticClientByDay: function drawStatisticClientByDay() {
      var _this3 = this;

      this.toggleLoadding(true);
      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["c" /* getClientByDay */])(filters).then(function (response) {
        _this3.toggleLoadding(false);
        var title = 'Số lượng shop đăng ký theo thời gian';
        if (_this3.filters.start_date && _this3.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this3.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this3.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (response.code === 200) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-client',
              type: 'line'
            },
            title: {
              text: 'Số lượng shop đăng ký theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: 'Số shop (shop)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f} shop</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            series: response.data.series
          });
          window.chart = chart;
        } else {
          document.getElementById('statistic-status-by-day').innerHTML = '';
        }
      });
    },
    drawTop10UserWithAllShipment: function drawTop10UserWithAllShipment() {
      var _this4 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["d" /* getTop10User */])(filters).then(function (response) {
        if (response.code === 200) {
          _this4.topUserAllShipment = response.data;
          _this4.toggleLoadding(false);
        } else {
          _this4.topUserAllShipment = [];
          _this4.toggleLoadding(false);
        }
      });
    },
    drawTop10UserWithReturnShipment: function drawTop10UserWithReturnShipment() {
      var _this5 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.is_return = true;
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["d" /* getTop10User */])(filters).then(function (response) {
        if (response.code === 200) {
          _this5.toggleLoadding(false);
          _this5.topUserReturnShipment = response.data;
        } else {
          _this5.topUserReturnShipment = [];
          _this5.toggleLoadding(false);
        }
      });
    },
    drawAllUserHasShipment: function drawAllUserHasShipment() {
      var _this6 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["e" /* getAllUserHasShipments */])(filters).then(function (response) {
        if (response.code === 200) {
          _this6.toggleLoadding(false);
          _this6.allUserHasShipment = response.data;
          _this6.allUserHasShipmentModal = true;
        } else {
          _this6.allUserHasShipment = [];
          _this6.toggleLoadding(false);
          _this6.allUserHasShipmentModal = true;
        }
      });
    },
    drawProportion: function drawProportion() {
      var _this7 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["f" /* getProportion */])(filters).then(function (response) {
        var title = 'Tỷ lệ phân bố vận đơn theo thời gian';
        if (_this7.filters.start_date && _this7.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this7.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this7.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-proportion',
              type: 'line'
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo thời gian',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f} đơn</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            series: response.data.series
          });
          _this7.log = chart;
        } else {
          document.getElementById('statistic-proportion').innerHTML = '';
        }
      });
    },
    drawStatisticCodAmount: function drawStatisticCodAmount() {
      var _this8 = this;

      this.toggleLoadding(true);
      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["g" /* getTotalCod */])(filters).then(function (response) {
        _this8.toggleLoadding(false);
        var title = 'Tổng tiền COD theo thời gian';
        if (_this8.filters.start_date && _this8.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this8.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this8.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (response.code === 200) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-cod-amount',
              type: 'line'
            },
            title: {
              text: 'Tổng tiền COD theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              title: {
                text: 'VNĐ'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b class="text-red">{point.y}</b>đ</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              line: {
                showInLegend: true
              }
            },
            series: response.data.series
          });
          window.chart = chart;
        } else {
          document.getElementById('statistic-cod-amount').innerHTML = '';
        }
      });
    },
    drawProfit: function drawProfit() {
      var _this9 = this;

      this.toggleLoadding(true);
      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["h" /* getProfit */])(filters).then(function (response) {
        _this9.toggleLoadding(false);
        var title = 'Tổng doanh thu theo thời gian';
        if (_this9.filters.start_date && _this9.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this9.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this9.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (response.code === 200) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-profit',
              type: 'line'
            },
            title: {
              text: 'Tổng doanh thu theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              title: {
                text: 'VNĐ'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b class="text-red">{point.y}</b>đ</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              line: {
                showInLegend: true
              }
            },
            series: response.data.series
          });
          window.chart = chart;
        } else {
          document.getElementById('statistic-cod-amount').innerHTML = '';
        }
      });
    },
    drawProportionPie: function drawProportionPie() {
      var _this10 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["i" /* getProportionPie */])(this.filters).then(function (response) {
        var title = 'Tỷ lệ phân bố vận đơn theo thời gian';
        if (_this10.filters.start_date && _this10.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this10.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this10.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-proportion-pie',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>' + '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          });
          _this10.log = chart;
        } else {
          document.getElementById('statistic-proportion-pie').innerHTML = '';
        }
      });
    },
    drawByCarrier: function drawByCarrier() {
      var _this11 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["j" /* getByCarrier */])(this.filters).then(function (response) {
        var title = 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển';
        if (_this11.filters.start_date && _this11.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this11.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this11.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-carrier',
              type: 'column'
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          });
          _this11.log = chart;
        } else {
          document.getElementById('statistic-carrier').innerHTML = '';
        }
      });
    },
    drawTotalShop: function drawTotalShop() {
      var _this12 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["k" /* getTotalShop */])(this.filters).then(function (response) {
        var title = 'Tỷ lệ phân bố shop theo vùng miền';
        if (_this12.filters.start_date && _this12.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this12.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this12.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-total-shop',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố shop theo vùng miền',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Shop'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>' + '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          });
          _this12.log = chart;
        } else {
          if (document.getElementById('statistic-total-shop')) {
            document.getElementById('statistic-total-shop').innerHTML = '';
          }
        }
      });
    },
    drawTotalSource: function drawTotalSource() {
      var _this13 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["l" /* getTotalSource */])(this.filters).then(function (response) {
        var title = 'Tỷ lệ phân bố vận đơn theo nguồn tạo đơn';
        if (_this13.filters.start_date && _this13.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this13.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this13.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-total-source',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo nguồn tạo đơn',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Shop'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>' + '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          });
          _this13.log = chart;
        } else {
          document.getElementById('statistic-total-source').innerHTML = '';
        }
      });
    },
    drawByCarierPie: function drawByCarierPie() {
      var _this14 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["m" /* getByCarrierPie */])(this.filters).then(function (response) {
        var title = 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển';
        if (_this14.filters.start_date && _this14.filters.end_date) {
          title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this14.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this14.filters.end_date, 'DD-MM-YYYY');
        } else {
          title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
            chart: {
              renderTo: 'statistic-carrier-pie',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>' + '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          });
          _this14.log = chart;
        } else {
          document.getElementById('statistic-carrier-pie').innerHTML = '';
        }
      });
    },
    showDetailShop: function showDetailShop(shop) {
      var _this15 = this;

      if (shop.client && shop.client.data.id) {
        this.currentShop = shop.client.data;
        var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
        filters.view = this.view;
        filters.client_id = shop.client.data.id;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["f" /* getProportion */])(filters).then(function (response) {
          if (response.code === 200) {
            _this15.detailShopModal = true;
            var title = 'Tỷ lệ phân bố vận đơn theo thời gian';
            if (_this15.filters.start_date && _this15.filters.end_date) {
              title += ' t\u1EEB ng\xE0y  ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this15.filters.start_date, 'DD-MM-YYYY') + ' \u0111\u1EBFn ng\xE0y ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(_this15.filters.end_date, 'DD-MM-YYYY');
            } else {
              title += ' ngày ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_src_helpers__["a" /* formatDate */])(new Date(), 'DD-MM-YYYY');
            }
            if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
              _this15.$nextTick(function () {
                var chart = new __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a.Chart({
                  chart: {
                    renderTo: 'statistic-detail-shopment-shop',
                    type: 'line'
                  },
                  title: {
                    text: 'Tỷ lệ phân bố vận đơn theo thời gian',
                    x: -20
                  },
                  subtitle: {
                    text: title,
                    x: -20
                  },
                  xAxis: {
                    categories: response.data.categories
                  },
                  yAxis: {
                    title: {
                      text: 'Vận đơn'
                    },
                    allowDecimals: false,
                    plotLines: [{
                      value: 0,
                      width: 1,
                      color: '#808080'
                    }]
                  },
                  tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f} đơn</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                  },
                  legend: {
                    align: 'right',
                    verticalAlign: 'bottom'
                  },
                  plotOptions: {
                    column: {
                      pointPadding: 0.2,
                      borderWidth: 0
                    }
                  },
                  series: response.data.series
                });
                _this15.log = chart;
              });
            } else {
              document.getElementById('statistic-detail-shopment-shop').innerHTML = '';
            }
          }
        });
      }
    },
    drawTop10DistrictTopShipment: function drawTop10DistrictTopShipment() {
      var _this16 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["n" /* getTop10DistrictTopShipment */])(filters).then(function (response) {
        if (response.code === 200) {
          _this16.topDistrictTopShipment = response.data;
          _this16.toggleLoadding(false);
        } else {
          _this16.topDistrictTopShipment = [];
          _this16.toggleLoadding(false);
        }
      });
    },
    drawTop10DistrictTopUser: function drawTop10DistrictTopUser() {
      var _this17 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["o" /* getTop10DistrictTopUser */])(filters).then(function (response) {
        if (response.code === 200) {
          _this17.topDistrictTopUser = response.data;
          _this17.toggleLoadding(false);
        } else {
          _this17.topDistrictTopUser = [];
          _this17.toggleLoadding(false);
        }
      });
    },
    drawMatrixShipmentByCity: function drawMatrixShipmentByCity() {
      var _this18 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["p" /* getMatrixShipmentByCity */])(filters).then(function (response) {
        if (response.code === 200) {
          _this18.matrixShipmentByCity = response.data;
          _this18.toggleLoadding(false);
        } else {
          _this18.matrixShipmentByCity = [];
          _this18.toggleLoadding(false);
        }
      });
    },
    drawInterprovinceShipment: function drawInterprovinceShipment() {
      var _this19 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["q" /* getInterprovinceShipment */])(filters).then(function (response) {
        if (response.code === 200) {
          _this19.interprovinceShipment = response.data;
          _this19.toggleLoadding(false);
        } else {
          _this19.interprovinceShipment = [];
          _this19.toggleLoadding(false);
        }
      });
    },
    drawAllShipmentFromCity: function drawAllShipmentFromCity() {
      var _this20 = this;

      var filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.filters);
      filters.view = this.view;
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_dashboard__["r" /* getAllShipmentFromCity */])(filters).then(function (response) {
        if (response.code === 200) {
          _this20.allShipmentFromCity = response.data;
          _this20.toggleLoadding(false);
        } else {
          _this20.allShipmentFromCity = [];
          _this20.toggleLoadding(false);
        }
      });
    }
  }),
  mounted: function mounted() {
    var _this21 = this;

    if (!this.carriers.length) {
      this.getAllCarriers({ limit: -1 });
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.shipmentHelpers).length) {
      this.getShipmentHelpers();
    }
    if (!this.administrators.length) {
      this.getAllAdmins({ role_name: 'saler', limit: -1 });
    }
    this.$nextTick(function () {
      _this21.filter();
    });
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_stubs_shipments__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_invoice__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DetailInvoice',
  data: function data() {
    return {
      confirmPopup: false,
      payPopup: false,
      returnPopup: false,
      emailPopup: false,
      shipmentStatuses: __WEBPACK_IMPORTED_MODULE_2_src_stubs_shipments__["a" /* shipmentStatuses */],

      dialogPaymentExtra: false,
      pendingReturn: false,
      doHardPayment: false,
      payment_extra: {
        payment: '',
        note: ''
      },
      rulePaymentExtra: {
        payment: [{ required: true, message: 'Vui lòng nhập số tiền.', trigger: 'blur' }],
        note: [{ required: true, message: 'Vui lòng nhập lý do cấn trừ', trigger: 'blur' }]
      },
      isLoadingPayment: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('invoice', ['getInvoiceDetail']), {
    confirmInvoice: function confirmInvoice() {
      var _this = this;

      this.confirmPopup = false;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["e" /* confirmInvoice */])(this.invoice.id).then(function (response) {
        if (response.code === 200) {
          _this.$message({
            type: 'success',
            message: 'Xác nhận phiếu chi thành công'
          });
          _this.getInvoiceDetail({ id: _this.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } });
        } else {
          _this.$message({
            type: 'error',
            message: 'Xác nhận phiếu chi thất bại'
          });
        }
      });
    },
    payInvoice: function payInvoice() {
      var _this2 = this;

      this.payPopup = false;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["f" /* paymentInvoice */])(this.invoice.id).then(function (response) {
        switch (response.code) {
          case 200:
            _this2.$message({
              type: 'success',
              message: 'Thanh toán phiếu chi thành công'
            });
            _this2.getInvoiceDetail({ id: _this2.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } });
            break;
          case 422:
            _this2.$message({
              type: 'error',
              message: response.data.errors
            });
            break;
          default:
            _this2.$message({
              type: 'error',
              message: 'Thanh toán phiếu chi thất bại'
            });
        }
      });
    },
    returnInvoice: function returnInvoice(invoice) {
      var _this3 = this;

      this.pendingReturn = true;
      this.returnPopup = false;
      var dataReturn = {
        type: 0,
        relation_id: this.invoice.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["d" /* returnInvoice */])(invoice.id, dataReturn).then(function (response) {
        if (response.code === 200) {
          _this3.$message({
            type: 'success',
            message: 'Truy thu công nợ phiếu chi thành công'
          });
          _this3.getInvoiceDetail({ id: _this3.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } });

          _this3.pendingReturn = false;
        } else {
          _this3.$message({
            type: 'error',
            message: 'Truy thu công nợ phiếu chi thất bại'
          });
          _this3.pendingReturn = false;
        }
      });
    },
    returnHandler: function returnHandler() {
      this.dialogReturner = true;
    },
    returnedHandler: function returnedHandler() {
      this.dialogReturned = true;
    },
    returnsHandler: function returnsHandler() {
      this.dialogReturns = true;
    },
    showpaymentExtra: function showpaymentExtra() {
      this.dialogPaymentExtra = true;
    },
    detailInvoiceBlankTab: function detailInvoiceBlankTab(id) {
      window.open('/invoice/' + id);
    },
    sendEmail: function sendEmail() {
      var _this4 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["g" /* resendEmail */])(this.invoice.id).then(function (response) {
        if (response.code === 200) {
          _this4.$message({
            type: 'success',
            message: 'Gửi email thành công'
          });
          _this4.toggleLoadding(false);
        } else {
          _this4.$message({
            type: 'error',
            message: 'Gửi email thất bại'
          });
          _this4.toggleLoadding(false);
        }
      });
    },
    exportExcel: function exportExcel() {
      var _this5 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["h" /* exportExcel */])({ uuid: this.invoice.id }).then(function (response) {
        _this5.toggleLoadding(false);
        window.location.href = response.full;
      });
    },
    hardPayment: function hardPayment() {
      var _this6 = this;

      this.doHardPayment = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["i" /* hardPaymentInvoice */])(this.invoice.id).then(function (response) {
        _this6.doHardPayment = false;
        if (response.code === 200) {
          _this6.$message({
            type: 'success',
            message: 'Truy thu công nợ phiếu chi thành công'
          });
          _this6.getInvoiceDetail({ id: _this6.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } });
        } else {
          _this6.$message({
            type: 'error',
            message: 'Truy thu công nợ phiếu chi thất bại'
          });
        }
      });
    },
    onPaymentExtra: function onPaymentExtra(formName) {
      var _this7 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this7.isLoadingPayment = true;
          _this7.toggleLoadding(true);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_invoice__["j" /* makePaymentExtra */])(_this7.invoice.id, _this7.payment_extra).then(function (res) {
            _this7.toggleLoadding(false);
            if (res.code === 200) {
              _this7.$message({
                type: 'success',
                message: 'Cấn trừ phiếu chi thành công.'
              });
              _this7.getInvoiceDetail({ id: _this7.$route.params.id, params: { include: 'shipments,returner,client,shipments.compare_fee,shipments.compare,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' } });
            } else {
              _this7.$message({
                type: 'error',
                message: res.data.errors
              });
            }
            _this7.isLoadingPayment = false;
            _this7.dialogPaymentExtra = false;
          });
        } else {
          console.log('Payment false');
          return false;
        }
      });
    },
    differenceFee: function differenceFee(last_total_fee, total_fee) {
      return total_fee - last_total_fee;
    },
    getCompare: function getCompare(shipment) {
      if (!this.invoice.cross_check && !this.invoice.cross_check.data.compares.data.length) {
        return 0;
      }

      var compare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(this.invoice.cross_check.data.compares.data, { code: shipment.code });
      if (!compare) {
        compare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(this.invoice.cross_check.data.compares.data, { code: shipment.id });
      }

      return compare;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('invoice', ['invoice', 'getTotalFee', 'getTotalCOD', 'getArearAmount', 'getTotalFeeDifference']), {
    getBankInfo: function getBankInfo() {
      var data = [];
      var strings = this.invoice.bank_info.split('|');
      if (strings.length === 1) {
        strings = this.invoice.bank_info.split('.');
      }
      if (strings.length > 2) {
        data = [{ text: 'Chủ tài khoản', value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_helpers__["c" /* removeAccents */])(strings[1].trim()) }, { text: 'Số tài khoản', value: strings[2].trim() }, { text: 'Ngân hàng', value: strings[0].trim() }];
      }
      return data;
    },
    getReason: function getReason() {
      var indexStart = this.invoice.description.indexOf(':');
      var indexEnd = this.invoice.description.indexOf(',');
      var code = this.invoice.description.slice(indexStart, indexEnd);
      return 'Goship' + code + ' - ' + this.invoice.client_id;
    },
    getCrossCcheckKindCod: function getCrossCcheckKindCod() {
      return this.invoice.kind === __WEBPACK_IMPORTED_MODULE_5_src_constants__["a" /* CROSS_CHECK_TYPE */].COD;
    },
    getCrossCcheckKindFee: function getCrossCcheckKindFee() {
      return this.invoice.kind === __WEBPACK_IMPORTED_MODULE_5_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE;
    },
    getCrossCcheckKindFee1: function getCrossCcheckKindFee1() {
      return this.invoice.kind === __WEBPACK_IMPORTED_MODULE_5_src_constants__["a" /* CROSS_CHECK_TYPE */].FEE1;
    },
    getPayedFee: function getPayedFee() {
      var _this8 = this;

      var payed = 0;

      if (this.invoice.shipments && this.invoice.shipments.data.length) {
        this.invoice.shipments.data.forEach(function (shipment) {
          payed += _this8.getCompare(shipment).last_payed_fee;
        });
      }
      return payed;
    }
  }),
  mounted: function mounted() {
    this.clickToCopy();
    this.getInvoiceDetail({
      id: this.$route.params.id,
      params: { include: 'shipments,returner,client,shipments.compare_fee,cross_check.compares,confirmer,payer,shipments.parcel,relations,returns.returner,returneds.returner' },
      success: function success(invoice) {
        if (invoice.confirmer_id && !invoice.payer_id && invoice.total_amount > 0) {}
      }
    });
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_invoice__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(108);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewInvoice',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  methods: {
    validatorBeforeSubmit: function validatorBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs['edit-invoice-form'].validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_invoice__["k" /* editInvoice */])(_this.localInvoice.id, _this.localInvoice).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa phiếu chi thành công',
                  type: 'success'
                });
                _this.reloadGsTableAfterRedirect({ name: 'invoice' }, 'invoices');
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Sửa thất bại',
                  body: 'Sửa phiếu chi thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                });
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_invoice__["l" /* getInvoice */])(this.$route.params.id, { include: 'shipments,client,shipments.receiver,shipments.picker' }).then(function (response) {
      if (response.code === 200) {
        _this2.localInvoice.id = response.data.id;
        _this2.localInvoice.total_amount = response.data.total_amount;
        _this2.localInvoice.debt = response.data.debt;
        _this2.localInvoice.description = response.data.description;
        _this2.localInvoice.kind = response.data.kind.toString();
        _this2.localInvoice.client_id = response.data.client.data.id;
        _this2.localInvoice.shipments = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["forEach"])(response.data.shipments.data, function (shipment) {
          _this2.localInvoice.shipments.push(shipment.id);
        });
        _this2.shipmentAdded = response.data.shipments.data;
        _this2.suggettionReceiver = response.data.client.data;
        setTimeout(function () {
          _this2.watching = true;
        }, 100);
      } else {
        _this2.$router.push({ name: 'invoice' });
        _this2.$store.dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Phiếu chi không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
      }
    });
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_client_SelectClient__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_client_SelectClient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_src_components_client_SelectClient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_invoice__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants__ = __webpack_require__(46);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Invoice',
  components: {
    SelectClient: __WEBPACK_IMPORTED_MODULE_6_src_components_client_SelectClient___default.a
  },
  data: function data() {
    return {
      invoiceTable: 'invoices',
      totalMoneyNeedConfirm: 0,
      totalMoney: 0,
      filterDateRange: '',
      selectedRows: [],
      filters: {
        sort: 'id:-1',
        include: 'creator,client,confirmer,payer,returner,cross_check',
        client_id: '',
        is_confirm: 0,
        is_payment: -1,
        is_return: -1,
        start_date: '',
        end_date: '',
        bank_id: '',
        kind: '',
        is_negative: ''
      },
      sorted: {
        id: -1,
        real_amount: ''
      },
      sorts: [{ key: 'id', name: 'Ngày tạo' }, { key: 'real_amount', name: 'Tổng tiền trả shop' }],
      statuses: [{ key: 'is_confirm', value: 0, title: 'Chưa xác nhận', class: 'text-red' }, { key: 'is_confirm', value: 1, title: 'Đã xác nhận', class: 'text-orange' }, { key: 'is_payment', value: 1, title: 'Đã thanh toán', class: 'text-green' }, { key: 'is_return', value: 1, title: 'Đã truy thu', class: 'text-violet' }, { key: 'all', value: 1, title: 'Tất cả', class: 'text-blue' }],
      showData: false,
      dialogExportZh: false,
      paramsExportZh: {
        createdAt: undefined,
        createdAtRange: undefined,
        carrierId: [],
        status: 'success'
      },
      submitting: false,
      rules: {
        createdAt: [{ required: true, message: 'Chọn ngày là bắt buộc', trigger: 'change' }],
        createdAtRange: [{ required: true, message: 'Chọn ngày là bắt buộc', trigger: 'change' }],
        carrierId: [{ required: true, message: 'Chọn hãng vận chuyển là bắt buộc', trigger: 'change' }]
      },
      selectedDateMode: 1,
      selectedCrossCheckMode: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('invoice', ['invoice']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('bank', ['banks']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('carrier', ['carrierZhs']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('compare', ['crossChecksHelpers']), {
    getCrossCheckKindCod: function getCrossCheckKindCod() {
      return this.selectedCrossCheckMode == __WEBPACK_IMPORTED_MODULE_9_src_constants__["a" /* CROSS_CHECK_TYPE */].COD;
    },
    getCrossCheckKindcompareFee: function getCrossCheckKindcompareFee() {
      return this.selectedCrossCheckMode == __WEBPACK_IMPORTED_MODULE_9_src_constants__["a" /* CROSS_CHECK_TYPE */].COMPARE_FEE;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('invoice', ['setInvoice']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('bank', ['getAllBanks']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('carrier', ['getAllCarrierZhCod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('compare', ['getCrossChecksHeppers']), {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs.paramsExportZhRef.validate(function (valid) {
        if (valid) {
          var data = {
            createdAt: _this.selectedDateMode === 1 ? _this.paramsExportZh.createdAt : _this.paramsExportZh.createdAtRange,
            carrierId: _this.paramsExportZh.carrierId.map(function (carrier) {
              return carrier.id;
            }).join(','),
            status: _this.getCrossCheckKindCod || _this.getCrossCheckKindcompareFee ? _this.paramsExportZh.status : undefined
          };
          if (typeof data.createdAt === 'string') {
            var formattedDate = _this.addition1Day(data.createdAt);
            data.createdAt = data.createdAt + ',' + formattedDate;
          } else {
            var _formattedDate = _this.addition1Day(data.createdAt[1]);
            data.createdAt = data.createdAt[0] + ',' + _formattedDate;
          }
          var carrierName = _this.paramsExportZh.carrierId.map(function (carrier) {
            return carrier.short_name;
          }).join('-').toUpperCase();
          if (_this.getCrossCheckKindCod) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["a" /* exportCodListing */])(data).then(function (res) {
              switch (res.status) {
                case 200:
                  var createdAt = data.createdAt.split(',');
                  var nameDate = _this.selectedDateMode === 1 ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(createdAt[0]).format('DD-MM-YYYY') : __WEBPACK_IMPORTED_MODULE_8_moment___default()(createdAt[0]).format('DD-MM-YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.paramsExportZh.createdAtRange[1]).format('DD-MM-YYYY');
                  _this.saveBlobToFile(res.data, nameDate, carrierName);
                  _this.submitting = false;
                  break;
                case 400:
                  _this.submitting = false;
                  _this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error'
                  });
                  break;
                default:
                  _this.submitting = false;
                  _this.$store.dispatch('showNotify', {
                    title: res.data.message || 'Có lỗi xảy ra',
                    type: 'error'
                  });
              }
            }).catch(function (err) {
              if (err.message.includes('status code 400')) {
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng thử lại sau ít phút',
                  type: 'error'
                });
              } else {
                _this.$store.dispatch('showNotify', {
                  title: err.message,
                  type: 'error'
                });
              }
              _this.submitting = false;
            });
          } else if (_this.getCrossCheckKindcompareFee) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["b" /* exportCompareFeeListing */])(data).then(function (res) {
              switch (res.status) {
                case 200:
                  var createdAt = data.createdAt.split(',');
                  var nameDate = _this.selectedDateMode === 1 ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(createdAt[0]).format('DD-MM-YYYY') : __WEBPACK_IMPORTED_MODULE_8_moment___default()(createdAt[0]).format('DD-MM-YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.paramsExportZh.createdAtRange[1]).format('DD-MM-YYYY');
                  _this.saveBlobToFile(res.data, nameDate, carrierName);
                  _this.submitting = false;
                  break;
                case 400:
                  _this.submitting = false;
                  _this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error'
                  });
                  break;
                default:
                  _this.submitting = false;
                  _this.$store.dispatch('showNotify', {
                    title: res.data.message || 'Có lỗi xảy ra',
                    type: 'error'
                  });
              }
            }).catch(function (err) {
              if (err.message.includes('status code 400')) {
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng thử lại sau ít phút',
                  type: 'error'
                });
              } else {
                _this.$store.dispatch('showNotify', {
                  title: err.message,
                  type: 'error'
                });
              }
              _this.submitting = false;
            });
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["n" /* exportFeeListing */])(data).then(function (res) {
              switch (res.status) {
                case 200:
                  _this.submitting = false;
                  var createdAt = data.createdAt.split(',');
                  var nameDate = _this.selectedDateMode === 1 ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(createdAt[0]).format('DD-MM-YYYY') : __WEBPACK_IMPORTED_MODULE_8_moment___default()(createdAt[0]).format('DD-MM-YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.paramsExportZh.createdAtRange[1]).format('DD-MM-YYYY');
                  _this.saveBlobToFile(res.data, nameDate, carrierName);
                  break;
                case 400:
                  _this.submitting = false;
                  _this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error'
                  });
                  break;
                default:
                  _this.submitting = false;
                  _this.$store.dispatch('showNotify', {
                    title: res.data.message || 'Có lỗi xảy ra',
                    type: 'error'
                  });
              }
            }).catch(function (err) {
              if (err.message.includes('status code 400')) {
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng thử lại sau ít phút',
                  type: 'error'
                });
              } else {
                _this.$store.dispatch('showNotify', {
                  title: err.message,
                  type: 'error'
                });
              }
              _this.submitting = false;
            });
          }
        } else {
          _this.submitting = false;
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
        }
      });
    },
    saveBlobToFile: function saveBlobToFile(blob, date, shortName) {
      var url = URL.createObjectURL(blob);

      var link = document.createElement('a');
      link.href = url;
      link.download = 'B\u1EA3ng k\xEA ' + this.setNameExportList(this.selectedCrossCheckMode) + ' ' + date + ' ' + shortName;
      link.click();

      URL.revokeObjectURL(url);
    },
    setNameExportList: function setNameExportList(val) {
      return this.crossCheckList.find(function (item) {
        return item.value === val;
      }).name;
    },
    addition1Day: function addition1Day(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
    },
    updateFilters: function updateFilters(data) {
      var startDate = data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_helpers__["a" /* formatDate */])(data[0]) : null;
      var endDate = data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_helpers__["a" /* formatDate */])(data[1]) : null;

      this.filters.start_date = startDate;
      this.filters.end_date = endDate;
      this.filter();
    },
    setFilterStatus: function setFilterStatus(key, value) {
      this.filters['is_confirm'] = -1;
      this.filters['is_payment'] = -1;
      this.filters['is_return'] = -1;
      this.filters['all'] = '';
      this.filters[key] = value;

      this.filter();
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.invoiceTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('doFilter')) {
        this.getTotalDebtInvoice();
        this.getTotalDebtInvoiceByFilter();
        this.reloadGsTable(this.invoiceTable);
      }
      this.$router.push({ query: this.filters });
    }, 300),
    gsFilterChange: function gsFilterChange(e) {
      this.getTotalDebtInvoice();
      this.getTotalDebtInvoiceByFilter();
    },
    removeFilter: function removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'id:-1',
        include: 'creator,client,confirmer,payer,returner,cross_check',
        client_id: '',
        is_confirm: 0,
        is_payment: -1,
        is_return: -1,
        start_date: '',
        end_date: '',
        bank_id: '',
        kind: '',
        is_negative: ''
      }) || this.filters.is_confirm !== 0 || this.filters.is_confirm !== -1) {
        this.reloadGsTable(this.invoiceTable);
      }
      this.filterDateRange = '';
      this.filters = {
        sort: 'id:-1',
        include: 'creator,client,confirmer,payer,cross_check',
        client_id: '',
        is_confirm: 0,
        is_payment: -1,
        start_date: '',
        end_date: '',
        bank_id: '',
        kind: '',
        is_negative: ''
      };
    },
    checkDefaultFilter: function checkDefaultFilter(filters) {
      var _this2 = this;

      var diff = false;
      var lkeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(filters);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"])(lkeys, function (key) {
        if (filters[key] !== _this2.filters[key]) {
          _this2.diff = true;
        }
      });
      return diff;
    },
    deleteInvoice: function deleteInvoice(invoice) {
      var _this3 = this;

      this.setInvoice(invoice);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a phi\u1EBFu chi ' + this.invoice.id, 'Xóa phiếu chi', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this3.delInvoice();
      }).catch(function () {});
    },
    confirmInvoice: function confirmInvoice(invoice) {
      var _this4 = this;

      this.setInvoice(invoice);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xE1c nh\u1EADn phi\u1EBFu chi ' + this.invoice.id, 'Xác nhận phiếu chi', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this4.confInvoice();
      }).catch(function () {});
    },
    payInvoice: function payInvoice(invoice) {
      var _this5 = this;

      this.setInvoice(invoice);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n thanh to\xE1n phi\u1EBFu chi ' + this.invoice.id, 'Thanh toán phiếu chi', {
        confirmButtonText: 'Thanh toán',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this5.pInvoice();
      }).catch(function () {});
    },
    returnInvoice: function returnInvoice(invoice) {
      var _this6 = this;

      this.setInvoice(invoice);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n truy thu phi\u1EBFu chi ' + this.invoice.id, 'Truy thu phiếu chi', {
        confirmButtonText: 'Truy thu',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this6.rInvoice();
      }).catch(function () {});
    },
    delInvoice: function delInvoice() {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["o" /* deleteInvoice */])(this.invoice.id).then(function (response) {
        if (response.code === 200) {
          _this7.$message({
            type: 'success',
            message: 'Xóa phiếu chi thành công'
          });
          _this7.reloadGsTable(_this7.invoiceTable);
        } else {
          _this7.$message({
            type: 'error',
            message: 'Xóa phiếu chi thất bại'
          });
        }
      });
    },
    confInvoice: function confInvoice() {
      var _this8 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["e" /* confirmInvoice */])(this.invoice.id).then(function (response) {
        if (response.code === 200) {
          _this8.$message({
            type: 'success',
            message: 'Xác nhận phiếu chi thành công'
          });
          _this8.reloadGsTable(_this8.invoiceTable);
        } else {
          _this8.$message({
            type: 'error',
            message: 'Xác nhận phiếu chi thất bại'
          });
        }
      });
    },
    pInvoice: function pInvoice() {
      var _this9 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["f" /* paymentInvoice */])(this.invoice.id).then(function (response) {
        switch (response.code) {
          case 200:
            _this9.$message({
              type: 'success',
              message: 'Thanh toán phiếu chi thành công'
            });
            _this9.reloadGsTable(_this9.invoiceTable);
            break;
          case 422:
            _this9.$message({
              type: 'error',
              message: response.data.errors
            });
            break;
          default:
            _this9.$message({
              type: 'error',
              message: 'Thanh toán phiếu chi thất bại'
            });
        }
      });
    },
    rInvoice: function rInvoice() {
      var _this10 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["d" /* returnInvoice */])(this.invoice.id).then(function (response) {
        if (response.code === 200) {
          _this10.$message({
            type: 'success',
            message: 'Truy thu phiếu chi thành công'
          });
          _this10.reloadGsTable(_this10.invoiceTable);
        } else {
          _this10.$message({
            type: 'error',
            message: 'Truy thu phiếu chi thất bại'
          });
        }
      });
    },
    exportExcel: function exportExcel() {
      var _this11 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["h" /* exportExcel */])(this.filters).then(function (response) {
        _this11.toggleLoadding(false);
        window.location.href = response.full;
      });
    },
    sendEmail: function sendEmail(invoice) {
      var _this12 = this;

      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["g" /* resendEmail */])(invoice.id).then(function (response) {
        if (response.code === 200) {
          _this12.$message({
            type: 'success',
            message: 'Gửi email thành công'
          });
          _this12.toggleLoadding(false);
        } else {
          _this12.$message({
            type: 'error',
            message: 'Gửi email thất bại'
          });
          _this12.toggleLoadding(false);
        }
      });
    },
    getTotalDebtInvoice: function getTotalDebtInvoice() {
      var _this13 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["p" /* getTotalDebt */])(this.filters).then(function (response) {
        if (response.code === 200) {
          _this13.totalMoneyNeedConfirm = response.data ? response.data.total : 0;
        } else {
          _this13.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi lấy thông tin tổng tiền.'
          });
        }
      });
    },
    getTotalDebtInvoiceByFilter: function getTotalDebtInvoiceByFilter() {
      var _this14 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["q" /* getTotalDebtByFilter */])(this.filters).then(function (response) {
        if (response.code === 200) {
          _this14.totalMoney = response.data ? response.data.total : 0;
        } else {
          _this14.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi lấy thông tin tổng tiền.'
          });
        }
      });
    },
    getBankInfo: function getBankInfo(value) {
      var data = [];
      if (!value) return data;
      var strings = value.split('|');
      if (strings.length === 1) {
        strings = value.split('.');
      }
      if (strings.length > 2) {
        data = [{ text: 'Tên tài khoản', value: strings[1].trim() }, { text: 'Số tài khoản', value: strings[2].trim() }, { text: 'Ngân hàng', value: strings[0].trim() }];
      }
      return data;
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    handleActions: function handleActions(cmd) {
      var _this15 = this;

      var invoiceIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(this.selectedRows, 'id');

      if (cmd === 'confirmAll') {
        this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xE1c nh\u1EADn phi\u1EBFu chi \u0111\xE3 ch\u1ECDn?', 'Xác nhận phiếu chi', {
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Không',
          type: 'warning'
        }).then(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["r" /* confirmAllInvoice */])(invoiceIds).then(function (res) {
            if (res.count > 0) {
              _this15.$message({
                type: 'success',
                message: 'X\xE1c nh\u1EADn ' + res.count + ' phi\u1EBFu chi th\xE0nh c\xF4ng.'
              });
              _this15.reloadGsTable(_this15.invoiceTable);
            } else {
              _this15.$message({
                type: 'error',
                message: 'X\xE1c nh\u1EADn phi\u1EBFu chi th\u1EA5t b\u1EA1i.'
              });
            }
          });
        }).catch(function () {});
      }

      if (cmd === 'deleteAll') {
        this.$message({
          type: 'error',
          message: 'T\xEDnh n\u0103ng \u0111ang t\u1EA1m th\u1EDDi b\u1ECB v\xF4 hi\u1EC7u h\xF3a b\u1EDFi Admin.'
        });
      }

      if (cmd === 'exportAll') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["s" /* exportAllInvoice */])(invoiceIds).then(function (res) {
          window.location.href = res.full;
        });
      }

      if (cmd === 'paymentAll') {
        this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n Thanh to\xE1n phi\u1EBFu chi \u0111\xE3 ch\u1ECDn?', 'Thanh toán phiếu chi', {
          confirmButtonText: 'Thanh toán',
          cancelButtonText: 'Không',
          type: 'warning'
        }).then(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_invoice__["t" /* paymentAllInvoice */])(invoiceIds).then(function (res) {
            if (res.code === 200) {
              _this15.$message({
                type: 'success',
                message: 'Thanh to\xE1n phi\u1EBFu chi th\xE0nh c\xF4ng.'
              });
              _this15.reloadGsTable(_this15.invoiceTable);
            } else {
              _this15.$message({
                type: 'error',
                message: 'Thanh to\xE1n phi\u1EBFu chi th\u1EA5t b\u1EA1i.'
              });
            }
          });
        }).catch(function () {});
      }
    },
    handleChangeCarrier: function handleChangeCarrier(val) {
      this.paramsExportZh.carrierId = val.map(function (item) {
        return JSON.parse(item);
      });
    },
    kindStatus: function kindStatus(kind) {
      switch (kind) {
        case 1:
          return 'success';
        case 2:
          return 'danger';
        default:
          return 'info';
      }
    }
  }),
  watch: {
    carrierZhs: {
      handler: function handler(val) {
        this.paramsExportZh.carrierId = [val[0]];
      },
      immediate: true
    },
    '$route.query': {
      handler: function handler(newQuery) {
        var _this16 = this;

        this.filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.filters, newQuery);
        if (this.filters.start_date && this.filters.end_date) {
          this.filterDateRange = [this.filters.start_date, this.filters.end_date];
        }
        ['bank_id', 'is_confirm', 'is_payment', 'is_return', 'all', 'is_negative'].forEach(function (key) {
          if (_this16.filters[key]) {
            _this16.filters[key] = Number(_this16.filters[key]);
          }
        });
      },

      deep: true,
      immediate: true }
  },
  mounted: function mounted() {
    var _this17 = this;

    this.clickToCopy();
    var dateNow = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
    var formattedDate = this.addition1Day(dateNow);
    this.paramsExportZh.createdAt = dateNow;
    this.paramsExportZh.createdAtRange = [dateNow, __WEBPACK_IMPORTED_MODULE_8_moment___default()(formattedDate).format('YYYY-MM-DD')];
    if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.invoiceTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.invoiceTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    setTimeout(function () {
      _this17.showData = true;
    }, 200);
    this.listenReloadGsTable();
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getSorted(this.invoiceTable)).length) {
      this.sorted = this.getSorted(this.invoiceTable);
    }
    this.getTotalDebtInvoice();
    this.getTotalDebtInvoiceByFilter();
    if (!this.banks.length) {
      this.getAllBanks();
    }
    if (!this.carrierZhs.length) {
      this.getAllCarrierZhCod();
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.crossChecksHelpers).length) {
      this.getCrossChecksHeppers();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')['invoices']) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Invoice',
  data: function data() {
    return {
      invoiceReportTable: 'invoiceReport',
      filterDateRange: '',
      filters: {
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        include: 'cross_check'
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      showData: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('invoice', ['invoice'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('invoice', ['setInvoice']), {
    updateFilters: function updateFilters(data) {
      this.filters.start_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_helpers__["a" /* formatDate */])(data[0]);
      this.filters.end_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_helpers__["a" /* formatDate */])(data[1]);
      this.filter();
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.invoiceReportTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.invoiceReportTable);
      }
    }, 300),
    removeFilter: function removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        include: 'cross_check'
      }) || this.filters.is_confirm !== 0 || this.filters.is_confirm !== -1) {
        this.reloadGsTable(this.invoiceReportTable);
      }
      this.filterDateRange = '';
      this.filters = {
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        include: 'cross_check'
      };
    },
    checkDefaultFilter: function checkDefaultFilter(filters) {
      var _this = this;

      var diff = false;
      var lkeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(filters);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"])(lkeys, function (key) {
        if (filters[key] !== _this.filters[key]) {
          _this.diff = true;
        }
      });
      return diff;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.clickToCopy();
    if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.invoiceReportTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.invoiceReportTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    setTimeout(function () {
      _this2.showData = true;
    }, 200);
    this.listenReloadGsTable();
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getSorted(this.invoiceReportTable)).length) {
      this.sorted = this.getSorted(this.invoiceReportTable);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')['invoiceReport']) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_invoice__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(108);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewInvoice',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  methods: {
    validatorBeforeSubmit: function validatorBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs['create-invoice-form'].validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_invoice__["m" /* createInvoice */])(_this.localInvoice).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm mới phiếu chi thành công',
                  type: 'success'
                });
                _this.reloadGsTableAfterRedirect({ name: 'invoice' }, 'invoices');
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thất bại',
                  body: 'Thêm phiếu chi thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                });
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    newInvoice: function newInvoice() {
      var _this2 = this;

      this.localInvoice = {
        id: 0,
        kind: '0',
        client_id: 0,
        shipments: [],
        total_amount: 0,
        debt: 0,
        description: ''
      };
      setTimeout(function () {
        _this2.watching = true;
      }, 100);
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_permissions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewPermission',
  data: function data() {
    return {
      submitting: false,
      isIndeterminate: true,
      checkAll: false,
      localPermission: {
        name: '',
        display_name: '',
        description: '',
        prefix: []
      },
      rules: {
        name: [{ required: true, message: 'Bạn chưa nhập tên permission', trigger: 'change' }, { max: 255, message: 'Tên permission phải nhỏ hơn 255 ký tự', trigger: 'change' }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('permission', ['permissionHelpers'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('permission', ['getAllPermissionsHelpers']), {
    validateBeforeSubmitRole: function validateBeforeSubmitRole() {
      var _this = this;

      this.submitting = true;
      this.$refs.createPermissionForm.validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_permissions__["a" /* createPermission */])(_this.localPermission).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm permission  thành công'
                });
                _this.reloadGsTableAfterRedirect({ name: 'permission' }, 'permissions');
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Tạo permission thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('toggleLoadding', false, { root: true });
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    handleCheckAllChange: function handleCheckAllChange() {
      if (this.checkAll) {
        var listPermission = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"])(this.permissionHelpers.prefixs, function (value, key) {
          listPermission.push(key);
        });
        this.localPermission.prefix = listPermission;
      } else {
        this.localPermission.prefix = [];
      }
      this.isIndeterminate = false;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.watching = true;
    }, 100);
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.permissionHelpers).length) {
      this.getAllPermissionsHelpers();
    }
  },

  watch: {
    localPermission: {
      handler: function handler(value) {
        if (this.watching) {
          this.changedData = true;
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_permissions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Permission',
  data: function data() {
    return {
      permissionTable: 'permissions',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('permission', ['permission'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('permission', ['setPermission']), {
    removeFilter: function removeFilter() {
      this.reloadGsTable(this.permissionTable);
      this.filters = {
        sort: 'created_at:-1'
      };
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.permissionTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.permissionTable);
      }
    }, 300),
    deletePermission: function deletePermission(permission) {
      var _this = this;

      this.setPermission(permission);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a permission ' + this.permission.name, 'Xóa permission', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this.delPermission();
      }).catch(function () {});
    },
    delPermission: function delPermission() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_permissions__["b" /* deletePermission */])(this.permission.id).then(function (response) {
        if (response.code === 200) {
          _this2.$message({
            type: 'success',
            message: 'Xóa permission thành công'
          });
          _this2.reloadGsTable(_this2.permissionTable);
        } else {
          _this2.$message({
            type: 'danger',
            message: 'Xóa permission thất bại'
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.permissionTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.permissionTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.permissionTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')['permissions']) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionDenied'
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_stubs_shipments__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_receipt__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_api_invoice__ = __webpack_require__(27);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DetailReceipt',
  data: function data() {
    return {
      confirmPopup: false,
      payPopup: false,
      shipmentStatuses: __WEBPACK_IMPORTED_MODULE_2_src_stubs_shipments__["a" /* shipmentStatuses */],
      dialogReturner: false,
      dialogReturned: false,
      listReturn: [],
      pendingReturn: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('receipt', ['getReceiptDetail']), {
    confirmReceipt: function confirmReceipt() {
      var _this = this;

      this.confirmPopup = false;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_receipt__["a" /* confirmReceipt */])(this.receipt.id).then(function (response) {
        if (response.code === 200) {
          _this.$message({
            type: 'success',
            message: 'Xác nhận phiếu thu thành công'
          });
          _this.getReceiptDetail({ id: _this.$route.params.id, params: { include: 'shipments,creator,client,confirmer,payer,client.banks,shipments.parcel' } });
        } else {
          _this.$message({
            type: 'error',
            message: 'Xác nhận phiếu thu thất bại'
          });
        }
      });
    },
    returnHandler: function returnHandler() {
      this.dialogReturner = true;
      this.getListReturnInvoices();
    },
    getListReturnInvoices: function getListReturnInvoices() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_invoice__["c" /* getAllInvoice */])({ client_id: this.receipt.client.data.id, is_debt: 1, limit: -1 }).then(function (response) {
        if (response.code === 200) {
          _this2.listReturn = response.data;
        } else {
          _this2.listReturn = [];
        }
      });
    },
    returnedHandler: function returnedHandler() {
      this.dialogReturned = true;
    },
    returnInvoice: function returnInvoice(invoice) {
      var _this3 = this;

      this.pendingReturn = true;
      this.returnPopup = false;
      var dataReturn = {
        type: 1,
        relation_id: this.receipt.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_api_invoice__["d" /* returnInvoice */])(invoice.id, dataReturn).then(function (response) {
        if (response.code === 200) {
          _this3.$message({
            type: 'success',
            message: 'Truy thu công nợ phiếu chi thành công'
          });
          _this3.getReceiptDetail({ id: _this3.$route.params.id, params: { include: 'shipments,creator,client,confirmer,payer,client.banks,shipments.parcel,returns.returner' } });
          _this3.getListReturnInvoices();
          _this3.pendingReturn = false;
        } else {
          _this3.$message({
            type: 'error',
            message: 'Truy thu công nợ phiếu chi thất bại'
          });
          _this3.pendingReturn = false;
        }
      });
    },
    detailInvoiceBlankTab: function detailInvoiceBlankTab(id) {
      window.open('/invoice/' + id);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('receipt', ['receipt'])),
  mounted: function mounted() {
    this.getReceiptDetail({ id: this.$route.params.id, params: { include: 'shipments,creator,client,confirmer,payer,client.banks,shipments.parcel,returns.returner' } });
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_receipt__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditReceipt',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    validatorBeforeSubmit: function validatorBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs['edit-receipt-form'].validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_receipt__["b" /* editReceipt */])(_this.localReceipt.id, _this.localReceipt).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa phiếu thu thành công',
                  type: 'success'
                });
                _this.reloadGsTableAfterRedirect({ name: 'receipt' }, 'receipts');
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Sửa thất bại',
                  body: 'Sửa phiếu thu thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                });
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_receipt__["c" /* getReceipt */])(this.$route.params.id, { include: 'shipments,shipments.receiver,shipments.picker,client' }).then(function (response) {
      if (response.code === 200) {
        _this2.localReceipt.id = response.data.id;
        _this2.localReceipt.description = response.data.description;
        _this2.localReceipt.total_amount = response.data.amount;
        _this2.localReceipt.client_id = response.data.client.data.id;
        _this2.suggettionReceiver = response.data.client.data;
        _this2.localReceipt.shipments = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"])(response.data.shipments.data, function (shipment) {
          _this2.localReceipt.shipments.push(shipment.id);
        });
        _this2.shipmentAdded = response.data.shipments.data;
        setTimeout(function () {
          _this2.watching = true;
        }, 100);
      } else {
        _this2.$router.push({ name: 'receipt' });
        _this2.$store.dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Phiếu thu không tồn tại trên hệ thống',
          type: 'warning'
        }, { root: true });
      }
    });
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_receipt__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateReceipt',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    validatorBeforeSubmit: function validatorBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs['create-receipt-form'].validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_api_receipt__["d" /* createReceipt */])(_this.localReceipt).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm mới phiếu thu thành công',
                  type: 'success'
                });
                _this.reloadGsTableAfterRedirect({ name: 'receipt' }, 'receipts');
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thất bại',
                  body: 'Thêm phiếu thu thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                });
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    newReceipt: function newReceipt() {
      var _this2 = this;

      this.localReceipt = {
        id: 0,
        shipments: [],
        total_amount: 0,
        description: '',
        client_id: 0
      };
      setTimeout(function () {
        _this2.watching = true;
      }, 100);
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_receipt__ = __webpack_require__(37);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Receipt',
  data: function data() {
    return {
      receiptTable: 'receipts',
      filterDateRange: '',
      confirmModal: false,
      filters: {
        sort: 'created_at:-1',
        include: 'creator,confirmer',
        is_confirm: 0,
        start_date: '',
        end_date: ''
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      statuses: [{ key: 'is_confirm', value: 0, title: 'Chưa xác nhận', class: 'text-red' }, { key: 'is_confirm', value: 1, title: 'Đã xác nhận', class: 'text-orange' }, { key: 'all', value: 1, title: 'Tất cả', class: 'text-blue' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('receipt', ['receipt'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('receipt', ['setReceipt']), {
    updateFilters: function updateFilters(data) {
      this.filters.start_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_helpers__["a" /* formatDate */])(data[0]);
      this.filters.end_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_helpers__["a" /* formatDate */])(data[1]);
      this.filter();
    },
    setFilterStatus: function setFilterStatus(key, value) {
      this.filters['is_confirm'] = -1;
      this.filters['all'] = '';
      this.filters[key] = value;

      this.filter();
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.receiptTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.receiptTable);
      }
    }, 300),
    removeFilter: function removeFilter() {
      if (this.checkDefaultFilter({
        sort: 'created_at:-1',
        include: 'creator,confirmer',
        is_confirm: 0,
        start_date: '',
        end_date: ''
      }) || this.filters.is_confirm !== 0 || this.filters.is_confirm !== -1) {
        this.reloadGsTable(this.receiptTable);
      }
      this.filterDateRange = '';
      this.filters = {
        sort: 'created_at:-1',
        include: 'creator,confirmer',
        is_confirm: 0,
        start_date: '',
        end_date: ''
      };
    },
    checkDefaultFilter: function checkDefaultFilter(filters) {
      var _this = this;

      var diff = false;
      var lkeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(filters);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(lkeys, function (key) {
        if (filters[key] !== _this.filters[key]) {
          _this.diff = true;
        }
      });
      return diff;
    },
    deleteReceipt: function deleteReceipt(receipt) {
      var _this2 = this;

      this.setReceipt(receipt);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a phi\u1EBFu thu ' + this.receipt.id, 'Xóa phiếu thu', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this2.delReceipt();
      }).catch(function () {});
    },
    confirmReceipt: function confirmReceipt(receipt) {
      var _this3 = this;

      this.setReceipt(receipt);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xE1c nh\u1EADn phi\u1EBFu thu ' + this.receipt.id, 'Xác nhận phiếu thu', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this3.confReceipt();
      }).catch(function () {});
    },
    delReceipt: function delReceipt() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_api_receipt__["e" /* deleteReceipt */])(this.receipt.id).then(function (response) {
        if (response.code === 200) {
          _this4.$message({
            type: 'success',
            message: 'Xóa phiếu thu thành công'
          });
          _this4.reloadGsTable(_this4.receiptTable);
        } else {
          _this4.$message({
            type: 'error',
            message: 'Xóa phiếu thu thất bại'
          });
        }
      });
    },
    confReceipt: function confReceipt() {
      var _this5 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_api_receipt__["a" /* confirmReceipt */])(this.receipt.id).then(function (response) {
        if (response.code === 200) {
          _this5.$message({
            type: 'success',
            message: 'Xác nhận phiếu thu thành công'
          });
          _this5.reloadGsTable(_this5.receiptTable);
        } else {
          _this5.$message({
            type: 'error',
            message: 'Xác nhận phiếu thu thất bại'
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.clickToCopy();
    if (__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters')[this.receiptTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters')[this.receiptTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.receiptTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('filters')['receipts']) {
        __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_roles__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(110);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditRole',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  data: function data() {
    return {
      fetchData: false
    };
  },

  methods: {
    validateBeforeSubmitRole: function validateBeforeSubmitRole() {
      var _this = this;

      this.submitting = true;
      this.$refs.createRoleForm.validate(function (valid) {
        if (valid) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(_this.listPermissions, function (permission) {
            _this.localRole.permissions.push(permission.id);
          });
          _this.$nextTick(function () {
            _this.changedData = false;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_roles__["a" /* editRole */])(_this.localRole.id, _this.localRole).then(function (response) {
              switch (response.code) {
                case 200:
                  _this.$store.dispatch('showNotify', {
                    title: 'Sửa thành công',
                    body: 'Sửa role  thành công'
                  });
                  _this.reloadGsTableAfterRedirect({ name: 'role' }, 'roles');
                  _this.toggleLoadding(false);
                  _this.submitting = false;
                  break;
                case 422:
                  var er = response.data.errors;
                  var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                  _this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: message,
                    type: 'warning'
                  });
                  _this.toggleLoadding(false);
                  _this.submitting = false;
                  break;
                default:
                  _this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: 'Sửa role thất bại vui lòng kiểm tra lại thông tin',
                    type: 'warning'
                  });
                  _this.toggleLoadding(false);
                  _this.submitting = false;
              }
            });
          });
        } else {
          _this.$store.dispatch('toggleLoadding', false, { root: true });
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    selectPermission: function selectPermission(e, permission) {
      if (e === 1) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(this.listPermissions, { id: permission.id }) < 0) {
          this.listPermissions.push({ id: permission.id, name: permission.name });
        }
      } else {
        if (e.target.checked) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(this.listPermissions, { id: permission.id }) < 0) {
            this.listPermissions.push({ id: permission.id, name: permission.name });
          }
        } else {
          this.listPermissions.splice(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(this.listPermissions, { id: permission.id }), 1);
        }
      }
    },
    checkIsExist: function checkIsExist(permission) {
      if (this.listPermissions.length) {
        var check = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(this.listPermissions, { id: permission.id });
        if (check < 0) {
          return false;
        }
        return true;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_roles__["b" /* getRole */])(this.$route.params.id, { include: 'users,permissions' }).then(function (response) {
      if (response.code === 200) {
        _this2.localRole.id = response.data.id;
        _this2.localRole.name = response.data.name;
        _this2.localRole.display_name = response.data.display_name;
        _this2.localRole.description = response.data.description;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(response.data.users.data, function (admin) {
          _this2.localRole.users.push(admin.id);
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(response.data.permissions.data, function (permission) {
          _this2.selectPermission(1, permission);
        });
        _this2.selectedAdmins = response.data.users.data;
        _this2.fetchData = true;
        setTimeout(function () {
          _this2.watching = true;
        }, 100);
      } else {
        _this2.$router.push({ name: 'carrier' });
        _this2.$store.dispatch('showNotify', {
          title: 'Vui lòng kiểm tra thông tin cần nhập',
          body: 'Không tìm thấy tài nguyên',
          type: 'warning'
        });
      }
    });
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_roles__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(110);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewRole',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  methods: {
    validateBeforeSubmitRole: function validateBeforeSubmitRole() {
      var _this = this;

      this.submitting = true;
      this.$refs.createRoleForm.validate(function (valid) {
        if (valid) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(_this.listPermissions, function (permission) {
            _this.localRole.permissions.push(permission.id);
          });
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_roles__["c" /* createRole */])(_this.localRole).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm role  thành công'
                });
                _this.reloadGsTableAfterRedirect({ name: 'role' }, 'roles');
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Tạo role thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('toggleLoadding', false, { root: true });
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    newRole: function newRole() {
      var _this2 = this;

      this.localRole = {
        name: '',
        display_name: '',
        description: '',
        users: [],
        permissions: []
      };
      setTimeout(function () {
        _this2.watching = true;
      }, 100);
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_roles__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Role',

  data: function data() {
    return {
      roleTable: 'roles',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      detailModal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('role', ['role'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('role', ['getRole', 'setRole']), {
    removeFilter: function removeFilter() {
      this.reloadGsTable(this.roleTable);
      this.filters = {
        sort: 'created_at:-1'
      };
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.roleTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.roleTable);
      }
    }, 300),
    deleteRole: function deleteRole(role) {
      var _this = this;

      this.setRole(role);
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a role ' + this.role.name, 'Xóa role', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this.delRole();
      }).catch(function () {});
    },
    delRole: function delRole() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_src_api_roles__["d" /* deleteRole */])(this.role.id).then(function (response) {
        if (response.code === 200) {
          _this2.$message({
            type: 'success',
            message: 'Xóa role thành công'
          });
          _this2.reloadGsTable(_this2.roleTable);
        } else {
          _this2.$message({
            type: 'danger',
            message: 'Xóa role thất bại'
          });
        }
      });
    },
    detailRole: function detailRole(role) {
      this.detailModal = true;
      this.getRole({ id: role.id, params: { include: 'users,permissions' } });
    }
  }),
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.roleTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')[this.roleTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.roleTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.get('filters')['roles']) {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers__ = __webpack_require__(25);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Saller',
  data: function data() {
    return {
      salerTable: 'salers',
      filterDateRange: '',
      filters: {
        sort: 'month:-1',
        include: 'saler',
        sale_id: '',
        start_date: '',
        end_date: ''
      },
      sorted: {
        month: -1
      },
      sorts: [{ key: 'month', name: 'Ngày tạo' }],
      statusColor: {
        '0': 'text-red',
        '1': 'text-green',
        '2': 'text-violet'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('admin', ['administrators'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('admin', ['getAllAdmins']), {
    removeFilter: function removeFilter() {
      this.reloadGsTable(this.salerTable);
      this.filterDateRange = '';
      this.filters = {
        sort: 'month:-1',
        include: 'saler'
      };
    },
    updateFilters: function updateFilters(data) {
      this.filters.start_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_helpers__["a" /* formatDate */])(data[0], 'YYYY-MM');
      this.filters.end_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_helpers__["a" /* formatDate */])(data[1], 'YYYY-MM');
      this.filter();
    },
    commissionText: function commissionText(config) {
      var text = '';
      var kpi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(config);
      kpi.forEach(function (v, i) {
        if (i === 0 && parseInt(v) === -1) {
          text += v;
        } else {
          if (i === 0) {
            text += '0-' + v + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_helpers__["b" /* formatNumber */])(config[v], 0) + '\u0111 | ';
          } else if (parseInt(v) !== -1) {
            text += kpi[i - 1] + '-' + v + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_helpers__["b" /* formatNumber */])(config[v], 0) + '\u0111 | ';
          } else {
            text += '>' + kpi[i - 1] + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_helpers__["b" /* formatNumber */])(config[v], 0) + '\u0111';
          }
        }
      });
      return text;
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.salerTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.salerTable);
      }
    }, 300)
  }),
  mounted: function mounted() {
    this.clickToCopy();
    if (__WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters')[this.salerTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters')[this.salerTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    if (!this.administrators.length) {
      this.getAllAdmins({ role_name: 'saler', limit: -1 });
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.salerTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.get('filters')['clients']) {
        __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_saller__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SallerConfig',
  data: function data() {
    return {
      submitting: false,
      localConfig: {
        'parttime': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        },
        'trainee': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        },
        'employee': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        }
      },
      kpiPartTime: [],
      kpiTrainee: [],
      kpiEmployee: [],
      rules: {}
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs['config-saler-salary'].validate(function (valid) {
        if (valid) {
          _this.localConfig.parttime.kpi = {};
          _this.localConfig.parttime.bonus = {};
          _this.localConfig.parttime.month_plus = {};
          _this.kpiPartTime.forEach(function (value) {
            _this.localConfig.parttime.kpi[value.number] = value.money;
            _this.localConfig.parttime.bonus[value.number] = value.bonus;
            _this.localConfig.parttime.month_plus[value.number] = value.month_plus;
          });
          _this.localConfig.trainee.kpi = {};
          _this.localConfig.trainee.bonus = {};
          _this.localConfig.trainee.month_plus = {};
          _this.kpiTrainee.forEach(function (value) {
            _this.localConfig.trainee.kpi[value.number] = value.money;
            _this.localConfig.trainee.bonus[value.number] = value.bonus;
            _this.localConfig.trainee.month_plus[value.number] = value.month_plus;
          });
          _this.localConfig.employee.kpi = {};
          _this.localConfig.employee.bonus = {};
          _this.localConfig.employee.month_plus = {};
          _this.kpiEmployee.forEach(function (value) {
            _this.localConfig.employee.kpi[value.number] = value.money;
            _this.localConfig.employee.bonus[value.number] = value.bonus;
            _this.localConfig.employee.month_plus[value.number] = value.month_plus;
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_saller__["d" /* changeSysConfig */])(_this.localConfig).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thành công',
                  type: 'success'
                });
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thất bại',
                  body: 'Hệ thống gặp sự cố vui lòng thử lại sau',
                  type: 'danger'
                });
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    newKpi: function newKpi(kpi) {
      kpi.push({
        number: -1,
        money: 0
      });
    },
    removeKpi: function removeKpi(kpi, index) {
      kpi.splice(index, 1);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_saller__["e" /* getSysConfig */])().then(function (response) {
      if (response.code === 200) {
        _this2.localConfig = response.data;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.localConfig.employee.kpi).forEach(function (key) {
          _this2.kpiEmployee.push({
            number: key,
            money: _this2.localConfig.employee.kpi[key],
            bonus: _this2.localConfig.employee.bonus ? _this2.localConfig.employee.bonus[key] : 0,
            month_plus: _this2.localConfig.employee.month_plus ? _this2.localConfig.employee.month_plus[key] : 0
          });
        });

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.localConfig.trainee.kpi).forEach(function (key) {
          _this2.kpiTrainee.push({
            number: key,
            money: _this2.localConfig.trainee.kpi[key],
            bonus: _this2.localConfig.trainee.bonus ? _this2.localConfig.trainee.bonus[key] : 0,
            month_plus: _this2.localConfig.trainee.month_plus ? _this2.localConfig.trainee.month_plus[key] : 0
          });
        });

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.localConfig.parttime.kpi).forEach(function (key) {
          _this2.kpiPartTime.push({
            number: key,
            money: _this2.localConfig.parttime.kpi[key],
            bonus: _this2.localConfig.parttime.bonus ? _this2.localConfig.parttime.bonus[key] : 0,
            month_plus: _this2.localConfig.parttime.month_plus ? _this2.localConfig.parttime.month_plus[key] : 0
          });
        });
      }
    });
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_saller__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SallerConfig',
  data: function data() {
    return {
      submitting: false,
      localConfig: {
        'config': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        }
      },
      kpiConfig: [],
      rules: {}
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this = this;

      this.submitting = true;
      this.$refs['config-saler-salary'].validate(function (valid) {
        if (valid) {
          _this.localConfig.config.kpi = {};
          _this.localConfig.config.bonus = {};
          _this.localConfig.config.month_plus = {};
          _this.kpiConfig.forEach(function (value) {
            _this.localConfig.config.kpi[value.number] = value.money;
            _this.localConfig.config.bonus[value.number] = value.bonus;
            _this.localConfig.config.month_plus[value.number] = value.month_plus;
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_saller__["a" /* changeConfigBySaler */])(_this.$route.params.id, _this.localConfig).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thành công',
                  type: 'success'
                });
                _this.submitting = false;
                _this.$router.push({ name: 'saler' });
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thất bại',
                  body: 'Hệ thống gặp sự cố vui lòng thử lại sau',
                  type: 'danger'
                });
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    newKpi: function newKpi(kpi) {
      kpi.push({
        number: -1,
        money: 0
      });
    },
    removeKpi: function removeKpi(kpi, index) {
      kpi.splice(index, 1);
    },
    getConfig: function getConfig() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_saller__["b" /* getConfigBySaler */])(this.$route.params.id).then(function (response) {
        if (response.code === 200) {
          _this2.localConfig = response.data;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.localConfig.config.kpi).forEach(function (key) {
            _this2.kpiConfig.push({
              number: key,
              money: _this2.localConfig.config.kpi[key],
              bonus: _this2.localConfig.config.bonus ? _this2.localConfig.config.bonus[key] : 0,
              month_plus: _this2.localConfig.config.month_plus ? _this2.localConfig.config.month_plus[key] : 0
            });
          });
        }
      });
    },
    resetConfig: function resetConfig() {
      var _this3 = this;

      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n \u0111\u1EB7t l\u1EA1i c\u1EA5u h\xECnh m\u1EB7c \u0111\u1ECBnh cho saler n\xE0y', 'Đặt lại cấu hình mặc định', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_saller__["c" /* resetSalerConfig */])(_this3.$route.params.id).then(function (response) {
          switch (response.code) {
            case 200:
              _this3.$store.dispatch('showNotify', {
                title: 'Đặt lại cấu hình thành công',
                type: 'success'
              });
              _this3.$router.push({ name: 'saler' });
              break;
            case 422:
              var er = response.data.errors;
              var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
              _this3.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              });
              _this3.submitting = false;
              break;
            default:
              _this3.$store.dispatch('showNotify', {
                title: 'Đặt lại cấu hình thất bại',
                body: 'Hệ thống gặp sự cố vui lòng thử lại sau',
                type: 'danger'
              });
              _this3.submitting = false;
          }
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.getConfig();
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_users__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(111);






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'EditUser',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  methods: {
    validateBeforeSubmitUser: function validateBeforeSubmitUser() {
      var _this = this;

      this.submitting = true;
      this.$refs.editUserForm.validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_users__["a" /* editUser */])(_this.$route.params.id, _this.localUser).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa user  thành công'
                });
                _this.reloadGsTableAfterRedirect({ name: 'user' }, 'clients');
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Sửa user thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('toggleLoadding', false, { root: true });
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_users__["b" /* getUser */])(this.$route.params.id, {}).then(function (response) {
      if (response.code === 200) {
        _this2.localUser.id = response.data.id;
        _this2.localUser.shop_name = response.data.shop_name;
        _this2.localUser.name = response.data.name;
        _this2.localUser.phone = response.data.phone;
        _this2.localUser.email = response.data.email;
        setTimeout(function () {
          _this2.watching = true;
        }, 100);
      } else {
        _this2.$router.push({ name: 'carrier' });
        _this2.$store.dispatch('showNotify', {
          title: 'Vui lòng kiểm tra thông tin cần nhập',
          body: 'Không tìm thấy tài nguyên',
          type: 'warning'
        });
      }
    });
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_users__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(111);






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'NewUser',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  methods: {
    validateBeforeSubmitUser: function validateBeforeSubmitUser() {
      var _this = this;

      this.submitting = true;
      this.$refs.createUserForm.validate(function (valid) {
        if (valid) {
          _this.changedData = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_api_users__["c" /* createUser */])(_this.localUser).then(function (response) {
            switch (response.code) {
              case 200:
                _this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm user  thành công'
                });
                _this.reloadGsTableAfterRedirect({ name: 'user' }, 'clients');
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              case 422:
                var er = response.data.errors;
                var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(er)[0]]);
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
                break;
              default:
                _this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Tạo user thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                });
                _this.toggleLoadding(false);
                _this.submitting = false;
            }
          });
        } else {
          _this.$store.dispatch('toggleLoadding', false, { root: true });
          _this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          });
          _this.submitting = false;
          return false;
        }
      });
    },
    newUser: function newUser() {
      var _this2 = this;

      this.localUser = {
        shop_name: '',
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      };
      setTimeout(function () {
        _this2.watching = true;
      }, 100);
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_local_storage__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_users__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_accounts__ = __webpack_require__(43);










/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'User',

  data: function data() {
    return {
      clientTable: 'clients',
      filters: {
        sort: 'created_at:-1',
        role_name: 'admin'
      },
      sorted: {
        created_at: -1
      },
      sorts: [{ key: 'created_at', name: 'Ngày tạo' }],
      shieldModal: false,
      currentUser: {},
      admin: {
        roles: []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('role', ['roles'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('role', ['getAllRoles']), {
    removeFilter: function removeFilter() {
      this.reloadGsTable(this.clientTable);
      this.filters = {
        sort: 'created_at:-1',
        role_name: 'admin'
      };
    },

    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["debounce"])(function () {
      var lsFilter = __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('filters', {});
      if (!lsFilter) {
        lsFilter = {};
      }
      lsFilter[this.clientTable] = this.filters;
      __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.set('filters', lsFilter);
      if (__WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('doFilter')) {
        this.reloadGsTable(this.clientTable);
      }
    }, 300),
    deleteUser: function deleteUser(user) {
      var _this = this;

      this.currentUser = user;
      this.$confirm('B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xF3a user ' + this.currentUser.id, 'Xóa user', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(function () {
        _this.delUser();
      }).catch(function () {});
    },
    delUser: function delUser() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_api_users__["d" /* deleteUser */])(this.currentUser.id).then(function (response) {
        if (response.code === 200) {
          _this2.$message({
            type: 'success',
            message: 'Xóa user thành công'
          });
          _this2.reloadGsTable(_this2.clientTable);
        } else {
          _this2.$message({
            type: 'danger',
            message: 'Xóa user thất bại'
          });
        }
      });
    },
    shieldUser: function shieldUser(user) {
      var _this3 = this;

      this.admin.roles = [];
      this.toggleLoadding(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_api_users__["b" /* getUser */])(user.id, { include: 'roles' }).then(function (response) {
        switch (response.code) {
          case 200:
            _this3.currentUser = response.data;
            _this3.shieldModal = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(response.data.roles.data, function (role) {
              _this3.admin.roles.push(role.id);
            });
            _this3.toggleLoadding(false);
            break;
          case 404:
            _this3.toggleLoadding(false);
            _this3.$store.dispatch('showNotify', {
              title: 'Không tìm thấy tài nguyên',
              body: 'User không tồn tại trên hệ thống',
              type: 'warning'
            }, { root: true });
            break;
          default:
            _this3.toggleLoadding(false);
        }
      });
    },
    addRole: function addRole() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_api_users__["a" /* editUser */])(this.currentUser.id, this.admin).then(function (response) {
        switch (response.code) {
          case 200:
            _this4.$store.dispatch('showNotify', {
              title: 'Phân quyền thành công',
              body: 'Phân quyền user  thành công'
            });
            _this4.shieldModal = false;
            _this4.reloadGsTable(_this4.clientTable);
            _this4.toggleLoadding(false);
            break;
          case 422:
            var er = response.data.errors;
            var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["head"])(er[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(er)[0]]);
            _this4.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: message,
              type: 'warning'
            });
            _this4.toggleLoadding(false);
            break;
          default:
            _this4.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: 'Phân quyền user thất bại vui lòng kiểm tra lại thông tin',
              type: 'warning'
            });
            _this4.toggleLoadding(false);
        }
      });
    },
    toggleOnline: function toggleOnline(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true });
      var dataClient = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);
      var params = {
        is_online: 1,
        user_id: dataClient.id
      };
      var message = 'Kích hoạt online tài khoản thành công';
      this.updateStatusUser(params, message);
    },
    toggleOffline: function toggleOffline(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true });
      var dataClient = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);
      var params = {
        is_online: 0,
        user_id: dataClient.id
      };
      var message = 'Kích hoạt offline tài khoản thành công';
      this.updateStatusUser(params, message);
    },
    updateStatusUser: function updateStatusUser(data, message) {
      var _this5 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_src_api_accounts__["b" /* updateStatusOnline */])(data).then(function (response) {
        if (response.code === 200) {
          _this5.$store.dispatch('toggleLoadding', false, { root: true });
          _this5.$store.dispatch('showNotify', {
            title: 'Cập nhật thành công',
            body: message
          });
          _this5.reloadGsTable(_this5.clientTable);
        }
        if (response.code === 422) {
          _this5.$store.dispatch('toggleLoadding', false, { root: true });
          var er = response.data.errors;
          var _message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["head"])(er);
          _this5.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            body: _message,
            type: 'warning'
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.clickToCopy();
    if (__WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('filters')[this.clientTable]) {
      this.filters = __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('filters')[this.clientTable];
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.set('doFilter', true);
      }, 100);
    }
    if (!this.roles.length) {
      this.getAllRoles({ limit: -1, sort: 'name:1' });
    }
    this.listenReloadGsTable();
    this.sorted = this.getSorted(this.clientTable);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.remove('filters');
      __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.set('doFilter', true);
    } else {
      if (__WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('filters') && __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.get('filters')['clients']) {
        __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.set('doFilter', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_5_local_storage___default.a.set('doFilter', true);
      }
    }
    next();
  }
});

/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 140,
	"./af.js": 140,
	"./ar": 147,
	"./ar-dz": 141,
	"./ar-dz.js": 141,
	"./ar-kw": 142,
	"./ar-kw.js": 142,
	"./ar-ly": 143,
	"./ar-ly.js": 143,
	"./ar-ma": 144,
	"./ar-ma.js": 144,
	"./ar-sa": 145,
	"./ar-sa.js": 145,
	"./ar-tn": 146,
	"./ar-tn.js": 146,
	"./ar.js": 147,
	"./az": 148,
	"./az.js": 148,
	"./be": 149,
	"./be.js": 149,
	"./bg": 150,
	"./bg.js": 150,
	"./bm": 151,
	"./bm.js": 151,
	"./bn": 153,
	"./bn-bd": 152,
	"./bn-bd.js": 152,
	"./bn.js": 153,
	"./bo": 154,
	"./bo.js": 154,
	"./br": 155,
	"./br.js": 155,
	"./bs": 156,
	"./bs.js": 156,
	"./ca": 157,
	"./ca.js": 157,
	"./cs": 158,
	"./cs.js": 158,
	"./cv": 159,
	"./cv.js": 159,
	"./cy": 160,
	"./cy.js": 160,
	"./da": 161,
	"./da.js": 161,
	"./de": 164,
	"./de-at": 162,
	"./de-at.js": 162,
	"./de-ch": 163,
	"./de-ch.js": 163,
	"./de.js": 164,
	"./dv": 165,
	"./dv.js": 165,
	"./el": 166,
	"./el.js": 166,
	"./en-au": 167,
	"./en-au.js": 167,
	"./en-ca": 168,
	"./en-ca.js": 168,
	"./en-gb": 169,
	"./en-gb.js": 169,
	"./en-ie": 170,
	"./en-ie.js": 170,
	"./en-il": 171,
	"./en-il.js": 171,
	"./en-in": 172,
	"./en-in.js": 172,
	"./en-nz": 173,
	"./en-nz.js": 173,
	"./en-sg": 174,
	"./en-sg.js": 174,
	"./eo": 175,
	"./eo.js": 175,
	"./es": 179,
	"./es-do": 176,
	"./es-do.js": 176,
	"./es-mx": 177,
	"./es-mx.js": 177,
	"./es-us": 178,
	"./es-us.js": 178,
	"./es.js": 179,
	"./et": 180,
	"./et.js": 180,
	"./eu": 181,
	"./eu.js": 181,
	"./fa": 182,
	"./fa.js": 182,
	"./fi": 183,
	"./fi.js": 183,
	"./fil": 184,
	"./fil.js": 184,
	"./fo": 185,
	"./fo.js": 185,
	"./fr": 188,
	"./fr-ca": 186,
	"./fr-ca.js": 186,
	"./fr-ch": 187,
	"./fr-ch.js": 187,
	"./fr.js": 188,
	"./fy": 189,
	"./fy.js": 189,
	"./ga": 190,
	"./ga.js": 190,
	"./gd": 191,
	"./gd.js": 191,
	"./gl": 192,
	"./gl.js": 192,
	"./gom-deva": 193,
	"./gom-deva.js": 193,
	"./gom-latn": 194,
	"./gom-latn.js": 194,
	"./gu": 195,
	"./gu.js": 195,
	"./he": 196,
	"./he.js": 196,
	"./hi": 197,
	"./hi.js": 197,
	"./hr": 198,
	"./hr.js": 198,
	"./hu": 199,
	"./hu.js": 199,
	"./hy-am": 200,
	"./hy-am.js": 200,
	"./id": 201,
	"./id.js": 201,
	"./is": 202,
	"./is.js": 202,
	"./it": 204,
	"./it-ch": 203,
	"./it-ch.js": 203,
	"./it.js": 204,
	"./ja": 205,
	"./ja.js": 205,
	"./jv": 206,
	"./jv.js": 206,
	"./ka": 207,
	"./ka.js": 207,
	"./kk": 208,
	"./kk.js": 208,
	"./km": 209,
	"./km.js": 209,
	"./kn": 210,
	"./kn.js": 210,
	"./ko": 211,
	"./ko.js": 211,
	"./ku": 212,
	"./ku.js": 212,
	"./ky": 213,
	"./ky.js": 213,
	"./lb": 214,
	"./lb.js": 214,
	"./lo": 215,
	"./lo.js": 215,
	"./lt": 216,
	"./lt.js": 216,
	"./lv": 217,
	"./lv.js": 217,
	"./me": 218,
	"./me.js": 218,
	"./mi": 219,
	"./mi.js": 219,
	"./mk": 220,
	"./mk.js": 220,
	"./ml": 221,
	"./ml.js": 221,
	"./mn": 222,
	"./mn.js": 222,
	"./mr": 223,
	"./mr.js": 223,
	"./ms": 225,
	"./ms-my": 224,
	"./ms-my.js": 224,
	"./ms.js": 225,
	"./mt": 226,
	"./mt.js": 226,
	"./my": 227,
	"./my.js": 227,
	"./nb": 228,
	"./nb.js": 228,
	"./ne": 229,
	"./ne.js": 229,
	"./nl": 231,
	"./nl-be": 230,
	"./nl-be.js": 230,
	"./nl.js": 231,
	"./nn": 232,
	"./nn.js": 232,
	"./oc-lnc": 233,
	"./oc-lnc.js": 233,
	"./pa-in": 234,
	"./pa-in.js": 234,
	"./pl": 235,
	"./pl.js": 235,
	"./pt": 237,
	"./pt-br": 236,
	"./pt-br.js": 236,
	"./pt.js": 237,
	"./ro": 238,
	"./ro.js": 238,
	"./ru": 239,
	"./ru.js": 239,
	"./sd": 240,
	"./sd.js": 240,
	"./se": 241,
	"./se.js": 241,
	"./si": 242,
	"./si.js": 242,
	"./sk": 243,
	"./sk.js": 243,
	"./sl": 244,
	"./sl.js": 244,
	"./sq": 245,
	"./sq.js": 245,
	"./sr": 247,
	"./sr-cyrl": 246,
	"./sr-cyrl.js": 246,
	"./sr.js": 247,
	"./ss": 248,
	"./ss.js": 248,
	"./sv": 249,
	"./sv.js": 249,
	"./sw": 250,
	"./sw.js": 250,
	"./ta": 251,
	"./ta.js": 251,
	"./te": 252,
	"./te.js": 252,
	"./tet": 253,
	"./tet.js": 253,
	"./tg": 254,
	"./tg.js": 254,
	"./th": 255,
	"./th.js": 255,
	"./tk": 256,
	"./tk.js": 256,
	"./tl-ph": 257,
	"./tl-ph.js": 257,
	"./tlh": 258,
	"./tlh.js": 258,
	"./tr": 259,
	"./tr.js": 259,
	"./tzl": 260,
	"./tzl.js": 260,
	"./tzm": 262,
	"./tzm-latn": 261,
	"./tzm-latn.js": 261,
	"./tzm.js": 262,
	"./ug-cn": 263,
	"./ug-cn.js": 263,
	"./uk": 264,
	"./uk.js": 264,
	"./ur": 265,
	"./ur.js": 265,
	"./uz": 267,
	"./uz-latn": 266,
	"./uz-latn.js": 266,
	"./uz.js": 267,
	"./vi": 268,
	"./vi.js": 268,
	"./x-pseudo": 269,
	"./x-pseudo.js": 269,
	"./yo": 270,
	"./yo.js": 270,
	"./zh-cn": 271,
	"./zh-cn.js": 271,
	"./zh-hk": 272,
	"./zh-hk.js": 272,
	"./zh-mo": 273,
	"./zh-mo.js": 273,
	"./zh-tw": 274,
	"./zh-tw.js": 274
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 582;

/***/ }),
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  "data-v-759ed8b5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  "data-v-8358df8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  "data-v-fa80b58a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  "data-v-4f3bfd5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-34c496e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  "data-v-5575974c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  "data-v-0fba1707",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  "data-v-33779268",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  "data-v-5ea7c7e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  "data-v-3e34e679",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  "data-v-14b59de6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  "data-v-30f9745e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  "data-v-8535785e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  "data-v-4a8e2806",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  "data-v-799e5f06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  "data-v-92003384",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-17fe86a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  "data-v-18211e1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  "data-v-3b68e2e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  "data-v-62dbde07",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  "data-v-84335bc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  "data-v-69d8f55d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  "data-v-0aa08835",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  "data-v-433404b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  "data-v-8cbbc26e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  "data-v-acb79b06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content padding-top padding-bottom"
  }, [_c('el-card', {
    staticClass: "box-card margin-bottom",
    attrs: {
      "shadow": "never"
    }
  }, [_vm._t("filters"), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "xl": 8
    }
  }, [_vm._t("inline-filters", function() {
    return [_vm._v(" ")]
  })], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "xl": 16
    }
  }, [_c('div', {
    staticClass: "filter-box"
  }, [_c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:sortPopup",
      arg: "sortPopup"
    }],
    staticClass: "filter-btn text-grey"
  }, [_c('svg', {
    staticClass: "filter-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"
    }
  })]), _vm._v(" "), _c('el-popover', {
    ref: "sortPopup",
    attrs: {
      "placement": "bottom",
      "width": "500",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "sort-popup"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataSorts,
      "show-header": false,
      "border": false
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          on: {
            "change": _vm.fetchData
          },
          model: {
            value: (_vm.dataSorted[scope.row.key]),
            callback: function($$v) {
              _vm.$set(_vm.dataSorted, scope.row.key, $$v)
            },
            expression: "dataSorted[scope.row.key]"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": ""
          }
        }, [_c('span', {
          staticClass: "text-black"
        }, [_vm._v("Không")])]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_c('span', {
          staticClass: "text-blue"
        }, [_vm._v("Tăng")])]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": -1
          }
        }, [_c('span', {
          staticClass: "text-red"
        }, [_vm._v("Giảm")])])], 1)]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('a', {
    staticClass: "filter-btn text-red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeFilter.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    staticClass: "filter-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
    }
  })])]), _vm._v(" "), _c('el-input', {
    staticClass: "filter-search-box",
    attrs: {
      "size": "small",
      "placeholder": _vm.searchText,
      "prefix-icon": "el-icon-search"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12,
      "xl": 12
    }
  }, [_vm._t("batch_actions")], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12,
      "xl": 12
    }
  }, [((typeof _vm.dataPaginations[_vm.tableName] !== 'undefined')) ? _c('div', {
    staticClass: "block pull-right margin-top"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "sizes, prev, pager, next",
      "background": "",
      "page-sizes": [25, 50, 100, 200],
      "current-page": _vm.dataPaginations[_vm.tableName].current_page,
      "page-size": _vm.dataPaginations[_vm.tableName].per_page,
      "total": _vm.dataPaginations[_vm.tableName].total
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1) : _vm._e()])], 1)], 2), _vm._v(" "), _vm._t("default", null, {
    "data": _vm.dataTable
  }), _vm._v(" "), ((typeof _vm.dataPaginations[_vm.tableName] !== 'undefined')) ? _c('div', {
    staticClass: "block pull-right margin-top"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "sizes, prev, pager, next",
      "page-sizes": [25, 50, 100, 200],
      "current-page": _vm.dataPaginations[_vm.tableName].current_page,
      "page-size": _vm.dataPaginations[_vm.tableName].per_page,
      "total": _vm.dataPaginations[_vm.tableName].total
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1) : _vm._e()], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Cấu hình chung lương cho saller",
      "breadcrumbs": [{
        title: 'Quản lý saler',
        route: {
          name: 'saler'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "config-saler-salary",
    attrs: {
      "model": _vm.localConfig,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit()
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Nhân viên chính thức")]), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "employee.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiEmployee), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiEmployee[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'number', $$v)
        },
        expression: "kpiEmployee[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiEmployee[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiEmployee[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiEmployee[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiEmployee[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiEmployee[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'money', $$v)
        },
        expression: "kpiEmployee[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiEmployee[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiEmployee[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'bonus', $$v)
        },
        expression: "kpiEmployee[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiEmployee[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiEmployee[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'month_plus', $$v)
        },
        expression: "kpiEmployee[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiEmployee[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiEmployee, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiEmployee)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "employee.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.employee.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.employee, "salary_accumulation", $$v)
      },
      expression: "localConfig.employee.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.employee.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "employee.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.employee.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.employee, "salary_by_customer", $$v)
      },
      expression: "localConfig.employee.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.employee.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "employee.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.employee.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.employee, "month_accumulation", $$v)
      },
      expression: "localConfig.employee.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.employee.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Nhân viên thử việc")]), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "trainee.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiTrainee), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiTrainee[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'number', $$v)
        },
        expression: "kpiTrainee[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiTrainee[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiTrainee[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiTrainee[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiTrainee[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiTrainee[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'money', $$v)
        },
        expression: "kpiTrainee[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiTrainee[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiTrainee[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'bonus', $$v)
        },
        expression: "kpiTrainee[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiTrainee[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiTrainee[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'month_plus', $$v)
        },
        expression: "kpiTrainee[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiTrainee[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiTrainee, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiTrainee)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "trainee.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.trainee.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.trainee, "salary_accumulation", $$v)
      },
      expression: "localConfig.trainee.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.trainee.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "trainee.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.trainee.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.trainee, "salary_by_customer", $$v)
      },
      expression: "localConfig.trainee.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.trainee.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "trainee.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.trainee.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.trainee, "month_accumulation", $$v)
      },
      expression: "localConfig.trainee.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.trainee.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Nhân viên parttime / CTV")]), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "parttime.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiPartTime), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiPartTime[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'number', $$v)
        },
        expression: "kpiPartTime[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiPartTime[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiPartTime[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiPartTime[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiPartTime[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiPartTime[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'money', $$v)
        },
        expression: "kpiPartTime[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiPartTime[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiPartTime[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'bonus', $$v)
        },
        expression: "kpiPartTime[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiPartTime[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiPartTime[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'month_plus', $$v)
        },
        expression: "kpiPartTime[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiPartTime[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiPartTime, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiPartTime)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "parttime.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.parttime.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.parttime, "salary_accumulation", $$v)
      },
      expression: "localConfig.parttime.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.parttime.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "parttime.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.parttime.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.parttime, "salary_by_customer", $$v)
      },
      expression: "localConfig.parttime.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.parttime.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "parttime.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.parttime.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.parttime, "month_accumulation", $$v)
      },
      expression: "localConfig.parttime.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.parttime.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý saler"
    }
  }, [_c('router-link', {
    staticClass: "ui mini violet button",
    attrs: {
      "to": {
        name: 'saller-config'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Cấu hình chung")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'new-user'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.salerTable,
    attrs: {
      "table-name": _vm.salerTable,
      "data-source": "saller-salary",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.salerTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.salerTable].current_page - 1) * _vm.dataPaginations[_vm.salerTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Saller",
            "width": "250"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.saler) ? _c('div', [(scope.row.saler.data.name) ? _c('p', [_c('i', {
                staticClass: "fa fa-user",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.saler.data.name))])]) : _vm._e(), _vm._v(" "), (scope.row.saler.data.phone) ? _c('p', [_c('i', {
                staticClass: "fa fa-phone",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.saler.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.saler.data.email) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.saler.data.email))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('i', {
                staticClass: "fa fa-calendar"
              }), _vm._v(" " + _vm._s(scope.row.month))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đơn giá"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Đơn DS: "), _c('small', {
                staticClass: "pull-right text-red",
                staticStyle: {
                  "font-size": "10px"
                }
              }, [_vm._v(_vm._s(_vm.commissionText(scope.row.config_salary.kpi)))])]), _vm._v(" "), _c('p', [_vm._v("Đơn TL: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.config_salary.salary_accumulation)))])]), _vm._v(" "), _c('p', [_vm._v("Khách mới: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.config_salary.salary_by_customer)))])]), _vm._v(" "), _c('p', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đơn & Khách",
            "width": "130"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Đơn DS: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_new_shipment)))])]), _vm._v(" "), _c('p', [_vm._v("Đơn TL: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_accumulation_shipment)))])]), _vm._v(" "), _c('p', [_vm._v("Khách: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_new_customer)))])]), _vm._v(" "), _c('p', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Lương",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Lương DS: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary_commission)))])]), _vm._v(" "), _c('p', [_vm._v("Lương TL: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary_accumulation)))])]), _vm._v(" "), _c('p', [_vm._v("Thưởng khách: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary_new_customer)))])]), _vm._v(" "), _c('p', [_vm._v("Thưởng chỉ tiêu: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.bonus)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng lương: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "KPI",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(" KPI: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.kpi)))])]), _vm._v(" "), _c('p', [_vm._v(" % KPI: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.kpi_percent)))])]), _vm._v(" "), _c('p', {
                staticClass: "text-right"
              }, [_c('span', {
                class: _vm.statusColor[scope.row.kpi_status]
              }, [_vm._v(_vm._s(scope.row.kpi_status_txt))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "55"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(scope.row.saler) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cấu hình lương"
                }
              }, [_c('router-link', {
                staticClass: "text-violet padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'saller-config-by-saler',
                    params: {
                      id: scope.row.saler.data.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-cog"
              })])], 1) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn saler"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.sale_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sale_id", $$v)
      },
      expression: "filters.sale_id"
    }
  }, _vm._l((_vm.administrators), function(admin) {
    return _c('el-option', {
      key: admin.id,
      attrs: {
        "label": admin.name,
        "value": admin.id
      }
    })
  }), 1)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Bảng điều khiển"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-row', {
    staticClass: "remove-margin margin-sm-top",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14,
      "xs": 0
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "span": 5,
      "xs": 24
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "xs": 24
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.changeView
    },
    model: {
      value: (_vm.view),
      callback: function($$v) {
        _vm.view = $$v
      },
      expression: "view"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "day"
    }
  }, [_vm._v("Ngày")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "week"
    }
  }, [_vm._v("Tuần")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "month"
    }
  }, [_vm._v("Tháng")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "year"
    }
  }, [_vm._v("Năm")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v("Biểu đồ biểu diễn theo thời gian")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-proportion"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-client"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-cod-amount"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-profit"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v("Biểu đồ phân bổ theo thời gian")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-total-shop"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-total-source"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "margin-lg-top",
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-carrier-pie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-proportion-pie"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v("Thống kê hoạt động của người dùng")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 Khách hàng có số lượng đơn cao nhất "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.drawAllUserHasShipment.apply(null, arguments)
      }
    }
  }, [_c('small', [_vm._v("(Xem tất cả)")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 Khách hàng có số lượng đơn cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topUserAllShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.client) ? _c('span', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Đơn thành công",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_success)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉ lệ",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("percent")((scope.row.total_success / scope.row.total_shipment) * 100, 2)))]), _vm._v(" "), _c('a', {
          staticClass: "text-blue cursor-pointer pull-right",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showDetailShop(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 Khách hàng có số lượng đơn chuyển hoàn cao nhất")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 Khách hàng có số lượng đơn chuyển hoàn cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topUserReturnShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.client) ? _c('span', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Đơn chuyển hoàn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_return)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉ lệ",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("percent")((scope.row.total_return / scope.row.total_shipment) * 100)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 quận có lượng đơn cao nhất")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 quận có lượng đơn cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topDistrictTopShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.name) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 quận có lượng khách hàng cao nhất")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 quận có lượng khách hàng cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topDistrictTopUser,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.name) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_user)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("Thống kê đơn theo tỉnh thành")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          Thống kê đơn theo tỉnh thành\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": [].concat(_vm.matrixShipmentByCity, _vm.interprovinceShipment),
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Thời gian"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.create_time) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉnh thành đi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.city_from_name ? scope.row.city_from_name : scope.row.city_from) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉnh thành đến"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.city_to_name ? scope.row.city_to_name : 'Liên tỉnh') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Vận đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_location_fee / 1000)) + " k")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("Thống kê đơn gửi từ tỉnh thành")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          Thống kê đơn gửi từ tỉnh thành\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allShipmentFromCity,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Thời gian"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.create_time) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉnh thành"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.city_from) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Vận đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ("Thông tin shop: " + (_vm.currentShop.shop_name)),
      "visible": _vm.detailShopModal
    },
    on: {
      "update:visible": function($event) {
        _vm.detailShopModal = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-detail-shopment-shop"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Danh sách khách hàng tạo đơn",
      "visible": _vm.allUserHasShipmentModal
    },
    on: {
      "update:visible": function($event) {
        _vm.allUserHasShipmentModal = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allUserHasShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.client) ? _c('span', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Đơn thành công",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_success)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉ lệ",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("percent")((scope.row.total_success / scope.row.total_shipment) * 100, 2)))]), _vm._v(" "), _c('a', {
          staticClass: "text-blue cursor-pointer pull-right",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showDetailShop(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Báo cáo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [(_vm.showData) ? _c('gs-table', {
    ref: _vm.invoiceReportTable,
    attrs: {
      "table-name": _vm.invoiceReportTable,
      "data-source": "invoices/report-by-crosscheck",
      "data-params": _vm.filters,
      "cache-data": false,
      "data-sorts": _vm.sorts,
      "data-sorted": _vm.sorted
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.invoiceReportTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.invoiceReportTable].current_page - 1) * _vm.dataPaginations[_vm.invoiceReportTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.cross_check && scope.row.cross_check.data.id) ? _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Mã đối soát"
                }
              }, [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.cross_check.data.id))])])], 1) : _vm._e(), _vm._v(" "), (scope.row.cross_check) ? _c('p', [_vm._v("Ngày: " + _vm._s(scope.row.cross_check.data.created_at))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi",
            "width": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phiếu: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng tiền: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_amount)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi đã thanh toán",
            "width": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phiếu: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_payed)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng tiền: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_amount_payed)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi đã xác nhận",
            "width": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phiếu: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_confirm)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng tiền: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_amount_confirm)))])])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 70991074)
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)])], 1)], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa phiếu thu",
      "breadcrumbs": [{
        title: 'Quản lý phiếu thu',
        route: {
          name: 'receipt'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "edit-receipt-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localReceipt,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tổng tiền",
      "prop": "total_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng tiền"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('total_amount')
      },
      "blur": function($event) {
        return _vm.addZero('total_amount')
      }
    },
    model: {
      value: (_vm.localReceipt.total_amount),
      callback: function($$v) {
        _vm.$set(_vm.localReceipt, "total_amount", $$v)
      },
      expression: "localReceipt.total_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localReceipt.total_amount)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm khách hàng",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên, sđt...",
      "remote-method": _vm.selectReceiver,
      "loading": _vm.fetchReceiver
    },
    on: {
      "change": _vm.selectSuggettionReceiver
    },
    model: {
      value: (_vm.suggettionReceiver),
      callback: function($$v) {
        _vm.suggettionReceiver = $$v
      },
      expression: "suggettionReceiver"
    }
  }, _vm._l((_vm.listReceiver), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm vận đơn"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập mã,...",
      "remote-method": _vm.selectShipment,
      "loading": _vm.fetchShipment
    },
    on: {
      "change": _vm.selectSuggettionShipment
    },
    model: {
      value: (_vm.suggettionShipment),
      callback: function($$v) {
        _vm.suggettionShipment = $$v
      },
      expression: "suggettionShipment"
    }
  }, _vm._l((_vm.listShipment), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left shipment-code-display"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right shipment-code-display"
    }, [_vm._v(_vm._s(item.code))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lý do",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Lý do"
    },
    model: {
      value: (_vm.localReceipt.description),
      callback: function($$v) {
        _vm.$set(_vm.localReceipt, "description", $$v)
      },
      expression: "localReceipt.description"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(Object.keys(_vm.suggettionReceiver).length) ? _c('h3', [_vm._v("Thông tin khách hàng")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.suggettionReceiver).length) ? _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.name) + "    "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.phone) + "    "), _c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.email))]) : _vm._e(), _vm._v(" "), (_vm.shipmentAdded.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.shipmentAdded
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 1353483373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người nhận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.phone))])]
      }
    }], null, false, 1336654758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người gửi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.phone))])]
      }
    }], null, false, 438074374)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.id)))])]
      }
    }], null, false, 2465153771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payer_txt))])]
      }
    }], null, false, 52296414)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Xóa"
          }
        }, [_c('a', {
          staticClass: "text-red padding-all display-inline-block cursor-pointer",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeShipment(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])])]
      }
    }], null, false, 1101567570)
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới phiếu thu",
      "breadcrumbs": [{
        title: 'Quản lý phiếu thu',
        route: {
          name: 'receipt'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "create-receipt-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localReceipt,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tổng tiền",
      "prop": "total_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng tiền"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('total_amount')
      },
      "blur": function($event) {
        return _vm.addZero('total_amount')
      }
    },
    model: {
      value: (_vm.localReceipt.total_amount),
      callback: function($$v) {
        _vm.$set(_vm.localReceipt, "total_amount", $$v)
      },
      expression: "localReceipt.total_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localReceipt.total_amount)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm khách hàng",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên, sđt...",
      "remote-method": _vm.selectReceiver,
      "loading": _vm.fetchReceiver
    },
    on: {
      "change": _vm.selectSuggettionReceiver
    },
    model: {
      value: (_vm.suggettionReceiver),
      callback: function($$v) {
        _vm.suggettionReceiver = $$v
      },
      expression: "suggettionReceiver"
    }
  }, _vm._l((_vm.listReceiver), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm vận đơn"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập mã,...",
      "remote-method": _vm.selectShipment,
      "loading": _vm.fetchShipment
    },
    on: {
      "change": _vm.selectSuggettionShipment
    },
    model: {
      value: (_vm.suggettionShipment),
      callback: function($$v) {
        _vm.suggettionShipment = $$v
      },
      expression: "suggettionShipment"
    }
  }, _vm._l((_vm.listShipment), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left shipment-code-display"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right shipment-code-display"
    }, [_vm._v(_vm._s(item.code))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lý do",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Lý do"
    },
    model: {
      value: (_vm.localReceipt.description),
      callback: function($$v) {
        _vm.$set(_vm.localReceipt, "description", $$v)
      },
      expression: "localReceipt.description"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(Object.keys(_vm.suggettionReceiver).length) ? _c('h3', [_vm._v("Thông tin khách hàng")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.suggettionReceiver).length) ? _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.name) + "    "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.phone) + "    "), _c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.email))]) : _vm._e(), _vm._v(" "), (_vm.shipmentAdded.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.shipmentAdded
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 1353483373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người nhận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.phone))])]
      }
    }], null, false, 1336654758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người gửi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.phone))])]
      }
    }], null, false, 438074374)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.id)))])]
      }
    }], null, false, 2465153771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payer_txt))])]
      }
    }], null, false, 52296414)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Xóa"
          }
        }, [_c('a', {
          staticClass: "text-red padding-all display-inline-block cursor-pointer",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeShipment(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])])]
      }
    }], null, false, 1101567570)
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": _vm.placeholder ? _vm.placeholder : 'Gõ để tìm kiếm',
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', _vm.value)
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.clients), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ((item.name) + " - " + (item.shop_name)),
        "value": item.id
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Tạo mới phiếu chi",
      "breadcrumbs": [{
        title: 'Quản lý phiếu chi',
        route: {
          name: 'invoice'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all margin-top"
  }, [_c('el-form', {
    ref: "create-invoice-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localInvoice,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Tìm kiếm người nhận",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên, sđt...",
      "remote-method": _vm.selectReceiver,
      "loading": _vm.fetchReceiver
    },
    on: {
      "change": _vm.selectSuggettionReceiver
    },
    model: {
      value: (_vm.suggettionReceiver),
      callback: function($$v) {
        _vm.suggettionReceiver = $$v
      },
      expression: "suggettionReceiver"
    }
  }, _vm._l((_vm.listReceiver), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm vận đơn"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "disabled": !_vm.localInvoice.client_id,
      "placeholder": "Nhập mã,...",
      "remote-method": _vm.selectShipment,
      "loading": _vm.fetchShipment
    },
    on: {
      "change": _vm.selectSuggettionShipment
    },
    model: {
      value: (_vm.suggettionShipment),
      callback: function($$v) {
        _vm.suggettionShipment = $$v
      },
      expression: "suggettionShipment"
    }
  }, _vm._l((_vm.listShipment), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left shipment-code-display"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right shipment-code-display"
    }, [_vm._v(_vm._s(item.code))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lý do",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Lý do"
    },
    model: {
      value: (_vm.localInvoice.description),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "description", $$v)
      },
      expression: "localInvoice.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Loại phiếu",
      "prop": "kind"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Loại phiếu"
    },
    model: {
      value: (_vm.localInvoice.kind),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "kind", $$v)
      },
      expression: "localInvoice.kind"
    }
  }, _vm._l((_vm.invoiceHelpers.kinds), function(item, key, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": key,
        "label": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tổng tiền phải trả cho shop",
      "prop": "total_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng tiền phải trả cho shop"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('total_amount')
      },
      "blur": function($event) {
        return _vm.addZero('total_amount')
      }
    },
    model: {
      value: (_vm.localInvoice.total_amount),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "total_amount", $$v)
      },
      expression: "localInvoice.total_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localInvoice.total_amount)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tiền cộng vào tài khoản shop",
      "prop": "debt"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiền cộng vào tài khoản shop"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('debt')
      },
      "blur": function($event) {
        return _vm.addZero('debt')
      }
    },
    model: {
      value: (_vm.localInvoice.debt),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "debt", $$v)
      },
      expression: "localInvoice.debt"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localInvoice.debt)))])])], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(Object.keys(_vm.suggettionReceiver).length) ? _c('h3', [_vm._v("Thông tin người nhận")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.suggettionReceiver).length) ? _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.name) + "    "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.phone) + "    "), _c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.email))]) : _vm._e(), _vm._v(" "), (_vm.shipmentAdded.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.shipmentAdded
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 1353483373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người nhận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.phone))])]
      }
    }], null, false, 1336654758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người gửi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.phone))])]
      }
    }], null, false, 438074374)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.id)))])]
      }
    }], null, false, 2465153771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payer_txt))])]
      }
    }], null, false, 52296414)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Xóa"
          }
        }, [_c('a', {
          staticClass: "text-red padding-all display-inline-block cursor-pointer",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeShipment(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])])]
      }
    }], null, false, 1101567570)
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "invoice-area"
  }, [_c('gs-header', {
    attrs: {
      "title": ("Chi tiết phiếu chi: <span class='shipment-code-display click-copy'>" + (_vm.invoice.id) + "</span>"),
      "breadcrumbs": [{
        title: 'Quản lý phiếu chi',
        route: {
          name: 'invoice'
        }
      }]
    }
  }, [_c('el-popover', {
    ref: "confirmPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.confirmPopup),
      callback: function($$v) {
        _vm.confirmPopup = $$v
      },
      expression: "confirmPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn xác nhận phiếu chi này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.confirmPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.confirmPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmInvoice.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n          nhận")])], 1)]), _vm._v(" "), _c('el-popover', {
    ref: "payPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.payPopup),
      callback: function($$v) {
        _vm.payPopup = $$v
      },
      expression: "payPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn thanh toán phiếu chi này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.payPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.payPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.payInvoice.apply(null, arguments)
      }
    }
  }, [_vm._v("Thanh\n          toán")])], 1)]), _vm._v(" "), _c('el-popover', {
    ref: "emailPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.emailPopup),
      callback: function($$v) {
        _vm.emailPopup = $$v
      },
      expression: "emailPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn gửi lại email?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.emailPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.emailPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("Gửi")])], 1)]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportExcel.apply(null, arguments)
      }
    }
  }, [_vm._v("Xuất excel")]), _vm._v(" "), (_vm.invoice.total_amount > 0) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showpaymentExtra.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Cấn trừ")]) : _vm._e(), _vm._v(" "), (_vm.invoice.total_amount < 0 || _vm.invoice.real_amount < 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "loading": _vm.doHardPayment
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hardPayment.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Trừ ví")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:confirmPopup",
      arg: "confirmPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.invoice.confirmer_id),
      expression: "!invoice.confirmer_id"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n      Xác nhận")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:payPopup",
      arg: "payPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.can_payment),
      expression: "invoice.can_payment"
    }],
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v("\n      Thanh\n      toán")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:emailPopup",
      arg: "emailPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.payer_id),
      expression: "invoice.payer_id"
    }],
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" Gửi\n      email")])], 1), _vm._v(" "), (_vm.invoice.id) ? _c('div', {
    staticClass: "padding-sm-all margin-top padding-lg-bottom invoice-body"
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Thông tin shop")]), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Shop:")]), _vm._v(" "), (_vm.invoice.client.data.vip) ? _c('span', {
    staticClass: "ui label green mini"
  }, [_vm._v("Credit")]) : _c('span', {
    staticClass: "ui label grey mini"
  }, [_vm._v("Debit")]), _vm._v("\n          " + _vm._s(_vm.invoice.client.data.name) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Điện thoại:")]), _vm._v(" "), _c('span', {
    staticClass: "click-copy"
  }, [_vm._v(_vm._s(_vm.invoice.client.data.phone))])]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "click-copy"
  }, [_vm._v(_vm._s(_vm.invoice.client.data.email))])]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Ví trả trước:")]), _vm._v(" "), _c('span', {
    staticClass: "text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.client.data.debit_amount)))])]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Ví giao dịch:")]), _vm._v(" "), _c('span', {
    staticClass: "text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.client.data.money_amount)))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Tài khoản ngân hàng")]), _vm._v(" "), (!_vm.getBankInfo.length) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.invoice.bank_info) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getBankInfo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "margin-bottom"
    }, [_c('span', {
      staticClass: "click-copy"
    }, [_vm._v("• " + _vm._s(item.value))])])
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("Lý do:")]), _vm._v(" "), _c('span', {
    staticClass: "click-copy"
  }, [_vm._v(_vm._s(_vm.getReason))])])], 2), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Kiểm soát")]), _vm._v(" "), (_vm.invoice.confirmer) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Người duyệt:")]), _vm._v(" " + _vm._s(_vm.invoice.confirmer.data.name) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Duyệt lúc:")]), _vm._v(" " + _vm._s(_vm.invoice.confirmed_at))]), _vm._v(" "), (_vm.invoice.payer) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Thanh toán:")]), _vm._v(" " + _vm._s(_vm.invoice.payer.data.name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Thanh toán lúc:")]), _vm._v(" " + _vm._s(_vm.invoice.payed_at))])]), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Thanh toán")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("1. Tổng COD:")]), _vm._v(" "), (_vm.getCrossCcheckKindCod) ? _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(" " + _vm._s(_vm._f("vnd")(_vm.getTotalCOD)))]) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee || _vm.getCrossCcheckKindFee1) ? _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(" " + _vm._s(_vm._f("vnd")(0)))]) : _vm._e()]), _vm._v(" "), (_vm.getCrossCcheckKindCod) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("2. Tổng phí:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getTotalFee - _vm.getPayedFee)))])]) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("2. Tổng phí:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getTotalFeeDifference)))])]) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee1) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("2. Tổng phí:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.debt)))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold",
    attrs: {
      "title": "Tiền cần trả shop"
    }
  }, [_vm._v("3. " + _vm._s(_vm.invoice.total_amount > 0 ? 'Trả shop' : 'Thu shop') + " "), _c('small', [_vm._v("(1-2)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.total_amount)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("4. " + _vm._s(_vm.invoice.money_return > 0 ? 'Truy thu' : 'Đã truy thu') + ":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getArearAmount)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold",
    attrs: {
      "title": _vm.invoice.payment_note
    }
  }, [_vm._v("5. Nợ ví trả trước:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")((_vm.invoice.payment_extra * -1))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold",
    attrs: {
      "title": "Tiền thực trả cho shop"
    }
  }, [_vm._v("Thực trả:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.real_amount)))])])])], 1), _vm._v(" "), (_vm.invoice.shipments) ? _c('el-row', {
    staticClass: "margin-top"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("DANH SÁCH VẬN ĐƠN")]), _vm._v(" "), (_vm.getCrossCcheckKindCod) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invoice.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tài chính"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("COD: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_for_cross)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng phí: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Phí đã thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getCompare(scope.row).last_payed_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Phí cần thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee - _vm.getCompare(scope.row).last_payed_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Trả shop: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_return_shop + _vm.getCompare(scope.row).last_payed_fee)))])])]
      }
    }], null, false, 881170283)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red pull-right"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.location_fee)))])]), _vm._v(" "), (scope.row.update_info_fee) ? _c('p', [_vm._v("Phí cập nhật: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.update_info_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.discount) ? _c('p', [_vm._v("Giảm giá: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.discount)))])]) : _vm._e(), _vm._v(" "), (scope.row.update_info_fee || scope.row.discount) ? _c('p', [_vm._v("Phí thực: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")((parseInt(scope.row.location_fee) +
          parseInt(scope.row.update_info_fee)) - parseInt(scope.row.discount))))])]) : _vm._e()]
      }
    }], null, false, 649544089)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chi phí khác"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.return_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Vượt cân: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.overweight_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Giao lại: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.re_delivery_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Bảo hiểm: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.insurrance_fee)))])]), _vm._v(" "), _c('p', [_vm._v("COD: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_fee_real)))])]), _vm._v(" "), _c('p', [_vm._v("Phí dịch vụ: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.service_fee)))])])]
      }
    }], null, false, 42426858)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Trạng thái",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.shipmentStatuses[scope.row.status]
        }, [_vm._v(_vm._s(scope.row.status_txt))]), _c('br'), _vm._v(" "), (scope.row.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), _vm._v(" "), (scope.row.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e()]
      }
    }], null, false, 1321402342)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invoice.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chi phí đã thu lần 1",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red pull-right"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.compare_fee.data.last_total_fee)))])])]
      }
    }], null, false, 2617603501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí đối soát"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.compare_fee.data.total_fee)))])])]
      }
    }], null, false, 3670930480)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chênh lệch"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.differenceFee(scope.row.compare_fee.data.last_total_fee, scope.row.compare_fee.data.total_fee))))])])]
      }
    }], null, false, 686709672)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng tiền đơn hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])])]
      }
    }], null, false, 178689434)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee1) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invoice.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tài chính"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Tổng phí: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Đã thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getCompare(scope.row).last_payed_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Tạm thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getCompare(scope.row).payed_fee)))])])]
      }
    }], null, false, 2557346471)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red pull-right"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.location_fee)))])]), _vm._v(" "), (scope.row.update_info_fee) ? _c('p', [_vm._v("Phí cập nhật: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.update_info_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.discount) ? _c('p', [_vm._v("Giảm giá: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.discount)))])]) : _vm._e(), _vm._v(" "), (scope.row.update_info_fee || scope.row.discount) ? _c('p', [_vm._v("Phí thực: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")((parseInt(scope.row.location_fee) +
          parseInt(scope.row.update_info_fee)) - parseInt(scope.row.discount))))])]) : _vm._e()]
      }
    }], null, false, 649544089)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chi phí khác"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.return_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Vượt cân: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.overweight_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Giao lại: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.re_delivery_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Bảo hiểm: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.insurrance_fee)))])]), _vm._v(" "), _c('p', [_vm._v("COD: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_fee_real)))])]), _vm._v(" "), _c('p', [_vm._v("Phí dịch vụ: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.service_fee)))])])]
      }
    }], null, false, 42426858)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Trạng thái",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.shipmentStatuses[scope.row.status]
        }, [_vm._v(_vm._s(scope.row.status_txt))]), _c('br'), _vm._v(" "), (scope.row.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), _vm._v(" "), (scope.row.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e()]
      }
    }], null, false, 1321402342)
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cấn trừ tiền COD",
      "visible": _vm.dialogPaymentExtra
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPaymentExtra = $event
      }
    }
  }, [_c('p', [_vm._v("Tác vụ này sẽ cấn trừ tiền COD của phiếu chi này và nạp số tiền đó vào ví trả trước.")]), _vm._v(" "), _c('el-form', {
    ref: "payment_extra",
    attrs: {
      "rules": _vm.rulePaymentExtra,
      "model": _vm.payment_extra,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền",
      "prop": "payment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.payment_extra.payment),
      callback: function($$v) {
        _vm.$set(_vm.payment_extra, "payment", $$v)
      },
      expression: "payment_extra.payment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ghi chú",
      "prop": "note"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.payment_extra.note),
      callback: function($$v) {
        _vm.$set(_vm.payment_extra, "note", $$v)
      },
      expression: "payment_extra.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingPayment
    },
    on: {
      "click": function($event) {
        return _vm.onPaymentExtra('payment_extra')
      }
    }
  }, [_vm._v("Cấn trừ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Thêm vận đơn vào đối soát",
      "visible": _vm.dialog
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Chọn file đối soát"
    }
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "fileInput",
      "name": "file"
    },
    on: {
      "change": _vm.loadExcel
    }
  })])], 1), _vm._v(" "), (_vm.fileColumnField.length > 1) ? _c('el-col', [_c('el-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.fileColumnField.length > 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Chọn các cột dữ liệu tương ứng")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "5",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', [_c('td', [_c('strong', [_vm._v("Dữ liệu đầu vào")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Cột tương ứng")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Đơn vị vận chuyển")]), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Chọn cột tương ứng"
    },
    model: {
      value: (_vm.carrier),
      callback: function($$v) {
        _vm.carrier = $$v
      },
      expression: "carrier"
    }
  }, _vm._l((_vm.carriers), function(carrier) {
    return _c('el-option', {
      key: carrier.id,
      attrs: {
        "label": carrier.name,
        "value": carrier.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _vm._l((_vm.filteredFileColumnField), function(field, index) {
    return _c('tr', {
      key: 'row-' + index
    }, [_c('td', [_vm._v(_vm._s(field.text))]), _vm._v(" "), _c('td', [_c('el-select', {
      attrs: {
        "placeholder": "Chọn cột tương ứng"
      },
      model: {
        value: (_vm.filteredFileColumnField[index].file),
        callback: function($$v) {
          _vm.$set(_vm.filteredFileColumnField[index], "file", $$v)
        },
        expression: "filteredFileColumnField[index].file"
      }
    }, _vm._l((_vm.fileColumnField), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.text,
          "value": item.value
        }
      })
    }), 1)], 1)])
  })], 2)])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Hủy bỏ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting,
      "disabled": _vm.dataExcelJson.length === 0
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Tải lên")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý phiếu thu"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-receipt'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.receiptTable,
    attrs: {
      "table-name": _vm.receiptTable,
      "data-source": "receipts",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.receiptTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.receiptTable].current_page - 1) * _vm.dataPaginations[_vm.receiptTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu thu",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Người tạo"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.creator) ? _c('div', [_c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.creator.data.name))]), _vm._v(" "), _c('p', [_c('i', {
                staticClass: "fa fa-sign-in"
              }), _vm._v(" " + _vm._s(scope.row.creator.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Người xác nhận"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.confirmer) ? _c('div', [_c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.confirmer.data.name))]), _vm._v(" "), _c('p', [_c('i', {
                staticClass: "fa fa-sign-in"
              }), _vm._v(" " + _vm._s(scope.row.confirmer.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Lý do"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('small', [_vm._v(_vm._s(scope.row.description))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tổng tiền"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "text-red click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.real_amount)))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('router-link', {
                staticClass: "text-blue padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'detail-receipt',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-receipt',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteReceipt(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xác nhận"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.confirmReceipt(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-check"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-top",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.statuses), function(status, index) {
    return _c('a', {
      staticClass: "cursor-pointer padding-all",
      class: [{
        'active-status': status.value === _vm.filters[status.key]
      }, status.class],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setFilterStatus(status.key, status.value)
        }
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý phiếu chi"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    }
  }, [_c('router-link', {
    staticClass: "text-remove-decoration text-white",
    attrs: {
      "to": {
        name: 'create-invoice'
      }
    }
  }, [_vm._v("Thêm mới")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-s-data"
    }
  }, [_c('router-link', {
    staticClass: "text-remove-decoration text-black",
    attrs: {
      "to": {
        name: 'invoice-report'
      }
    }
  }, [_vm._v("Báo cáo")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportExcel.apply(null, arguments)
      }
    }
  }, [_vm._v("Xuất excel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dialogExportZh = true
      }
    }
  }, [_vm._v("Xuất bảng kê")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.invoiceTable,
    attrs: {
      "table-name": _vm.invoiceTable,
      "data-source": "invoices",
      "data-params": _vm.filters,
      "cache-data": false,
      "data-sorts": _vm.sorts,
      "data-sorted": _vm.sorted
    },
    on: {
      "remove-filter": _vm.removeFilter,
      "filter-change": _vm.gsFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          },
          on: {
            "selection-change": _vm.handleSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "align": "center",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "align": "center",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.invoiceTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.invoiceTable].current_page - 1) * _vm.dataPaginations[_vm.invoiceTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phiếu chi",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1), _vm._v(" "), (scope.row.cross_check) ? _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Mã đối soát"
                }
              }, [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.cross_check.data.id))])])], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('el-tag', {
                attrs: {
                  "size": "small",
                  "type": _vm.kindStatus(scope.row.kind)
                }
              }, [_vm._v(_vm._s(scope.row.kind_txt))])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Shop"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.client) ? _c('div', [_c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]), _vm._v(" "), _c('p', {
                staticClass: "click-copy"
              }, [_c('i', {
                staticClass: "fa fa-phone"
              }), _vm._v(" " + _vm._s(scope.row.client.data.phone))]), _vm._v(" "), _c('p', {
                class: {
                  'text-red': scope.row.client.data.debit_amount < 0
                }
              }, [_c('i', {
                staticClass: "fa fa-money"
              }), _vm._v(" " + _vm._s(_vm._f("vnd")(scope.row.client.data.debit_amount)))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tài khoản NH"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(!_vm.getBankInfo(scope.row.bank_info).length) ? _c('div', [_vm._v("\n                " + _vm._s(scope.row.bank_info) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getBankInfo(scope.row.bank_info)), function(item, index) {
                return _c('div', {
                  key: index,
                  staticClass: "margin-bottom"
                }, [_c('span', {
                  staticClass: "click-copy"
                }, [_vm._v(_vm._s(item.value))])])
              })]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tổng tiền trả shop"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phí: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.debt)))])]), _vm._v(" "), (scope.row.money_return > 0) ? _c('p', [_vm._v("Truy thu: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.money_return)))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Thực trả: "), _c('span', {
                staticClass: "text-red click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.real_amount)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('router-link', {
                staticClass: "text-blue padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'detail-invoice',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-invoice',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteInvoice(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.confirmer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xác nhận"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.confirmInvoice(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-check"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.can_payment) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Thanh toán"
                }
              }, [_c('a', {
                staticClass: "text-violet padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.payInvoice(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-money"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.payer_id) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Gửi lại email"
                }
              }, [_c('a', {
                staticClass: "text-violet padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.sendEmail(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-envelope-o"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Ngân hàng"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.bank_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "bank_id", $$v)
      },
      expression: "filters.bank_id"
    }
  }, _vm._l((_vm.banks), function(bank) {
    return _c('el-option', {
      key: bank.id,
      attrs: {
        "label": bank.name + ' (' + bank.short_name + ')',
        "value": bank.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Kiểu đối soát"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.kind),
      callback: function($$v) {
        _vm.$set(_vm.filters, "kind", $$v)
      },
      expression: "filters.kind"
    }
  }, _vm._l((_vm.crossChecksHelpers.kinds), function(kindName, kindKey) {
    return _c('el-option', {
      key: kindKey,
      attrs: {
        "label": kindName,
        "value": kindKey
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('select-client', {
    attrs: {
      "placeholder": "Gõ để tìm kiếm khách hàng"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.filters.client_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "client_id", $$v)
      },
      expression: "filters.client_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-top",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_vm._v("\n            Tiền thanh toán:\n            "), _c('el-radio-group', {
    staticClass: "status-listting margin-lg-right",
    attrs: {
      "fill": _vm.filters.is_negative ? '#32CD32' : '#db2828'
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.is_negative),
      callback: function($$v) {
        _vm.$set(_vm.filters, "is_negative", $$v)
      },
      expression: "filters.is_negative"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_c('span', {
    class: {
      'text-red': _vm.filters.is_negative != 0
    }
  }, [_vm._v("Âm")])]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    class: {
      'text-green': _vm.filters.is_negative != 1
    }
  }, [_vm._v("Dương")])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-top",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.statuses), function(status, index) {
    return _c('a', {
      key: index,
      staticClass: "cursor-pointer padding-all",
      class: [{
        'active-status': status.value === _vm.filters[status.key]
      }, status.class],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setFilterStatus(status.key, status.value)
        }
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "inline-filters"
    },
    slot: "inline-filters"
  }, [(_vm.selectedRows.length > 0) ? _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.is_payment < 0),
      expression: "filters.is_payment < 0"
    }],
    staticClass: "margin-right",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleActions
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("\n            Hành động "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 0 ? false : true,
      "command": "confirmAll"
    }
  }, [_vm._v("Duyệt tất\n              cả")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 0 ? false : true,
      "command": "deleteAll"
    }
  }, [_vm._v("Xóa tất\n              cả")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 1 ? false : true,
      "command": "paymentAll"
    }
  }, [_vm._v("Thanh toán tất\n              cả")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.filters.is_confirm == 1 ? false : true,
      "command": "exportAll"
    }
  }, [_vm._v("Xuất\n              Excel")])], 1)], 1) : _vm._e(), _vm._v("\n        Tổng tiền cần chuyển: "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.totalMoneyNeedConfirm)))]), _vm._v("   -  \n        Tổng tiền: "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.totalMoney)))])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Xuất bảng kê",
      "visible": _vm.dialogExportZh
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogExportZh = $event
      }
    }
  }, [_c('el-form', {
    ref: "paramsExportZhRef",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.paramsExportZh,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "200px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-radio-group', {
    staticClass: "el-form-item display-block",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.selectedCrossCheckMode),
      callback: function($$v) {
        _vm.selectedCrossCheckMode = $$v
      },
      expression: "selectedCrossCheckMode"
    }
  }, _vm._l((_vm.crossCheckList), function(item) {
    return _c('el-radio-button', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('el-radio-group', {
    staticClass: "el-form-item display-block",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.selectedDateMode),
      callback: function($$v) {
        _vm.selectedDateMode = $$v
      },
      expression: "selectedDateMode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Theo ngày")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("Theo khoảng thời gian")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedDateMode === 1),
      expression: "selectedDateMode === 1"
    }],
    attrs: {
      "label": "Ngày tạo",
      "prop": "createdAt"
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "date",
      "format": "dd-MM-yyyy",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Chọn ngày"
    },
    model: {
      value: (_vm.paramsExportZh.createdAt),
      callback: function($$v) {
        _vm.$set(_vm.paramsExportZh, "createdAt", $$v)
      },
      expression: "paramsExportZh.createdAt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedDateMode === 2),
      expression: "selectedDateMode === 2"
    }],
    attrs: {
      "label": "Ngày tạo",
      "prop": "createdAt"
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "daterange",
      "format": "dd-MM-yyyy",
      "value-format": "yyyy-MM-dd",
      "range-separator": " / ",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    model: {
      value: (_vm.paramsExportZh.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.paramsExportZh, "createdAtRange", $$v)
      },
      expression: "paramsExportZh.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Chọn hãng vận chuyển",
      "prop": "carrierId"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "value": _vm.paramsExportZh.carrierId.map(function (item) { return JSON.stringify(item); }),
      "multiple": "",
      "filterable": "",
      "placeholder": "Chọn cột tương ứng"
    },
    on: {
      "change": _vm.handleChangeCarrier
    }
  }, _vm._l((_vm.carrierZhs), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": JSON.stringify(item)
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.getCrossCheckKindCod || _vm.getCrossCheckKindcompareFee) ? _c('el-form-item', {
    attrs: {
      "label": "Trạng thái"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.paramsExportZh.status),
      callback: function($$v) {
        _vm.$set(_vm.paramsExportZh, "status", $$v)
      },
      expression: "paramsExportZh.status"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "success"
    }
  }, [_vm._v("Hoàn thành")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "unsuccess"
    }
  }, [_vm._v("Chưa hoàn thành")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogExportZh = false
      }
    }
  }, [_vm._v("Hủy bỏ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Tải xuống")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "gs-header"
  }, [_c('h2', [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(page, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": page.route
      }
    }, [_vm._v(_vm._s(page.title))])
  }), _vm._v(" "), (_vm.title) ? _c('el-breadcrumb-item', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa user",
      "breadcrumbs": [{
        title: 'Quản lý user',
        route: {
          name: 'user'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-lg-all"
  }, [_c('el-form', {
    ref: "editUserForm",
    attrs: {
      "model": _vm.localUser,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitUser('editUserForm')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên cửa hàng",
      "prop": "shop_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên cửa hàng"
    },
    model: {
      value: (_vm.localUser.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "shop_name", $$v)
      },
      expression: "localUser.shop_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Họ tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Họ tên"
    },
    model: {
      value: (_vm.localUser.name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "name", $$v)
      },
      expression: "localUser.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số điện thoại",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số điện thoại"
    },
    model: {
      value: (_vm.localUser.phone),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "phone", $$v)
      },
      expression: "localUser.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.localUser.email),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "email", $$v)
      },
      expression: "localUser.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý permissions"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-permission'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.permissionTable,
    attrs: {
      "table-name": _vm.permissionTable,
      "data-source": "permissions",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.permissionTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.permissionTable].current_page - 1) * _vm.dataPaginations[_vm.permissionTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên hiển thị",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.display_name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Mô tả"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.description))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tạo lúc"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.created_at))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deletePermission(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])])], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "gs-menu"
  }, [_c('el-menu', {
    attrs: {
      "background-color": "#324157",
      "text-color": "#ffffff",
      "active-text-color": "#FFD037",
      "router": true,
      "default-active": _vm.$route.path.split('/')[1] || 'dashboard',
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    staticClass: "gs-logo gs-border-none",
    attrs: {
      "index": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/goship-w.png",
      "alt": "1Express Express"
    }
  })])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "dashboard",
      "active": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Bảng điều khiển")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "cross-checks"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cross-check'
      }
    }
  }, [_vm._v("Phiên đối soát")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "invoices"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoice'
      }
    }
  }, [_vm._v("Phiếu\n            chi")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "compares"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'compare'
      }
    }
  }, [_vm._v("Đơn đối soát")])], 1), _vm._v(" "), _c('el-submenu', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Admin")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "users"
    }
  }, [_c('router-link', {
    staticClass: "text-white text-remove-decoration",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user margin-right"
  }), _vm._v("\n              User")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "roles"
    }
  }, [_c('router-link', {
    staticClass: "text-white text-remove-decoration",
    attrs: {
      "to": {
        name: 'role'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog margin-right"
  }), _vm._v("\n              Role")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "permissions"
    }
  }, [_c('router-link', {
    staticClass: "text-white text-remove-decoration",
    attrs: {
      "to": {
        name: 'permission'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs margin-right"
  }), _vm._v(" Permission")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "header-right gs-border-none pull-right padding-lg-right padding-lg-left"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "el-icon-setting icon-header"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue",
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Logout")])]), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePassword()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Đổi\n                  mật khẩu")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-right gs-border-none pull-right padding-lg-right padding-lg-left"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('h3', {
    staticClass: "text-center text-blue remove-margin"
  }, [_vm._v("Thông tin tài khoản")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.name))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.phone))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.email))])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "fa fa-user-circle-o icon-header"
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Đổi mật khẩu",
      "visible": _vm.changePasswordModal
    },
    on: {
      "update:visible": function($event) {
        _vm.changePasswordModal = $event
      }
    }
  }, [_c('el-form', {
    ref: "changePasswordForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.account,
      "label-width": "120px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "label": "Mật khẩu hiện tại",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu hiện tại"
    },
    model: {
      value: (_vm.account.old_password),
      callback: function($$v) {
        _vm.$set(_vm.account, "old_password", $$v)
      },
      expression: "account.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "label": "Mật khẩu mới",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu mới"
    },
    model: {
      value: (_vm.account.password),
      callback: function($$v) {
        _vm.$set(_vm.account, "password", $$v)
      },
      expression: "account.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nhập lại mật khẩu",
      "prop": "password_confirmation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Nhập lại mật khẩu"
    },
    model: {
      value: (_vm.account.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.account, "password_confirmation", $$v)
      },
      expression: "account.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item"
  }, [_c('el-button', {
    staticClass: "width-100",
    attrs: {
      "type": "primary",
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu\n              lại")])], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.localShipment.id) ? _c('div', {
    staticClass: "padding-sm-all padding-lg-bottom"
  }, [_c('el-form', {
    ref: "create-shipment-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localShipment,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin border-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h2', {
    staticClass: "shipment-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Thông tin người nhận")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "receiver.name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localShipment.receiver.name),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.receiver, "name", $$v)
      },
      expression: "localShipment.receiver.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Điện thoại",
      "prop": "receiver.phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Điện thoại"
    },
    model: {
      value: (_vm.localShipment.receiver.phone),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.receiver, "phone", $$v)
      },
      expression: "localShipment.receiver.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Địa chỉ đến",
      "prop": "address_to.street"
    }
  }, [_c('el-input', {
    attrs: {
      "name": "address_to.street",
      "placeholder": "Địa chỉ đến"
    },
    model: {
      value: (_vm.localShipment.address_to.street),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "street", $$v)
      },
      expression: "localShipment.address_to.street"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tỉnh thành",
      "prop": "address_to.city_code"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn tỉnh thành đến"
    },
    on: {
      "change": function($event) {
        return _vm.getDistrictTo(false)
      }
    },
    model: {
      value: (_vm.localShipment.address_to.city_code),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "city_code", $$v)
      },
      expression: "localShipment.address_to.city_code"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quận huyện",
      "prop": "address_to.district_code"
    }
  }, [_c('el-col', {
    staticClass: "margin-sm-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "disabled": _vm.localShipment.address_to && !_vm.localShipment.address_to.city_code,
      "filterable": "",
      "placeholder": "Chọn quận huyện đến"
    },
    on: {
      "change": function($event) {
        return _vm.changeDistrictTo(false)
      }
    },
    model: {
      value: (_vm.localShipment.address_to.district_code),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "district_code", $$v)
      },
      expression: "localShipment.address_to.district_code"
    }
  }, _vm._l((_vm.districtTo), function(district) {
    return _c('el-option', {
      key: district.id,
      attrs: {
        "label": district.name,
        "value": district.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phường xã",
      "prop": "address_to.ward_id"
    }
  }, [_c('el-col', {
    staticClass: "margin-sm-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "disabled": _vm.localShipment.address_to && !_vm.localShipment.address_to.district_code,
      "filterable": "",
      "placeholder": "Phường xã đến"
    },
    model: {
      value: (_vm.localShipment.address_to.ward_id),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "ward_id", $$v)
      },
      expression: "localShipment.address_to.ward_id"
    }
  }, _vm._l((_vm.wardTo), function(ward) {
    return _c('el-option', {
      key: ward.id,
      attrs: {
        "label": ward.name,
        "value": ward.id.toString()
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h2', {
    staticClass: "shipment-block"
  }, [_c('i', {
    staticClass: "fa fa fa-info-circle"
  }), _vm._v(" Thông tin hàng gửi")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tiền thu hộ (COD)",
      "prop": "parcel.cod_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiền thu hộ (COD)"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('parcel.cod_amount')
      },
      "blur": function($event) {
        return _vm.addZero('parcel.cod_amount')
      }
    },
    model: {
      value: (_vm.localShipment.parcel.cod_amount),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.parcel, "cod_amount", $$v)
      },
      expression: "localShipment.parcel.cod_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.parcel.cod_amount)))])])], 2)], 1), _vm._v(" "), (_vm.showUpdateToCarrier) ? _c('el-form-item', {
    attrs: {
      "label": "Cập nhật tiền thu hộ (COD) sang hãng",
      "prop": "update_to_carrier"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.update_to_carrier),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "update_to_carrier", $$v)
      },
      expression: "localShipment.update_to_carrier"
    }
  }, [_vm._v(" Cập nhật tiền thu hộ (COD) sang hãng ")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phí vượt cân",
      "prop": "over_weight_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí vượt cân"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('over_weight_fee')
      },
      "blur": function($event) {
        return _vm.addZero('over_weight_fee')
      }
    },
    model: {
      value: (_vm.localShipment.over_weight_fee),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "over_weight_fee", $$v)
      },
      expression: "localShipment.over_weight_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.over_weight_fee)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phí giao lại",
      "prop": "re_delivery_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí giao lại"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('re_delivery_fee')
      },
      "blur": function($event) {
        return _vm.addZero('re_delivery_fee')
      }
    },
    model: {
      value: (_vm.localShipment.re_delivery_fee),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "re_delivery_fee", $$v)
      },
      expression: "localShipment.re_delivery_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.re_delivery_fee)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phí khác",
      "prop": "update_info_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí cập nhật"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('update_info_fee')
      },
      "blur": function($event) {
        return _vm.addZero('update_info_fee')
      }
    },
    model: {
      value: (_vm.localShipment.update_info_fee),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "update_info_fee", $$v)
      },
      expression: "localShipment.update_info_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.update_info_fee)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Người thanh toán"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isCoin
    },
    model: {
      value: (_vm.localShipment.payer),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "payer", $$v)
      },
      expression: "localShipment.payer"
    }
  }, _vm._l((_vm.shipmentHelpers.payers), function(payer, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(payer))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ghi chú cập nhật",
      "prop": "note_update"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Ghi chú cập nhật"
    },
    model: {
      value: (_vm.localShipment.note_update),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "note_update", $$v)
      },
      expression: "localShipment.note_update"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tình trạng đơn hàng"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.part_delivery || !!_vm.localShipment.is_lost || !!_vm.localShipment.is_error,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.is_return),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "is_return", $$v)
      },
      expression: "localShipment.is_return"
    }
  }, [_vm._v(" Chuyển hoàn ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.is_return || !!_vm.localShipment.is_lost || !!_vm.localShipment.is_error,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.part_delivery),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "part_delivery", $$v)
      },
      expression: "localShipment.part_delivery"
    }
  }, [_vm._v(" Giao một phần ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.is_return || !!_vm.localShipment.part_delivery || !!_vm.localShipment.is_error,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.is_lost),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "is_lost", $$v)
      },
      expression: "localShipment.is_lost"
    }
  }, [_vm._v(" Thất lạc hàng ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.is_return || !!_vm.localShipment.part_delivery || !!_vm.localShipment.is_lost,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.is_error),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "is_error", $$v)
      },
      expression: "localShipment.is_error"
    }
  }, [_vm._v(" Đơn gửi sang hãng lỗi ")])], 1)], 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa phiếu chi",
      "breadcrumbs": [{
        title: 'Quản lý phiếu chi',
        route: {
          name: 'invoice'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all margin-top"
  }, [_c('el-form', {
    ref: "edit-invoice-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localInvoice,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Tìm kiếm người nhận",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên, sđt...",
      "remote-method": _vm.selectReceiver,
      "loading": _vm.fetchReceiver
    },
    on: {
      "change": _vm.selectSuggettionReceiver
    },
    model: {
      value: (_vm.suggettionReceiver),
      callback: function($$v) {
        _vm.suggettionReceiver = $$v
      },
      expression: "suggettionReceiver"
    }
  }, _vm._l((_vm.listReceiver), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm vận đơn"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "disabled": !_vm.localInvoice.client_id,
      "placeholder": "Nhập mã,...",
      "remote-method": _vm.selectShipment,
      "loading": _vm.fetchShipment
    },
    on: {
      "change": _vm.selectSuggettionShipment
    },
    model: {
      value: (_vm.suggettionShipment),
      callback: function($$v) {
        _vm.suggettionShipment = $$v
      },
      expression: "suggettionShipment"
    }
  }, _vm._l((_vm.listShipment), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left shipment-code-display"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right shipment-code-display"
    }, [_vm._v(_vm._s(item.code))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lý do",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Lý do"
    },
    model: {
      value: (_vm.localInvoice.description),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "description", $$v)
      },
      expression: "localInvoice.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Loại phiếu",
      "prop": "kind"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Loại phiếu"
    },
    model: {
      value: (_vm.localInvoice.kind),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "kind", $$v)
      },
      expression: "localInvoice.kind"
    }
  }, _vm._l((_vm.invoiceHelpers.kinds), function(item, key, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": key,
        "label": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tổng tiền phải trả cho shop",
      "prop": "total_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng tiền phải trả cho shop"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('total_amount')
      },
      "blur": function($event) {
        return _vm.addZero('total_amount')
      }
    },
    model: {
      value: (_vm.localInvoice.total_amount),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "total_amount", $$v)
      },
      expression: "localInvoice.total_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localInvoice.total_amount)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tiền cộng vào tài khoản shop",
      "prop": "debt"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiền cộng vào tài khoản shop"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('debt')
      },
      "blur": function($event) {
        return _vm.addZero('debt')
      }
    },
    model: {
      value: (_vm.localInvoice.debt),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "debt", $$v)
      },
      expression: "localInvoice.debt"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localInvoice.debt)))])])], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(Object.keys(_vm.suggettionReceiver).length) ? _c('h3', [_vm._v("Thông tin người nhận")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.suggettionReceiver).length) ? _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.name) + "    "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.phone) + "    "), _c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.email))]) : _vm._e(), _vm._v(" "), (_vm.shipmentAdded.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.shipmentAdded
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 1353483373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người nhận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.phone))])]
      }
    }], null, false, 1336654758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người gửi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.phone))])]
      }
    }], null, false, 438074374)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.id)))])]
      }
    }], null, false, 2465153771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payer_txt))])]
      }
    }], null, false, 52296414)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Xóa"
          }
        }, [_c('a', {
          staticClass: "text-red padding-all display-inline-block cursor-pointer",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeShipment(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])])]
      }
    }], null, false, 1101567570)
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa role",
      "breadcrumbs": [{
        title: 'Quản lý role',
        route: {
          name: 'role'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "createRoleForm",
    attrs: {
      "model": _vm.localRole,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRole('createRoleForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localRole.name),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "name", $$v)
      },
      expression: "localRole.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên hiển thị"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên hiển thị"
    },
    model: {
      value: (_vm.localRole.display_name),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "display_name", $$v)
      },
      expression: "localRole.display_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localRole.description),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "description", $$v)
      },
      expression: "localRole.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm user"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên...",
      "remote-method": _vm.selectAdmin,
      "loading": _vm.fetchAdmin
    },
    on: {
      "change": _vm.selectSuggettionAdmin
    },
    model: {
      value: (_vm.suggettionAdmin),
      callback: function($$v) {
        _vm.suggettionAdmin = $$v
      },
      expression: "suggettionAdmin"
    }
  }, _vm._l((_vm.listAdmins), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Danh sách users"
    }
  }, _vm._l((_vm.selectedAdmins), function(admin) {
    return _c('el-tag', {
      key: admin.id,
      staticClass: "margin-sm-right",
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.removeAdmin(admin)
        }
      }
    }, [_vm._v("\n          " + _vm._s(admin.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Permissions"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20,
      "offset": 2
    }
  }, [_c('ul', _vm._l((_vm.permissions), function(gpermission, key, index) {
    return _c('li', {
      key: key
    }, [_c('p', {
      staticClass: "text-blue text-bold"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('ul', {
      staticClass: "permission-subtree"
    }, _vm._l((gpermission), function(permission) {
      return (_vm.fetchData) ? _c('li', {
        key: key
      }, [_c('el-checkbox', {
        attrs: {
          "checked": _vm.checkIsExist(permission)
        },
        on: {
          "change": function($event) {
            return _vm.selectPermission($event, permission)
          }
        }
      }, [_vm._v(_vm._s(permission.display_name))])], 1) : _vm._e()
    }), 0)])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý role"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'new-role'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.roleTable,
    attrs: {
      "table-name": _vm.roleTable,
      "data-source": "roles",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.roleTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.roleTable].current_page -
                1) * _vm.dataPaginations[_vm.roleTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên hiển thị",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.display_name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Mô tả"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.description))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tạo lúc"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.created_at))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.detailRole(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search"
              })])]), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-role',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])], 1), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteRole(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])])], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ("Chi tiết role: " + (_vm.role.name) + "(" + (_vm.role.display_name) + ")"),
      "visible": _vm.detailModal
    },
    on: {
      "update:visible": function($event) {
        _vm.detailModal = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "text-center text-gray"
  }, [_vm._v("Danh sách admin")]), _vm._v(" "), (_vm.role.users) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.role.users.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": " Tên"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "text-center text-gray"
  }, [_vm._v("Danh sách permission")]), _vm._v(" "), (_vm.role.permissions) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.role.permissions.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": " Tên"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('div', {
    staticClass: "goship-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(593),
      "width": "200",
      "alt": "1Express"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Nền tảng giao hàng dành cho thương mại điện tử")])]), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Đăng nhập")]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.login,
      "label-width": "120px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.login.username),
      callback: function($$v) {
        _vm.$set(_vm.login, "username", $$v)
      },
      expression: "login.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu"
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item"
  }, [_c('el-button', {
    staticClass: "width-100",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitting,
      "native-type": "submit"
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Đăng nhập")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý đối soát"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.isOpenDialogCompare = true
      }
    }
  }, [_vm._v("Thêm mới đối soát")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.crossCheckTable,
    attrs: {
      "table-name": _vm.crossCheckTable,
      "data-source": "cross-checks",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.crossCheckTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.crossCheckTable].current_page - 1) *
                  _vm.dataPaginations[_vm.crossCheckTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.id) ? _c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [_c('p', [_c('span', [_vm._v("Ngày đối soát:")]), _vm._v(" " + _vm._s(scope.row.created_at))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Kiểu đối soát:")]), _vm._v(" "), _c('el-tag', {
                attrs: {
                  "size": "small",
                  "type": _vm.kindStatus(scope.row.kind)
                }
              }, [_vm._v(_vm._s(scope.row.kind_txt))])], 1)])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Ghi chú"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [(scope.row.note) ? _c('p', [_vm._v(_vm._s(scope.row.note))]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đơn Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [_c('p', [_c('span', [_vm._v("Thành công:")]), _vm._v(" "), _c('span', {
                staticClass: "text-green"
              }, [_vm._v(_vm._s(scope.row.num_compare_success))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Lỗi:")]), _vm._v(" "), _c('span', {
                staticClass: "text-orange"
              }, [_vm._v(_vm._s(scope.row.num_compare_error))])])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tổng COD thu"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [_c('p', [_c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_carrier)))])])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Trạng Thái"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', [_c('span', {
                class: _vm.compareStatuses[scope.row.status]
              }, [_vm._v(_vm._s(scope.row.status_txt))])])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "110",
            "label": "Thao Tác",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết đối soát"
                }
              }, [_c('router-link', {
                staticClass: "text-grey padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'listting-compare',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-view"
              })])], 1), _vm._v(" "), (!scope.row.status) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xác nhận đối soát"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-check"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.confirmApplyCompare(scope.row)
                  }
                }
              })], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xuất bảng kê"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-download"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.exportExcelComapre(scope.row)
                  }
                }
              })], 1), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa ghi chú đối soát"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.editNoteCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-edit"
              })])], 1), _vm._v(" "), (!scope.row.status) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Hủy đối soát"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.removeCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-remove text-red"
              })])], 1) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": "/",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "size": "small",
      "filterable": "",
      "clearable": "",
      "placeholder": "Kiểu đối soát"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.kind),
      callback: function($$v) {
        _vm.$set(_vm.filters, "kind", $$v)
      },
      expression: "filters.kind"
    }
  }, _vm._l((_vm.crossChecksHelpers.kinds), function(kindName, kindKey) {
    return _c('el-option', {
      key: kindKey,
      attrs: {
        "label": kindName,
        "value": kindKey
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.crossChecksHelpers.statuses) ? _c('el-radio-group', {
    staticClass: "status-listting",
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_vm._l((_vm.crossChecksHelpers.statuses), function(status, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                " + _vm._s(status) + "\n              ")])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_c('span', [_vm._v("Tất cả")])])], 2) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isOpenDialogCompare,
      "title": "Tạo đối soát",
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isOpenDialogCompare = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.isOpenDialogCompare = false
            }
          }
        }, [_vm._v("Thoát")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.importNewCompare()
            }
          }
        }, [_vm._v("\n          Tạo mới\n        ")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "padding-sm-bottom"
  }, [_c('span', [_vm._v("Bạn chắc chắn muốn tạo mới đối soát loại nào")]), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.kindCrossCheck),
      callback: function($$v) {
        _vm.kindCrossCheck = $$v
      },
      expression: "kindCrossCheck"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Cod")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("Phí")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("Phí lần 2")])], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "margin-bottom margin-top"
  }, [_vm._v("Ghi chú")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Nhập ghi chú",
      "maxlength": "255",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.note),
      callback: function($$v) {
        _vm.note = $$v
      },
      expression: "note"
    }
  }), _vm._v(" "), (_vm.kindCrossCheck !== 1) ? [_c('h4', {
    staticClass: "margin-bottom margin-top"
  }, [_vm._v("Tháng đối soát")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "month",
      "placeholder": "Chọn tháng"
    },
    model: {
      value: (_vm.monthRangeVal),
      callback: function($$v) {
        _vm.monthRangeVal = $$v
      },
      expression: "monthRangeVal"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isOpenDialogEditNote,
      "title": "Sửa ghi chú đối soát",
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isOpenDialogEditNote = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.isOpenDialogEditNote = false
            }
          }
        }, [_vm._v("Thoát")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handlerEditNote()
            }
          }
        }, [_vm._v("\n          Xác nhận\n        ")])], 1)]
      },
      proxy: true
    }])
  }, [_c('h4', {
    staticClass: "margin-bottom margin-top"
  }, [_vm._v("Ghi chú")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Nhập ghi chú",
      "maxlength": "255",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.noteEdit),
      callback: function($$v) {
        _vm.noteEdit = $$v
      },
      expression: "noteEdit"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10em"
    }
  }, [_c('i', {
    staticClass: "fa fa-bug",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 403")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "4em"
    }
  }, [_vm._v("PAGE FORBIDDEN")]), _vm._v(" "), _c('h1', [_vm._v("Bạn không có quyền thực hiện tác vụ này!")])])])
}]}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý affiliate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.affiliateTable,
    attrs: {
      "table-name": _vm.affiliateTable,
      "data-source": "affiliates",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.affiliateTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.affiliateTable].current_page - 1) * _vm.dataPaginations[_vm.affiliateTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Email",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.email))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Số khách",
            "width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-blue text-right"
              }, [_vm._v(_vm._s(scope.row.total_invite) + " khách")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Số đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-blue text-right"
              }, [_vm._v(_vm._s(scope.row.total_shipment) + " đơn")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tiền hoa hồng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-red text-right"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_money)) + " ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tiền đã thanh toán",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-red text-right"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.money_paymented)) + " ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Ngày tạo",
            "width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.created_at))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.detailRole(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search"
              })])])], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới role",
      "breadcrumbs": [{
        title: 'Quản lý role',
        route: {
          name: 'role'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "createRoleForm",
    attrs: {
      "model": _vm.localRole,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRole('createRoleForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localRole.name),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "name", $$v)
      },
      expression: "localRole.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên hiển thị"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên hiển thị"
    },
    model: {
      value: (_vm.localRole.display_name),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "display_name", $$v)
      },
      expression: "localRole.display_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localRole.description),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "description", $$v)
      },
      expression: "localRole.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm user"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên...",
      "remote-method": _vm.selectAdmin,
      "loading": _vm.fetchAdmin
    },
    on: {
      "change": _vm.selectSuggettionAdmin
    },
    model: {
      value: (_vm.suggettionAdmin),
      callback: function($$v) {
        _vm.suggettionAdmin = $$v
      },
      expression: "suggettionAdmin"
    }
  }, _vm._l((_vm.listAdmins), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Danh sách users"
    }
  }, _vm._l((_vm.selectedAdmins), function(admin) {
    return _c('el-tag', {
      key: admin.id,
      staticClass: "margin-sm-right",
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.removeAdmin(admin)
        }
      }
    }, [_vm._v("\n          " + _vm._s(admin.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Permissions"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20,
      "offset": 2
    }
  }, [_c('ul', _vm._l((_vm.permissions), function(gpermission, key, index) {
    return _c('li', {
      key: key
    }, [_c('p', {
      staticClass: "text-blue text-bold"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('ul', {
      staticClass: "permission-subtree"
    }, _vm._l((gpermission), function(permission) {
      return _c('li', {
        key: key
      }, [_c('el-checkbox', {
        attrs: {
          "checked": _vm.checkIsExist(permission)
        },
        on: {
          "change": function($event) {
            return _vm.selectPermission($event, permission)
          }
        }
      }, [_vm._v(_vm._s(permission.display_name))])], 1)
    }), 0)])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Thêm mới")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới permissions",
      "breadcrumbs": [{
        title: 'Quản lý permissions',
        route: {
          name: 'permission'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "createPermissionForm",
    attrs: {
      "model": _vm.localPermission,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRole('createPermissionForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localPermission.name),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "name", $$v)
      },
      expression: "localPermission.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên hiển thị"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên hiển thị"
    },
    model: {
      value: (_vm.localPermission.display_name),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "display_name", $$v)
      },
      expression: "localPermission.display_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localPermission.description),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "description", $$v)
      },
      expression: "localPermission.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("Chọn tất cả")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "margin-top margin-lg-bottom",
    model: {
      value: (_vm.localPermission.prefix),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "prefix", $$v)
      },
      expression: "localPermission.prefix"
    }
  }, _vm._l((_vm.permissionHelpers.prefixs), function(prefix, key, index) {
    return _c('el-checkbox', {
      key: key,
      attrs: {
        "label": key
      }
    }, [_vm._v(_vm._s(prefix))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Thêm mới")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới user",
      "breadcrumbs": [{
        title: 'Quản lý user',
        route: {
          name: 'user'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-lg-all"
  }, [_c('el-form', {
    ref: "createUserForm",
    attrs: {
      "model": _vm.localUser,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitUser('createUserForm')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên cửa hàng",
      "prop": "shop_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên cửa hàng"
    },
    model: {
      value: (_vm.localUser.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "shop_name", $$v)
      },
      expression: "localUser.shop_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Họ tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Họ tên"
    },
    model: {
      value: (_vm.localUser.name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "name", $$v)
      },
      expression: "localUser.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số điện thoại",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số điện thoại"
    },
    model: {
      value: (_vm.localUser.phone),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "phone", $$v)
      },
      expression: "localUser.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.localUser.email),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "email", $$v)
      },
      expression: "localUser.email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mật khẩu",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu"
    },
    model: {
      value: (_vm.localUser.password),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "password", $$v)
      },
      expression: "localUser.password"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nhập lại mật khẩu",
      "prop": "password_confirmation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Nhập lại mật khẩu"
    },
    model: {
      value: (_vm.localUser.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "password_confirmation", $$v)
      },
      expression: "localUser.password_confirmation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Thêm mới")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Chi tiết đối soát",
      "breadcrumbs": [{
        title: 'Phiên đối soát',
        route: {
          name: 'compare'
        }
      }]
    }
  }, [_c('el-popover', {
    ref: "applyPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.applyPopup),
      callback: function($$v) {
        _vm.applyPopup = $$v
      },
      expression: "applyPopup"
    }
  }, [_c('p', [_vm._v("Bạn xác nhận đối soát này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.applyPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.applyCompareSubmitting,
      "loading": _vm.applyCompareSubmitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.applyCompare.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n          nhận")])], 1)]), _vm._v(" "), _c('el-popover', {
    ref: "removePopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.removePopup),
      callback: function($$v) {
        _vm.removePopup = $$v
      },
      expression: "removePopup"
    }
  }, [_c('p', [_vm._v("Bạn xác nhận hủy đối soát này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.removePopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeCompare.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác nhận")])], 1)]), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:applyPopup",
      arg: "applyPopup"
    }],
    attrs: {
      "size": "small",
      "type": "success",
      "icon": "el-icon-finished"
    },
    on: {
      "click": function($event) {
        _vm.applyPopup = !_vm.applyPopup
      }
    }
  }, [_vm._v("Xác nhận\n      đối\n      soát")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning",
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.verifyCrossCheck
    }
  }, [_vm._v("Duyệt đối\n      soát")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:removePopup",
      arg: "removePopup"
    }],
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-remove"
    },
    on: {
      "click": function($event) {
        _vm.removePopup = !_vm.removePopup
      }
    }
  }, [_vm._v("Hủy đối\n      soát")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.addShipmentModal = !_vm.addShipmentModal
      }
    }
  }, [_vm._v("Thêm vận\n      đơn")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("Xuất\n      excel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-row', {
    staticClass: "padding-all",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-descriptions', {
    staticClass: "margin-top",
    attrs: {
      "title": "Tổng quan",
      "column": 2,
      "border": ""
    }
  }, [_c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-collection-tag"
  }), _vm._v("\n              Đơn thành công\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("number")(_vm.crossChecks.num_compare_success)) + "\n          ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v("\n              Đơn lỗi\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.crossChecks.num_compare_error)))])], 2), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-money"
  }), _vm._v("\n              COD hãng thu\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.cod_carrier)) + "\n          ")], 2) : _vm._e(), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-coin"
  }), _vm._v("\n              COD hãng trả\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.cod_goship)) + "\n          ")], 2) : _vm._e(), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-money"
  }), _vm._v("\n              " + _vm._s(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD) ? 'Tổng phí thu' : 'Tổng phí đối soát lần 1') + "\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.fee_goship)) + "\n          ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-coin"
  }), _vm._v("\n              " + _vm._s(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD) ? 'Tổng phí trả' : 'Tổng phí đối soát') + "\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.fee_carrier)) + "\n          ")], 2)], 1)], 1), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('h3', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("COD trả shop")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "data": _vm.financeReport,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Hãng vận chuyển",
      "prop": "carrier"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng COD",
      "prop": "cod"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tiền phí",
      "prop": "fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tiền phải trả",
      "prop": "total_pay"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.typeofCompare) ? [_c('gs-table', {
    ref: _vm.listtingCompareTable,
    attrs: {
      "cache-data": false,
      "table-name": _vm.listtingCompareTable,
      "data-source": _vm.typeofCompare + this.$route.params.id,
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "50",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.listtingCompareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.listtingCompareTable].current_page - 1) *
                  _vm.dataPaginations[_vm.listtingCompareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                      "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.code))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.invoice) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tiền thu hộ (COD)")]), _vm._v(" "), _c('p', [_vm._v("Tổng phí")]), _vm._v(" "), _c('p', [_vm._v("Đã thu")]), _vm._v(" "), _c('p', [_vm._v("Cần thu")]), _vm._v(" "), _c('p', [_vm._v("Cân nặng")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_amount)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee + scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.amount_for_cross)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_payed_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.last_payed_fee)))]) : _vm._e()]), _vm._v(" "), (scope.row.parcel) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("gam")(_vm.isOverweight(scope))))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông tin tài chính"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [(scope.row.shipment) ? _c('p', [_vm._v("Doanh thu: "), _c('span', {
                staticClass: "pull-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Chi phí: "), _c('span', {
                staticClass: "pull-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee + scope.row.last_total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Lợi nhuận: "), _c('span', {
                staticClass: "pull-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.total_fee - scope.row.last_total_fee)))])]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('a', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.editListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])]), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.can_hard_update && _vm.isCheckUpgrade) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cập nhập thông tin"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.showEditShipment(scope.row.shipment)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.error) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.deleteListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE)) ? _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "50",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.listtingCompareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.listtingCompareTable].current_page - 1) *
                  _vm.dataPaginations[_vm.listtingCompareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                    "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.code))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.invoice_fee) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice_fee.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phí")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát Lần 1"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_total_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Chênh lệch"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.differenceFee(scope.row.last_total_fee, scope.row.total_fee))))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('a', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.editListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])]), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.can_hard_update && _vm.isCheckUpgrade) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cập nhập thông tin"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.showEditShipment(scope.row.shipment)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.error) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.deleteListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE1)) ? _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "50",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.listtingCompareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.listtingCompareTable].current_page - 1) *
                  _vm.dataPaginations[_vm.listtingCompareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                    "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.code))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.invoice) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phí")]), _vm._v(" "), _c('p', [_vm._v("Đã thu")]), _vm._v(" "), _c('p', [_vm._v("Cần thu")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee + scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_payed_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.last_payed_fee)))]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('a', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.editListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])]), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.can_hard_update && _vm.isCheckUpgrade) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cập nhập thông tin"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.showEditShipment(scope.row.shipment)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.error) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.deleteListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1) : _vm._e()]
      }
    }], null, false, 1564173452)
  }, [_c('section', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.compareHelpers.errors && _vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareHelpers.errors), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                • " + _vm._s(error) + " "), _c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id !== index, _obj )
    }, [_vm._v("(" + _vm._s(_vm.countErrorCompare(index)) + ")")])])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_vm._v("\n                • "), _c('span', {
    class: ( _obj = {}, _obj[_vm.listtingComparesError[-1]] = _vm.filters.error_id !== -1, _obj )
  }, [_vm._v("Tất cả")])])], 2) : _vm._e(), _vm._v(" "), (_vm.compareFeeHelpers.errors && _vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE)) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareFeeHelpers.errors), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                • " + _vm._s(error) + " "), _c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id !== index, _obj )
    }, [_vm._v("(" + _vm._s(_vm.countErrorCompare(index)) + ")")])])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_vm._v("\n                • "), _c('span', {
    class: ( _obj$1 = {}, _obj$1[_vm.listtingComparesError[-1]] = _vm.filters.error_id !== -1, _obj$1 )
  }, [_vm._v("Tất cả")])])], 2) : _vm._e(), _vm._v(" "), (_vm.compareHelpers.errors_fee_1 && _vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE1)) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareHelpers.errors_fee_1), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                • " + _vm._s(error) + " "), _c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id !== index, _obj )
    }, [_vm._v("(" + _vm._s(_vm.countErrorCompare(index)) + ")")])])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_vm._v("\n                • "), _c('span', {
    class: ( _obj$2 = {}, _obj$2[_vm.listtingComparesError[-1]] = _vm.filters.error_id !== -1, _obj$2 )
  }, [_vm._v("Tất cả")])])], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    },
    attrs: {
      "slot": "inline-filters"
    },
    slot: "inline-filters"
  }, [_c('el-popover', {
    ref: "removeErrorShipmentPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.removeErrorShipmentPopup),
      callback: function($$v) {
        _vm.removeErrorShipmentPopup = $$v
      },
      expression: "removeErrorShipmentPopup"
    }
  }, [(_vm.filters.error_id) ? _c('p', [_vm._v("Xoá tất cả vận đơn: "), _c('code', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.getErrorText()))]), _vm._v(" ?\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.removeErrorShipmentPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.removeErrorShipmentSubmitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeAllErrorShipment.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n              nhận")])], 1)]), _vm._v(" "), (_vm.filters.error_id != -1) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:removeErrorShipmentPopup",
      arg: "removeErrorShipmentPopup"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.removeErrorShipmentPopup = !_vm.removeErrorShipmentPopup
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Xoá tất cả")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.countErrorCompare(1) === 0
    },
    on: {
      "click": _vm.resyncCode
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đồng bộ\n          code")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id != -1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.exportExcelCompare
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Xuất excel\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 3) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.countErrorCompare(3) === 0
    },
    on: {
      "click": _vm.resyncCode
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đồng bộ đối soát\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 6) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.countErrorCompare(6) === 0
    },
    on: {
      "click": _vm.updateWeight
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đồng bộ\n          cân")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 5 || _vm.filters.error_id == 7) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.filters.error_id == 5 ? _vm.countErrorCompare(5) === 0 : _vm.countErrorCompare(7) === 0
    },
    on: {
      "click": _vm.updateFeeCarrier
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Cập nhật theo phí hãng\n        ")]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Sửa đối soát:: ' + _vm.currentListtingCompare.code,
      "visible": _vm.editModal
    },
    on: {
      "update:visible": function($event) {
        _vm.editModal = $event
      }
    }
  }, [_c('el-form', {
    ref: "editListtingCompare",
    attrs: {
      "model": _vm.currentListtingCompare,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitEditCompare('editListtingCompare')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tiền thu hộ (COD)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.currentListtingCompare.cod_amount),
      callback: function($$v) {
        _vm.$set(_vm.currentListtingCompare, "cod_amount", $$v)
      },
      expression: "currentListtingCompare.cod_amount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tổng phí"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng phí"
    },
    model: {
      value: (_vm.currentListtingCompare.total_fee),
      callback: function($$v) {
        _vm.$set(_vm.currentListtingCompare, "total_fee", $$v)
      },
      expression: "currentListtingCompare.total_fee"
    }
  })], 1)], 1), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cân nặng"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cân nặng"
    },
    model: {
      value: (_vm.currentListtingCompare.weight),
      callback: function($$v) {
        _vm.$set(_vm.currentListtingCompare, "weight", $$v)
      },
      expression: "currentListtingCompare.weight"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disable": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 2), _vm._v(" "), _c('dialog-add-shipment-to-compare', {
    attrs: {
      "type": _vm.crossChecks.kind
    },
    on: {
      "success": _vm.reloadDataListCompare
    },
    model: {
      value: (_vm.addShipmentModal),
      callback: function($$v) {
        _vm.addShipmentModal = $$v
      },
      expression: "addShipmentModal"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ("Cập nhật thông tin vận đơn: " + (_vm.localShipment.code)),
      "visible": _vm.editShipmentModal,
      "width": "100%"
    },
    on: {
      "close": _vm.closeModalShipment,
      "update:visible": function($event) {
        _vm.editShipmentModal = $event
      }
    }
  }, [(_vm.localShipment.id) ? _c('upgrade-shipment', {
    attrs: {
      "shipment-id": _vm.localShipment.id
    },
    on: {
      "edit-shipment-success": _vm.editShipmentSuccess
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": ("Chi tiết phiếu thu: <span class='shipment-code-display click-copy'>" + (_vm.receipt.id) + "</span>"),
      "breadcrumbs": [{
        title: 'Quản lý phiếu thu',
        route: {
          name: 'receipt'
        }
      }]
    }
  }, [_c('el-popover', {
    ref: "confirmPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.confirmPopup),
      callback: function($$v) {
        _vm.confirmPopup = $$v
      },
      expression: "confirmPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn xác nhận phiếu thu này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('button', {
    staticClass: "ui red mini basic button",
    on: {
      "click": function($event) {
        _vm.confirmPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('button', {
    staticClass: "ui green mini basic button",
    attrs: {
      "disabled": !_vm.confirmPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmReceipt.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n          nhận")])])]), _vm._v(" "), (_vm.receipt.client_id && _vm.receipt.confirmer_id) ? _c('a', {
    staticClass: "ui mini violet button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Cần\n      truy thu")]) : _vm._e(), _vm._v(" "), (_vm.receipt.client_id && _vm.receipt.confirmer_id) ? _c('a', {
    staticClass: "ui mini violet button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnedHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Đã truy thu")]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:confirmPopup",
      arg: "confirmPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.receipt.confirmer_id),
      expression: "!receipt.confirmer_id"
    }],
    staticClass: "ui mini green button"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n      Xác nhận")])], 1), _vm._v(" "), (_vm.receipt.id) ? _c('div', {
    staticClass: "padding-sm-all margin-top padding-lg-bottom"
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 12
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Người tạo")]), _vm._v(" "), _c('p', [_vm._v("Họ tên: " + _vm._s(_vm.receipt.creator.data.name))]), _vm._v(" "), _c('p', [_vm._v("Tên đăng nhập: " + _vm._s(_vm.receipt.creator.data.email))]), _vm._v(" "), _c('p', [_vm._v("Ngày tạo: " + _vm._s(_vm.receipt.created_at))])]), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 12
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Xác nhận")]), _vm._v(" "), _c('p', [_vm._v("Họ tên: " + _vm._s(_vm.receipt.confirmer.data.name))]), _vm._v(" "), _c('p', [_vm._v("Tên đăng nhập: " + _vm._s(_vm.receipt.confirmer.data.email))]), _vm._v(" "), _c('p', [_vm._v("Ngày tạo: " + _vm._s(_vm.receipt.confirmed_at))])]), _vm._v(" "), (_vm.receipt.client_id) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "padding-lg-left padding-lg-all",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n          Khách hàng: " + _vm._s(_vm.receipt.client.data.name) + " | " + _vm._s(_vm.receipt.client.data.email) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "padding-lg-all bg-grey margin-top text-white",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n        Lý do: " + _vm._s(_vm.receipt.description) + "\n      ")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Danh sách vận đơn")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.receipt.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_for_cross)))])]
      }
    }], null, false, 3320493449)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]
      }
    }], null, false, 3846853147)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí khác"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.return_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Vượt cân: "), _c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.overweight_fee)))])])]
      }
    }], null, false, 26442921)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Cân nặng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Cân nặng: "), _c('span', {
          staticClass: "text-orange click-copy"
        }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.parcel.data.weight)))])]), _vm._v(" "), _c('p', [_vm._v("Cân thực tế: "), _c('span', {
          staticClass: "text-orange click-copy"
        }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.parcel.data.real_weight)))])])]
      }
    }], null, false, 642939648)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Trạng thái",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.shipmentStatuses[scope.row.status]
        }, [_vm._v(_vm._s(scope.row.status_txt))])]
      }
    }], null, false, 3519113547)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng tiền trả shop"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_return_shop)))])]
      }
    }], null, false, 4103530914)
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "padding-lg-right",
    attrs: {
      "span": 12,
      "offset": 12
    }
  }, [_c('h3', [_vm._v(" ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tổng tiền "), _c('sup', [_vm._v("(1)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.receipt.amount)))])]), _vm._v(" "), (_vm.receipt.money_return) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tiền nợ "), _c('sup', [_vm._v("(2)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.receipt.money_return)))])]) : _vm._e(), _vm._v(" "), (_vm.receipt.money_return) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tổng tiền thực trả "), _c('sup', [_vm._v("(1) - (2)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.receipt.real_amount)))])]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cần truy thu công nợ",
      "visible": _vm.dialogReturner
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogReturner = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listReturn,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.detailInvoiceBlankTab(scope.row.id)
            }
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Số nợ"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("number")(scope.row.real_amount)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "ui mini violet button",
          attrs: {
            "type": "button",
            "disabled": _vm.pendingReturn
          },
          on: {
            "click": function($event) {
              return _vm.returnInvoice(scope.row)
            }
          }
        }, [_vm._v("Truy thu")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Đã truy thu công nợ",
      "visible": _vm.dialogReturned
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogReturned = $event
      }
    }
  }, [(_vm.receipt.returns) ? _c('el-table', {
    attrs: {
      "data": _vm.receipt.returns.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.detailInvoiceBlankTab(scope.row.invoice_id)
            }
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.invoice_id))])])]
      }
    }], null, false, 2091597780)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Số tiền đã thu"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_amount)))])]
      }
    }], null, false, 2899389486)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người truy thu"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.returner) ? _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(scope.row.returner.data.name) + " |\n            " + _vm._s(scope.row.returner.data.email))]) : _vm._e()]
      }
    }], null, false, 524308329)
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Danh sách đơn đối soát",
      "breadcrumbs": [{
        title: 'Quản lý đối soát',
        route: {
          name: 'compare'
        }
      }]
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("Xuất excel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.compareTable,
    attrs: {
      "table-name": _vm.compareTable,
      "data-source": "compares",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.compareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.compareTable].current_page - 1) * _vm.dataPaginations[_vm.compareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                    "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.code))])]) : _vm._e(), _vm._v(" "), (scope.row.cross_check) ? _c('p', [_c('span', [_vm._v("Mã lịch sử đối soát: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.cross_check.data.id))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi cod: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice.data.id))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi phí: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice_fee.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tiền thu hộ (COD)")]), _vm._v(" "), _c('p', [_vm._v("Tổng phí")]), _vm._v(" "), _c('p', [_vm._v("Khuyến mãi")]), _vm._v(" "), _c('p', [_vm._v("Cân nặng")]), _vm._v(" "), _c('p', [_vm._v("Cân quy đổi")]), _vm._v(" "), _c('p', [_vm._v("Tạm thu")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-red"
              }, [_c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_amount)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v("0 đ")])]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.convertion_weight)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.payed_fee)))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-red"
              }, [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.amount_for_cross)) + "\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.discount)))]) : _vm._e()]), _vm._v(" "), (scope.row.parcel) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.parcel.data.weight)))]) : _vm._e(), _vm._v(" "), (scope.row.parcel) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.parcel.data.convertion_weight)))]) : _vm._e(), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông tin tài chính"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-red"
              }, [(scope.row.shipment) ? _c('p', [_vm._v("Revenue: "), _c('span', {
                staticClass: "pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Cost: "), _c('span', {
                staticClass: "pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Profit: "), _c('span', {
                staticClass: "pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.total_fee)))])]) : _vm._e()])]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.compareHelpers.statuses) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesStatusBg[_vm.filters.status]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_vm._l((_vm.compareHelpers.statuses), function(status, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_c('el-tooltip', {
      staticClass: "display-inline",
      attrs: {
        "placement": "top",
        "content": "Trạng thái"
      }
    }, [_c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesStatus[index]] = _vm.filters.status != index, _obj )
    }, [_vm._v(_vm._s(status))])])], 1)
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_c('el-tooltip', {
    staticClass: "display-inline",
    attrs: {
      "placement": "top",
      "content": "Trạng thái"
    }
  }, [_c('span', {
    class: ( _obj = {}, _obj[_vm.listtingComparesStatus[-1]] = _vm.filters.status != -1, _obj )
  }, [_vm._v("Tất cả")])])], 1)], 2) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.compareHelpers.errors) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareHelpers.errors), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_c('el-tooltip', {
      staticClass: "display-inline",
      attrs: {
        "placement": "top",
        "content": "Vận đơn lỗi"
      }
    }, [_c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id != index, _obj )
    }, [_vm._v(_vm._s(error))])])], 1)
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_c('el-tooltip', {
    staticClass: "display-inline",
    attrs: {
      "placement": "top",
      "content": "Vận đơn lỗi"
    }
  }, [_c('span', {
    class: ( _obj$1 = {}, _obj$1[_vm.listtingComparesError[-1]] = _vm.filters.error_id != -1, _obj$1 )
  }, [_vm._v("Tất cả")])])], 1)], 2) : _vm._e()], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý user"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'new-user'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.clientTable,
    attrs: {
      "table-name": _vm.clientTable,
      "data-source": "clients",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.clientTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.clientTable].current_page - 1) * _vm.dataPaginations[_vm.clientTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tài khoản",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.id) ? _c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Thời gian đăng nhập cuối cùng"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.updated_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [(scope.row.name) ? _c('p', [_c('i', {
                staticClass: "fa fa-user",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.name))])]) : _vm._e(), _vm._v(" "), (scope.row.phone) ? _c('p', [_c('i', {
                staticClass: "fa fa-phone",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.email) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.email))])]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Trạng thái"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-center"
              }, [_c('el-tag', {
                attrs: {
                  "type": scope.row.is_online ? 'success' : 'gray'
                }
              }, [_vm._v(_vm._s(scope.row.is_online ? 'Online' :
                'Offline'))])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(scope.row.is_online) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Offline"
                }
              }, [_c('a', {
                staticClass: "text-grey padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.toggleOffline(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa fa-wifi"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.is_online) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Online"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.toggleOnline(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa fa-wifi"
              })])]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteUser(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Phân quyền"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.shieldUser(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-shield"
              })])])], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Phân quyền cho user :: ' + _vm.currentUser.name,
      "visible": _vm.shieldModal
    },
    on: {
      "update:visible": function($event) {
        _vm.shieldModal = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Quyền"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "Chọn quyền"
    },
    model: {
      value: (_vm.admin.roles),
      callback: function($$v) {
        _vm.$set(_vm.admin, "roles", $$v)
      },
      expression: "admin.roles"
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('el-option', {
      key: role.id,
      attrs: {
        "label": role.name,
        "value": role.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addRole
    }
  }, [_vm._v("Lưu lại ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "loading",
    attrs: {
      "element-loading-text": "Đang tải dữ liệu vui lòng đợi..."
    }
  }), _vm._v(" "), (_vm.isLogged) ? _c('div', [_c('gs-menu')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), (_vm.devTool) ? _c('button', {
    staticClass: "ui icon mini button red dev-tool",
    on: {
      "click": function($event) {
        _vm.dialogDebug = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bug"
  })]) : _vm._e(), _vm._v(" "), (_vm.devTool) ? _c('div', {
    staticClass: "debug"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Debug queries",
      "visible": _vm.dialogDebug,
      "fullscreen": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDebug = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.debugQuery,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('table', {
          staticClass: "table"
        }, [_c('thead', [_c('tr', {
          staticClass: "debug-text"
        }, [_c('th', [_vm._v("Query")]), _vm._v(" "), _c('th', [_vm._v("File")]), _vm._v(" "), _c('th', [_vm._v("Execute time")])])]), _vm._v(" "), _c('tbody', _vm._l((props.row.statements), function(statement) {
          return _c('tr', {
            key: statement.stmt_id,
            staticClass: "debug-text cursor-pointer",
            on: {
              "click": function($event) {
                return _vm.showDebugDialog(statement)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(statement.sql))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(statement.stmt_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(statement.duration_str))])])
        }), 0)])]
      }
    }], null, false, 3505425340)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60",
      "label": "Method",
      "prop": "method",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Url",
      "prop": "uri",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "File",
      "prop": "file",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Middleware",
      "prop": "middleware",
      "width": "200",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60",
      "label": "Memory",
      "prop": "memory",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": "Execute time",
      "prop": "accumulated_duration_str",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60",
      "label": "Queries",
      "prop": "nb_statements",
      "class-name": "debug-text"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Debug query params",
      "visible": _vm.dialogDebugQuery
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDebugQuery = $event
      }
    }
  }, [_c('pre', {
    staticClass: "debug-text"
  }, [_vm._v(_vm._s(_vm.dialogData))])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Cấu hình lương cho saller",
      "breadcrumbs": [{
        title: 'Quản lý saler',
        route: {
          name: 'saler'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "config-saler-salary",
    attrs: {
      "model": _vm.localConfig,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit()
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "config.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiConfig), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiConfig[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'number', $$v)
        },
        expression: "kpiConfig[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiConfig[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiConfig[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiConfig[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiConfig[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiConfig[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'money', $$v)
        },
        expression: "kpiConfig[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiConfig[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiConfig[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'bonus', $$v)
        },
        expression: "kpiConfig[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiConfig[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiConfig[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'month_plus', $$v)
        },
        expression: "kpiConfig[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiConfig[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiConfig, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiConfig)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "config.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.config.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.config, "salary_accumulation", $$v)
      },
      expression: "localConfig.config.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.config.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "config.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.config.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.config, "salary_by_customer", $$v)
      },
      expression: "localConfig.config.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.config.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "config.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.config.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.config, "month_accumulation", $$v)
      },
      expression: "localConfig.config.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.config.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")]), _vm._v(" "), _c('button', {
    staticClass: "ui red basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "type": "button"
    },
    on: {
      "click": _vm.resetConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đặt lại cấu hình mặc định")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": ("Yêu cầu thanh toán: " + _vm.clientName)
    }
  }), _vm._v(" "), _c('gs-table', {
    ref: _vm.requestPaymentTable,
    attrs: {
      "table-name": _vm.requestPaymentTable,
      "data-source": "request-payments",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n      >\n        "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.requestPaymentTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.requestPaymentTable].current_page - 1) * _vm.dataPaginations[_vm.requestPaymentTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.client) ? _c('p', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Số tiền"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-red text-right"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.money)) + " ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Ngày tạo"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.created_at))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Trạng thái",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                class: {
                  'text-green': scope.row.status
                }
              }, [_vm._v(_vm._s(scope.row.status_txt))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Ghi chú",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.note))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Ngân hàng",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.bank_info))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(!scope.row.status) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Duyệt thanh toán"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.confirmPayment(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-check"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 667 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[430]);


// WEBPACK FOOTER //
// static/js/app.c3781bea74c806a40c99.js